/**-----------------------------------------------------------------------------------------
* Copyright © 2023 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the package root for more information
*-------------------------------------------------------------------------------------------*/
"use client";
import * as o from "react";
import * as n from "prop-types";
import { classNames as P, canUseDOM as J, createPropsContext as Dt, withIdHOC as yt, withPropsContext as St, Keys as C, validatePackage as Pt, setScrollbarWidth as fs, getActiveElement as ot, AsyncFocusBlur as we, kendoThemeMaps as mt, noop as Rs, IconWrap as ei } from "@progress/kendo-react-common";
import { getDate as x, cloneDate as v, addDecades as it, addCenturies as qt, firstDecadeOfCentury as oe, lastDecadeOfCentury as He, firstYearOfDecade as st, durationInCenturies as se, addYears as nt, lastYearOfDecade as Ae, durationInDecades as ie, addDays as Wt, addWeeks as gs, addMonths as $, firstDayOfMonth as fe, lastDayOfMonth as Ot, dayOfWeek as si, durationInMonths as ne, firstMonthOfYear as Ns, lastMonthOfYear as _s, createDate as le, durationInYears as ae, weekInYear as ii, isEqualDate as wt, isEqual as ht } from "@progress/kendo-date-math";
import { registerForIntl as ft, provideIntlService as ct, registerForLocalization as at, provideLocalizationService as q } from "@progress/kendo-react-intl";
import { Button as N, ButtonGroup as ni } from "@progress/kendo-react-buttons";
import { caretAltUpIcon as ai, caretAltDownIcon as ri, xIcon as oi, calendarIcon as Fs, clockIcon as li, chevronRightIcon as vs, chevronLeftIcon as ws, arrowsSwapIcon as hi } from "@progress/kendo-svg-icons";
import { FloatingLabel as Ls } from "@progress/kendo-react-labels";
import { Popup as be } from "@progress/kendo-react-popup";
import { ActionSheet as ci, ActionSheetHeader as ui, ActionSheetFooter as di, ActionSheetContent as ke } from "@progress/kendo-react-layout";
const Rt = {
  name: "@progress/kendo-react-dateinputs",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702376758,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/components/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, pi = (s, t, e) => [
  ...s.slice(0, t + 1),
  ...s.slice(t + 1).map((i) => i + e)
];
class mi {
  constructor(t = 0, e, i) {
    this.total = t, this.rowHeight = e, this.detailRowHeight = i, this.offsets = [], this.heights = [];
    let a = 0;
    for (let r = 0; r < t; r++)
      this.offsets.push(a), a += e, this.heights.push(e);
  }
  height(t) {
    return this.heights[t];
  }
  expandDetail(t) {
    this.height(t) === this.rowHeight && this.updateRowHeight(t, this.detailRowHeight);
  }
  collapseDetail(t) {
    this.height(t) > this.rowHeight && this.updateRowHeight(t, this.detailRowHeight * -1);
  }
  index(t) {
    for (let e = 0; e < this.offsets.length; e++) {
      if (t === this.offsets[e])
        return e;
      if (t < this.offsets[e])
        return e - 1;
    }
    return this.total - 1;
  }
  offset(t) {
    return this.offsets[t];
  }
  totalHeight() {
    return this.heights.reduce((t, e) => t + e, 0);
  }
  updateRowHeight(t, e) {
    this.heights[t] += e, this.offsets = pi(this.offsets, t, e);
  }
}
const re = (s) => Math.max(s, 0);
class Me {
  constructor(t) {
    this.offset = t;
  }
}
class Te {
  constructor(t) {
    this.skip = t;
  }
}
class fi {
  constructor(t, e) {
    this.onScrollAction = t, this.onPageAction = e, this.direction = "vertical", this.firstLoaded = 0, this.lastLoaded = 0, this.lastScrollTop = 0, this.take = 0, this.total = 0, this.rowHeightService = null, this.bottomOffset = 0, this.topOffset = 0;
  }
  create(t, e, i, a, r = 0, l = 0, c = "vertical") {
    this.rowHeightService = t, this.firstLoaded = e, this.lastLoaded = e + i, this.take = i, this.total = a, this.lastScrollTop = 0, this.topOffset = r, this.bottomOffset = l, this.direction = c;
    const h = this.rowsForHeight(r), u = re(e - h);
    this.onScrollAction(new Me(this.rowOffset(u))), this.onPageAction(new Te(u));
  }
  onScroll({ scrollLeft: t, scrollTop: e, offsetHeight: i, offsetWidth: a }) {
    const r = this.direction === "vertical" ? e : t, l = this.direction === "vertical" ? i : a;
    if (this.lastScrollTop === r || !this.rowHeightService)
      return;
    const c = this.lastScrollTop >= r;
    this.lastScrollTop = r;
    const h = this.rowHeightService.index(re(r - this.topOffset)), u = this.rowHeightService.index(re(r + l - this.bottomOffset));
    if (!c && u >= this.lastLoaded && this.lastLoaded < this.total && (this.firstLoaded = h, this.onScrollAction(new Me(this.rowOffset(h))), this.lastLoaded = Math.min(this.firstLoaded + this.take, this.total), this.onPageAction(new Te(this.firstLoaded))), c && h <= this.firstLoaded) {
      const d = Math.floor(this.take * 0.3);
      this.firstLoaded = re(h - d), this.onScrollAction(new Me(this.rowOffset(this.firstLoaded))), this.lastLoaded = Math.min(this.firstLoaded + this.take, this.total), this.onPageAction(new Te(this.firstLoaded));
    }
  }
  rowOffset(t) {
    return this.rowHeightService ? this.rowHeightService.offset(t) + this.topOffset : 0;
  }
  rowsForHeight(t) {
    return this.rowHeightService ? Math.ceil(t / this.rowHeightService.height(0)) : 0;
  }
}
const gi = (s, t, e) => Math.min(Math.abs(t - s), e), vi = 17, wi = 10, bi = {
  [
    1
    /* Forward */
  ]: (s) => (t) => t + s,
  [
    0
    /* Backward */
  ]: (s) => (t) => t - s
}, ki = {
  [
    1
    /* Forward */
  ]: (s) => (t) => Math.min(t, s),
  [
    0
    /* Backward */
  ]: (s) => (t) => Math.max(t, s)
}, Di = {
  [
    1
    /* Forward */
  ]: (s) => (t) => t < s,
  [
    0
    /* Backward */
  ]: (s) => (t) => t > s
}, he = class extends o.Component {
  constructor(s) {
    super(s), this.rowHeightService = null, this.scrollContainer = null, this.lastDirection = null, this.lastTotal = 0, this.lastTake = 0, this.animationInProgress = !1, this.restrictScroll = !1, this.scrollTo = (t) => {
      const e = this.direction === "vertical" ? "scrollTop" : "scrollLeft";
      if (!this.scrollContainer)
        return;
      const i = this.scrollContainer[e];
      this.restrictScroll && e === "scrollTop" && (!Number.isInteger(i) || !Number.isInteger(t)) && Math.abs(i - t) < wi || (this.scrollContainer[e] = t);
    }, this.scrollToIndex = (t) => {
      this.animationInProgress = !1, this.rowHeightService && this.scrollTo(this.rowHeightService.offset(t));
    }, this.animateToIndex = (t) => {
      if (!this.rowHeightService || !window)
        return;
      window.cancelAnimationFrame(this.cancelAnimation);
      const e = this.rowHeightService.offset(t), i = this.getContainerScrollDirection(e);
      let { start: a, end: r } = this.scrollRange(e, i);
      if (a === r)
        return;
      const l = this.scrollStep(a, r), c = bi[i](l), h = ki[i](r), u = Di[i](c(r)), d = (p) => {
        this.animationInProgress = !0;
        const m = c(p);
        this.scrollTo(h(m)), u(m) ? this.cancelAnimation = window.requestAnimationFrame(() => {
          d(m);
        }) : this.animationInProgress = !1;
      };
      this.cancelAnimation = window.requestAnimationFrame(() => {
        d(a);
      });
    }, this.scrollToBottom = () => {
      this.rowHeightService && this.scrollTo(this.rowHeightService.totalHeight() + this.props.bottomOffset);
    }, this.scrollStep = (t, e) => {
      const i = this.props.scrollDuration || he.defaultProps.scrollDuration;
      return Math.abs(e - t) / (i / vi);
    }, this.scrollRange = (t, e) => {
      const i = this.containerScrollPosition;
      if (parseInt(`${t}`, 10) === parseInt(`${i}`, 10))
        return { start: t, end: t };
      const a = this.containerMaxScroll(), r = e === 0 ? 1 : -1, l = gi(i, t, this.props.maxScrollDifference || 0), c = Math.min(t, a);
      return { start: Math.min(Math.max(c + r * l, 0), a), end: c };
    }, this.containerMaxScroll = () => this.containerScrollSize - this.containerOffsetSize, this.getContainerScrollDirection = (t) => t < this.containerScrollPosition ? 0 : 1, this.initServices = (t = this.props) => {
      const e = this.direction === "vertical" ? t.itemHeight : t.itemWidth;
      e !== void 0 && (this.rowHeightService = new mi(t.total, e, 0), this.scrollerService.create(
        this.rowHeightService,
        t.skip,
        t.take,
        t.total,
        t.topOffset,
        this.scrollOffsetSize,
        this.direction
      ));
    }, this.getContainerProperty = (t) => this.scrollContainer ? this.scrollContainer[t] : 0, this.handleScroll = (t) => {
      if (!this.scrollContainer || !this.rowHeightService)
        return;
      const e = t.target;
      this.scrollerService.onScroll({
        scrollLeft: e.scrollLeft,
        scrollTop: e.scrollTop,
        offsetHeight: e.offsetHeight,
        offsetWidth: e.offsetWidth
      });
      const i = this.rowHeightService.index(this.containerScrollPosition - this.props.topOffset), { onScrollAction: a } = this.props, r = {
        index: i,
        target: e,
        scrollAction: this.scrollAction,
        pageAction: this.pageAction,
        animationInProgress: this.animationInProgress
      };
      this.props.onScroll && this.props.onScroll.call(void 0, t), a && a.call(void 0, r), this.scrollAction = void 0, this.pageAction = void 0;
    }, this.handleScrollAction = (t) => {
      this.scrollAction = t;
    }, this.handlePageAction = (t) => {
      this.pageAction = t;
    }, this.scrollerService = new fi(
      this.handleScrollAction,
      this.handlePageAction
    ), this.restrictScroll = Number.parseFloat(o.version) > 17;
  }
  get element() {
    return this.scrollContainer;
  }
  get containerOffsetSize() {
    return this.getContainerProperty(this.direction === "vertical" ? "offsetHeight" : "offsetWidth");
  }
  get containerScrollSize() {
    return this.getContainerProperty(this.direction === "vertical" ? "scrollHeight" : "scrollWidth");
  }
  get containerScrollPosition() {
    return this.getContainerProperty(this.direction === "vertical" ? "scrollTop" : "scrollLeft");
  }
  get direction() {
    return this.props.direction !== void 0 ? this.props.direction : he.defaultProps.direction;
  }
  get scrollOffsetSize() {
    return this.props.scrollOffsetSize !== void 0 ? this.props.scrollOffsetSize : he.defaultProps.scrollOffsetSize;
  }
  activeIndex() {
    return this.itemIndex(Math.ceil(this.containerScrollPosition));
  }
  itemIndex(s) {
    return this.rowHeightService ? this.rowHeightService.index(s) : 0;
  }
  itemOffset(s) {
    return this.rowHeightService ? this.rowHeightService.offset(s) : 0;
  }
  isIndexVisible(s) {
    if (!this.rowHeightService)
      return !1;
    const t = this.containerScrollPosition, e = t + this.containerOffsetSize, i = this.rowHeightService.offset(s), a = i + this.rowHeightService.height(s);
    return i >= t && a <= e;
  }
  isListScrolled(s) {
    return this.rowHeightService ? this.containerScrollPosition !== this.rowHeightService.offset(s) : !1;
  }
  componentDidMount() {
    const { onMount: s } = this.props;
    s && s.call(void 0, this);
  }
  render() {
    (this.lastTotal !== this.props.total || this.lastDirection !== this.direction || this.lastTake !== this.props.take) && (this.initServices(), this.lastTotal = this.props.total, this.lastDirection = this.direction, this.lastTake = this.props.take);
    const s = `${(this.rowHeightService ? this.rowHeightService.totalHeight() : 0) + this.props.bottomOffset}`, t = this.direction === "vertical" ? { height: `${s}px` } : { width: `${s}px` }, e = P(
      "k-content k-scrollable",
      {
        "k-scrollable-horizontal": this.direction === "horizontal"
      },
      this.props.className
    ), i = P(
      "k-scrollable-placeholder",
      {
        "k-scrollable-horizontal-placeholder": this.direction === "horizontal"
      }
    );
    return /* @__PURE__ */ o.createElement(
      "div",
      {
        ref: (a) => {
          this.scrollContainer = a;
        },
        onScroll: this.handleScroll,
        className: e,
        tabIndex: this.props.tabIndex,
        role: this.props.role
      },
      this.props.children,
      /* @__PURE__ */ o.createElement(
        "div",
        {
          style: t,
          className: i
        }
      )
    );
  }
};
let Kt = he;
Kt.propTypes = {
  bottomOffset: n.number.isRequired,
  className: n.string,
  direction: n.oneOf(["horizontal", "vertical"]),
  forceScroll: n.bool,
  itemHeight: n.number,
  itemWidth: n.number,
  maxScrollDifference: n.number,
  onScroll: n.func,
  onScrollAction: n.func,
  scrollDuration: n.number,
  scrollOffsetSize: n.number,
  skip: n.number.isRequired,
  tabIndex: n.number,
  take: n.number.isRequired,
  topOffset: n.number.isRequired,
  total: n.number.isRequired,
  role: n.string
};
Kt.defaultProps = {
  direction: "vertical",
  forceScroll: !1,
  scrollOffsetSize: 0,
  maxScrollDifference: 100,
  scrollDuration: 100
};
const yi = (s, t) => {
  const e = Object.getOwnPropertyNames(s), i = Object.getOwnPropertyNames(t);
  if (e.length !== i.length)
    return !1;
  for (let a = 0; a < e.length; a++) {
    const r = e[a];
    if (s[r] !== t[r])
      return !1;
  }
  return !0;
};
class Si extends o.Component {
  constructor() {
    super(...arguments), this.handleClick = (t) => {
      const { onClick: e, value: i } = this.props;
      e && e.call(void 0, i, t);
    }, this.handleMouseEnter = () => {
      const { onMouseEnter: t, value: e } = this.props;
      t && t.call(void 0, e);
    }, this.handleMouseLeave = () => {
      const { onMouseLeave: t, value: e } = this.props;
      t && t.call(void 0, e);
    };
  }
  // Manually checking if the component needs an update
  // due to date object being compared by instance
  // and new Date object is created
  // every time and fails the shallow compare of the React.PureComponent.
  /**
   * @hidden
   */
  shouldComponentUpdate(t) {
    const { value: e, ...i } = this.props, { value: a, ...r } = t;
    return !((!(e && a) || e.getTime() === a.getTime()) && yi(i, r));
  }
  /* eslint-disable max-len */
  /**
   * @return
   * Returns a `<td />` element with a `<span className="k-link" />` inside to apply the styles. The text inside is the [`formattedValue`]({% slug api_dateinputs_calendarcellprops %}#toc-formattedvalue) of the `cell`.
   */
  render() {
    const {
      className: t,
      formattedValue: e,
      isWeekend: i,
      isFocused: a,
      isInRange: r,
      isSelected: l,
      isRangeStart: c,
      isRangeMid: h,
      isRangeEnd: u,
      isRangeSplitStart: d,
      isRangeSplitEnd: p,
      isToday: m,
      isDisabled: f,
      view: y,
      value: I,
      ...M
    } = this.props, w = this.props.activeRangeEnd === "end" && u, E = this.props.activeRangeEnd === "start" && c, g = P(
      "k-calendar-td",
      {
        "k-range-end": u,
        "k-range-mid": h,
        "k-range-split-end": p,
        "k-range-split-start": d,
        "k-range-start": c,
        "k-active": E || w,
        "k-state-pending-focus": a,
        "k-selected": l || c || u,
        "k-today": m,
        "k-weekend": i,
        "k-disabled": f
      },
      t
    );
    return /* @__PURE__ */ o.createElement(
      "td",
      {
        ...M,
        className: g,
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      },
      /* @__PURE__ */ o.createElement("span", { className: "k-link" }, this.props.children)
    );
  }
}
class xi extends o.Component {
  /**
   * @return
   * Returns a `<td />` element with the [`value`]({% slug api_dateinputs_calendarweekcellprops %}#toc-value) as a child.
   */
  render() {
    const { className: t, firstDate: e, ...i } = this.props;
    return /* @__PURE__ */ o.createElement("td", { className: P("k-calendar-td", t), ...i }, this.props.children);
  }
}
var b = /* @__PURE__ */ ((s) => (s[s.Left = 0] = "Left", s[s.Right = 1] = "Right", s[s.Up = 2] = "Up", s[s.Down = 3] = "Down", s[s.PrevView = 4] = "PrevView", s[s.NextView = 5] = "NextView", s[s.FirstInView = 6] = "FirstInView", s[s.LastInView = 7] = "LastInView", s[s.LowerView = 8] = "LowerView", s[s.UpperView = 9] = "UpperView", s))(b || {}), D = /* @__PURE__ */ ((s) => (s[s.month = 0] = "month", s[s.year = 1] = "year", s[s.decade = 2] = "decade", s[s.century = 3] = "century", s))(D || {});
const z = { start: null, end: null };
function rt(s) {
  const t = (i, a, r, ...l) => a[r] === null ? null : (i ? s.isRequired : s)(a, r, ...l), e = t.bind(null, !1);
  return e.isRequired = t.bind(null, !0), e;
}
const ge = (s, t, e) => t === void 0 || e === void 0 || t <= s && s <= e ? s : s < t ? t : e, L = new Date(1980, 0, 1), ut = new Date(1900, 0, 1), dt = new Date(2099, 11, 31), Nt = new Date(1980, 0, 1), xt = new Date(1980, 0, 1, 23, 59, 59), W = (s, t) => {
  const e = v(s);
  return e.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), e;
}, U = () => x(/* @__PURE__ */ new Date()), F = (s, t, e) => !s || !(t && t > s || e && e < s), Hs = (s, t, e) => s === null || !(t && x(t) > x(s) || e && x(e) < x(s)), De = (s, t) => {
  const { start: e, end: i } = t || z;
  return !e || !i ? !1 : e < s && s < i;
}, Q = (s, t, e = 1) => {
  const i = [];
  for (let a = s; a < t; a = a + e)
    i.push(a);
  return i;
}, As = (s, t, e) => t.getTime() <= s.getTime() && s.getTime() <= e.getTime(), Bs = (s, t) => s.slice(t).concat(s.slice(0, t)), K = (s, t, e) => s && (t && s < t ? v(t) : e && s > e ? v(e) : s), Y = (s) => (t, e = "", i = {}) => {
  const a = document.createElement(s);
  return a.className = e, Object.keys(i).map((r) => a.style[r] = i[r]), typeof t == "string" ? a.innerHTML = t || "" : (t || []).forEach((r) => r && a.appendChild(r)), a;
};
function Ci(s, t, e = {}) {
  let i, a;
  e.maxWait;
  let r, l, c;
  const h = window;
  let u = !1, d = !1;
  const p = !t && t !== 0 && typeof h.requestAnimationFrame == "function";
  if (typeof s != "function")
    throw new TypeError("Expected a function");
  t = +t || 0;
  function m(S) {
    const O = i, tt = a;
    return i = a = void 0, r = s.apply(tt, O), r;
  }
  function f(S, O) {
    return p ? (h.cancelAnimationFrame(l), h.requestAnimationFrame(S)) : setTimeout(S, O);
  }
  function y(S) {
    if (p)
      return h.cancelAnimationFrame(S);
    clearTimeout(S);
  }
  function I(S) {
    return l = f(E, t), u ? m() : r;
  }
  function M(S) {
    const O = S - c;
    return t - O;
  }
  function w(S) {
    const O = S - c;
    return c === void 0 || O >= t || O < 0 || d;
  }
  function E() {
    const S = Date.now();
    if (w(S))
      return g();
    l = f(E, M(S));
  }
  function g(S) {
    return l = void 0, i ? m() : (i = a = void 0, r);
  }
  function H() {
    l !== void 0 && y(l), i = c = a = l = void 0;
  }
  function V() {
    return l === void 0 ? r : g();
  }
  function R() {
    return l !== void 0;
  }
  function A(...S) {
    const O = Date.now(), tt = w(O);
    return i = S, a = this, c = O, tt && l === void 0 ? I() : (l === void 0 && (l = f(E, t)), r);
  }
  return A.cancel = H, A.flush = V, A.pending = R, A;
}
const Ii = [[]], Ee = 4, Mi = 3, Ti = {
  [b.Left]: (s) => it(s, -1),
  [b.Up]: (s) => it(s, -5),
  [b.Right]: (s) => it(s, 1),
  [b.Down]: (s) => it(s, 5),
  [b.PrevView]: (s) => qt(s, -1),
  [b.NextView]: (s) => qt(s, 1),
  [b.FirstInView]: (s) => oe(s),
  [b.LastInView]: (s) => He(s)
};
class Ei {
  addToDate(t, e) {
    return qt(t, e);
  }
  datesList(t, e) {
    return Q(0, e).map((i) => qt(t, i));
  }
  data(t) {
    const {
      cellUID: e,
      focusedDate: i,
      isActiveView: a,
      max: r,
      min: l,
      selectedDate: c,
      selectionRange: h = z,
      viewDate: u
    } = t;
    if (!u)
      return Ii;
    const d = Q(0, Ee), p = oe(u), m = He(u), f = U();
    return Q(0, Mi).map((y) => {
      const I = it(p, y * Ee);
      return d.map((M) => {
        const w = this.normalize(it(I, M), l, r), E = this.isEqual(w, h.start), g = this.isEqual(w, h.end), V = !E && !g && De(w, h), R = a && (Array.isArray(c) ? this.isSelectedFromArray(w, c, l, r) : F(c, l, r) && this.isEqual(w, c));
        return As(w, p, m) ? {
          formattedValue: this.value(w),
          id: `${e}${w.getTime()}`,
          isFocused: this.isEqual(w, i),
          isSelected: R,
          isWeekend: !1,
          isInRange: F(w, l, r),
          isRangeStart: E,
          isRangeMid: V,
          isRangeEnd: g,
          isRangeSplitEnd: V && this.isEqual(w, m),
          isRangeSplitStart: V && this.isEqual(w, p),
          isToday: this.isEqual(w, f),
          title: this.cellTitle(w),
          value: w
        } : null;
      });
    });
  }
  isSelectedFromArray(t, e, i, a) {
    let r = !1;
    return e.forEach((l) => {
      F(t, i, a) && this.isEqual(t, l) && (r = !0);
    }), r;
  }
  isEqual(t, e) {
    return !t || !e ? !1 : st(t).getFullYear() === st(e).getFullYear();
  }
  isInArray(t, e) {
    if (!e.length)
      return !1;
    const i = t.getFullYear();
    return e[0].getFullYear() <= i && i <= e[e.length - 1].getFullYear() + 99;
  }
  isInRange(t, e, i) {
    const a = st(t).getFullYear(), r = !e || st(e).getFullYear() <= a, l = !i || a <= st(i).getFullYear();
    return r && l;
  }
  isInSameView(t, e) {
    return se(t, e) === 0;
  }
  isRangeStart(t) {
    return t.getFullYear() % 1e3 === 0;
  }
  move(t, e) {
    const i = Ti[e];
    return i ? i(t) : t;
  }
  cellTitle(t) {
    return st(t).getFullYear().toString();
  }
  navigationTitle(t) {
    return t ? oe(t).getFullYear().toString() : "";
  }
  title(t) {
    return t ? `${oe(t).getFullYear()} - ${He(t).getFullYear()}` : "";
  }
  rowLength(t) {
    return Ee;
  }
  skip(t, e) {
    return se(e, t);
  }
  total(t, e) {
    return se(t, e) + 1;
  }
  value(t) {
    return t ? st(t).getFullYear().toString() : "";
  }
  viewDate(t, e, i = 1) {
    return se(t, e) < i ? qt(t, -1) : t;
  }
  normalize(t, e, i) {
    return t < e && this.isEqual(t, e) ? v(e) : t > i && this.isEqual(t, i) ? v(i) : t;
  }
}
const Vi = [[]], Ve = 4, Oi = 3, Pi = {
  [b.Left]: (s) => nt(s, -1),
  [b.Up]: (s) => nt(s, -5),
  [b.Right]: (s) => nt(s, 1),
  [b.Down]: (s) => nt(s, 5),
  [b.PrevView]: (s) => it(s, -1),
  [b.NextView]: (s) => it(s, 1),
  [b.FirstInView]: (s) => st(s),
  [b.LastInView]: (s) => Ae(s)
};
class Ri {
  addToDate(t, e) {
    return it(t, e);
  }
  datesList(t, e) {
    return Q(0, e).map((i) => it(t, i));
  }
  data(t) {
    const {
      cellUID: e,
      focusedDate: i,
      isActiveView: a,
      max: r,
      min: l,
      selectedDate: c,
      selectionRange: h = z,
      viewDate: u
    } = t;
    if (!u)
      return Vi;
    const d = Q(0, Ve), p = st(u), m = Ae(u), f = U();
    return Q(0, Oi).map((y) => {
      const I = nt(p, y * Ve);
      return d.map((M) => {
        const w = this.normalize(nt(I, M), l, r), E = this.isEqual(w, h.start), g = this.isEqual(w, h.end), V = !E && !g && De(w, h), R = a && (Array.isArray(c) ? this.isSelectedFromArray(w, c, l, r) : F(c, l, r) && this.isEqual(w, c));
        return As(w, p, m) ? {
          formattedValue: this.value(w),
          id: `${e}${w.getTime()}`,
          isFocused: this.isEqual(w, i),
          isSelected: R,
          isWeekend: !1,
          isInRange: F(w, l, r),
          isRangeStart: E,
          isRangeMid: V,
          isRangeEnd: g,
          isRangeSplitEnd: V && this.isEqual(w, m),
          isRangeSplitStart: V && this.isEqual(w, p),
          isToday: this.isEqual(w, f),
          title: this.cellTitle(w),
          value: w
        } : null;
      });
    });
  }
  isSelectedFromArray(t, e, i, a) {
    let r = !1;
    return e.forEach((l) => {
      F(t, i, a) && this.isEqual(t, l) && (r = !0);
    }), r;
  }
  isEqual(t, e) {
    return !t || !e ? !1 : t.getFullYear() === e.getFullYear();
  }
  isInArray(t, e) {
    if (!e.length)
      return !1;
    const i = t.getFullYear();
    return e[0].getFullYear() <= i && i <= e[e.length - 1].getFullYear() + 9;
  }
  isInRange(t, e, i) {
    const a = t.getFullYear(), r = !e || e.getFullYear() <= a, l = !i || a <= i.getFullYear();
    return r && l;
  }
  isRangeStart(t) {
    return t.getFullYear() % 100 === 0;
  }
  isInSameView(t, e) {
    return ie(t, e) === 0;
  }
  move(t, e) {
    const i = Pi[e];
    return i ? i(t) : t;
  }
  cellTitle(t) {
    return t.getFullYear().toString();
  }
  navigationTitle(t) {
    return t ? st(t).getFullYear().toString() : "";
  }
  title(t) {
    return t ? `${st(t).getFullYear()} - ${Ae(t).getFullYear()}` : "";
  }
  rowLength(t) {
    return Ve;
  }
  skip(t, e) {
    return ie(e, t);
  }
  total(t, e) {
    return ie(t, e) + 1;
  }
  value(t) {
    return t ? t.getFullYear().toString() : "";
  }
  viewDate(t, e, i = 1) {
    return ie(t, e) < i ? it(t, -1) : t;
  }
  normalize(t, e, i) {
    return t < e && this.isEqual(t, e) ? v(e) : t > i && this.isEqual(t, i) ? v(i) : t;
  }
}
const Ni = [[]], Oe = 7, _i = 6, Fi = 6, Li = 0, Hi = {
  [b.Left]: (s) => Wt(s, -1),
  [b.Up]: (s) => gs(s, -1),
  [b.Right]: (s) => Wt(s, 1),
  [b.Down]: (s) => gs(s, 1),
  [b.PrevView]: (s) => $(s, -1),
  [b.NextView]: (s) => $(s, 1),
  [b.FirstInView]: (s) => fe(s),
  [b.LastInView]: (s) => Ot(s)
};
class Ai {
  constructor(t) {
    this.intl = t;
  }
  addToDate(t, e) {
    return $(t, e);
  }
  datesList(t, e) {
    return Q(0, e).map((i) => $(t, i));
  }
  data(t) {
    const {
      cellUID: e,
      focusedDate: i,
      isActiveView: a,
      max: r,
      min: l,
      selectedDate: c,
      selectionRange: h = z,
      viewDate: u
    } = t;
    if (!u)
      return Ni;
    const d = fe(u), p = Ot(u), m = -1, f = si(d, this.intl.firstDay(), m), y = Q(0, Oe), I = U();
    return Q(0, _i).map((M) => {
      const w = Wt(f, M * Oe);
      return y.map((E) => {
        const g = this.normalize(Wt(w, E), l, r);
        if (g < d || g > p)
          return null;
        const V = this.isEqual(g, h.start), R = this.isEqual(g, h.end), S = !V && !R && De(g, h), O = a && (Array.isArray(c) ? this.isSelectedFromArray(g, c, l, r) : F(c, l, r) && this.isEqual(g, c));
        return {
          formattedValue: this.value(g),
          id: `${e}${g.getTime()}`,
          isFocused: this.isEqual(g, i),
          isSelected: O,
          isInRange: F(g, l, r),
          isWeekend: this.isWeekend(g),
          isRangeStart: V,
          isRangeMid: S,
          isRangeEnd: R,
          isRangeSplitStart: S && this.isEqual(g, d),
          isRangeSplitEnd: S && this.isEqual(g, p),
          isToday: this.isEqual(g, I),
          title: this.cellTitle(g),
          value: g
        };
      });
    });
  }
  isEqual(t, e) {
    return !t || !e ? !1 : x(t).getTime() === x(e).getTime();
  }
  isSelectedFromArray(t, e, i, a) {
    let r = !1;
    return e.forEach((l) => {
      F(t, i, a) && this.isEqual(t, l) && (r = !0);
    }), r;
  }
  isInArray(t, e) {
    return !!e.length && fe(e[0]) <= t && t <= Ot(e[e.length - 1]);
  }
  isInRange(t, e, i) {
    const a = x(t), r = !e || x(e) <= a, l = !i || a <= x(i);
    return r && l;
  }
  isInSameView(t, e) {
    return ne(t, e) === 0;
  }
  isRangeStart(t) {
    return !t.getMonth();
  }
  move(t, e) {
    const i = Hi[e];
    return i ? i(t) : t;
  }
  cellTitle(t) {
    return this.intl.formatDate(t, "D");
  }
  navigationTitle(t) {
    return t ? this.isRangeStart(t) ? t.getFullYear().toString() : this.abbrMonthNames()[t.getMonth()] : "";
  }
  title(t) {
    return `${this.wideMonthNames()[t.getMonth()]} ${t.getFullYear()}`;
  }
  rowLength(t) {
    return Oe + (t ? 1 : 0);
  }
  skip(t, e) {
    return ne(e, t);
  }
  total(t, e) {
    return ne(t, e) + 1;
  }
  value(t) {
    return t ? t.getDate().toString() : "";
  }
  viewDate(t, e, i = 1) {
    return ne(t, e) < i ? $(t, -1) : t;
  }
  isWeekend(t) {
    const e = t.getDay();
    return e === Fi || e === Li;
  }
  abbrMonthNames() {
    return this.intl.dateFormatNames({ nameType: "abbreviated", type: "months" });
  }
  normalize(t, e, i) {
    return t < e && this.isEqual(t, e) ? x(e) : t > i && this.isEqual(t, i) ? x(i) : t;
  }
  wideMonthNames() {
    return this.intl.dateFormatNames({ nameType: "wide", type: "months", standAlone: !0 });
  }
}
const Bi = [[]], Pe = 4, zi = 3, qi = (s) => s > 4 ? -5 : s < 2 ? -2 : -7, Wi = (s) => s < 7 ? 5 : s < 10 ? 7 : 2, Ui = {
  [b.Left]: (s) => $(s, -1),
  [b.Up]: (s) => $(s, qi(s.getMonth())),
  [b.Right]: (s) => $(s, 1),
  [b.Down]: (s) => $(s, Wi(s.getMonth())),
  [b.PrevView]: (s) => nt(s, -1),
  [b.NextView]: (s) => nt(s, 1),
  [b.FirstInView]: (s) => Ns(s),
  [b.LastInView]: (s) => _s(s)
};
class $i {
  constructor(t) {
    this._intl = t;
  }
  addToDate(t, e) {
    return nt(t, e);
  }
  datesList(t, e) {
    return Q(0, e).map((i) => nt(t, i));
  }
  data(t) {
    const {
      cellUID: e,
      focusedDate: i,
      isActiveView: a,
      max: r,
      min: l,
      selectedDate: c,
      selectionRange: h = z,
      viewDate: u
    } = t;
    if (!u)
      return Bi;
    const d = this.abbrMonthNames(), p = Ns(u), m = _s(u), f = p.getFullYear(), y = Q(0, Pe), I = U();
    return Q(0, zi).map((M) => {
      const w = $(p, M * Pe);
      return y.map((E) => {
        const g = this.normalize($(w, E), l, r);
        if (f < g.getFullYear())
          return null;
        const V = this.isEqual(g, h.start), R = this.isEqual(g, h.end), S = !V && !R && De(g, h), O = a && (Array.isArray(c) ? this.isSelectedFromArray(g, c, l, r) : F(c, l, r) && this.isEqual(g, c));
        return {
          formattedValue: d[g.getMonth()],
          id: `${e}${g.getTime()}`,
          isFocused: this.isEqual(g, i),
          isSelected: O,
          isInRange: F(g, l, r),
          isWeekend: !1,
          isRangeStart: V,
          isRangeMid: S,
          isRangeEnd: R,
          isRangeSplitEnd: S && this.isEqual(g, m),
          isRangeSplitStart: S && this.isEqual(g, p),
          isToday: this.isEqual(g, I),
          title: this.cellTitle(g),
          value: g
        };
      });
    });
  }
  isSelectedFromArray(t, e, i, a) {
    let r = !1;
    return e.forEach((l) => {
      F(t, i, a) && this.isEqual(t, l) && (r = !0);
    }), r;
  }
  isEqual(t, e) {
    return !t || !e ? !1 : t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth();
  }
  isInArray(t, e) {
    if (!e.length)
      return !1;
    const i = t.getFullYear();
    return e[0].getFullYear() <= i && i <= e[e.length - 1].getFullYear();
  }
  isInRange(t, e, i) {
    const a = le(t.getFullYear(), t.getMonth(), 1), r = !e || le(e.getFullYear(), e.getMonth(), 1) <= a, l = !i || a <= le(i.getFullYear(), i.getMonth(), 1);
    return r && l;
  }
  isInSameView(t, e) {
    return ae(t, e) === 0;
  }
  isRangeStart(t) {
    return t.getFullYear() % 10 === 0;
  }
  move(t, e) {
    const i = Ui[e];
    return i ? i(t) : t;
  }
  cellTitle(t) {
    return `${t.getFullYear()} ${this.value(t)}`;
  }
  navigationTitle(t) {
    return this.title(t);
  }
  title(t) {
    return t ? t.getFullYear().toString() : "";
  }
  rowLength(t) {
    return Pe;
  }
  skip(t, e) {
    return ae(e, t);
  }
  total(t, e) {
    return ae(t, e) + 1;
  }
  value(t) {
    return t ? this.abbrMonthNames()[t.getMonth()] : "";
  }
  viewDate(t, e, i = 1) {
    return ae(t, e) < i ? nt(t, -1) : t;
  }
  abbrMonthNames() {
    return this._intl.dateFormatNames({ nameType: "abbreviated", type: "months" });
  }
  normalize(t, e, i) {
    return t < e && this.isEqual(t, e) ? v(e) : t > i && this.isEqual(t, i) ? v(i) : t;
  }
}
const Yi = {
  [D.month]: Ai,
  [D.year]: $i,
  [D.decade]: Ri,
  [D.century]: Ei
}, Ki = (s, t) => {
  const e = D[D[s + t]];
  return e !== void 0 ? e : s;
};
class zs {
  constructor(t) {
    this.bottom = D.month, this.top = D.century, this.onViewChanged = t;
  }
  configure(t, e) {
    this.bottom = t, this.top = e;
  }
  service(t, e) {
    return new Yi[`${t}`](e);
  }
  moveDown(t, e) {
    this.move(t, -1, e);
  }
  moveUp(t, e) {
    this.move(t, 1, e);
  }
  moveToBottom(t) {
    t !== this.bottom && this.onViewChanged({ view: this.bottom });
  }
  canMoveDown(t) {
    return this.bottom < t;
  }
  canMoveUp(t) {
    return t < this.top;
  }
  clamp(t) {
    return t < this.bottom ? this.bottom : t > this.top ? this.top : t;
  }
  move(t, e, i) {
    const a = this.clamp(Ki(t, e));
    a !== t && this.onViewChanged({ view: a }, i);
  }
}
let ji = class {
  constructor() {
    this.calendarHeight = 0, this.headerHeight = 0, this.monthViewHeight = 0, this.yearViewHeight = 0, this.decadeViewHeight = 0, this.centuryViewHeight = 0, this.navigationItemHeight = 0, this.scrollableContentHeight = 0, this.scrollableYearContentHeight = 0, this.calendarWidth = 0, this.monthViewWidth = 0, this.yearViewWidth = 0, this.decadeViewWidth = 0, this.centuryViewWidth = 0, this.scrollableContentWidth = 0, this.didCalculate = !1, this.hostContainer = null;
  }
  ensureHeights() {
    this.calendarHeight === void 0 && this.calculateHeights();
  }
  calculateHeights(t) {
    if (!J)
      return;
    const e = Y("div"), i = Y("ul"), a = Y("li"), r = Y("td"), l = Y("th"), c = Y("tr"), h = Y("tbody"), u = Y("thead"), d = Y("table"), p = () => e(
      `
            <span class="k-button k-button-md k-button-rectangle k-button-solid k-button-solid-base k-button-flat k-calendar-title">
                <span className="k-button-text">March 2017</span>
            </span>
            <span class="k-spacer"></span>
            <span class="k-calendar-nav k-hstack"><button class="k-calendar-nav-today">TODAY</button></span>
        `,
      "k-calendar-header k-hstack"
    ), m = () => d(
      [
        u([
          c([l("MO", "k-calendar-th")], "k-calendar-tr")
        ], "k-calendar-thead")
      ],
      "k-calendar-table k-calendar-weekdays"
    ), f = (k, _) => new Array(k).fill("1").map(_), y = (k, _ = 1) => d([
      h(
        [c(
          [r("1", "k-calendar-td k-alt")]
        )].concat(
          f(
            k,
            () => c(f(_, (Mt) => r(`<span class="k-link">${Mt}</span>`, "k-calendar-td")), "k-calendar-tr")
          )
        ),
        "k-calendar-tbody"
      )
    ], "k-calendar-table"), I = (k) => e(k, "k-content k-scrollable"), M = (k, _, Mt) => e(
      Mt ? [
        p(),
        m(),
        I([k, k])
      ] : [
        p(),
        I([k, k])
      ],
      _,
      { left: "-10000px", position: "absolute" }
    ), w = (() => {
      let k;
      return () => J ? (k || (k = e(
        [I([i([a("<span>FEB</span>")])])],
        "k-calendar-navigation",
        { left: "0px", position: "absolute" }
      )), k) : null;
    })(), E = ({ cells: k, rows: _ }, Mt, ti) => {
      let Ie;
      return () => J ? (Ie || (Ie = M(y(_, k), Mt, ti)), Ie) : null;
    }, g = (k) => k.querySelector(".k-scrollable"), H = (k) => {
      const _ = g(k);
      return _.className = `${_.className} k-scrollable-horizontal`, k;
    }, V = E({ cells: 7, rows: 6 }, "k-calendar-view k-calendar-monthview k-vstack", !0), R = E({ cells: 5, rows: 3 }, "k-calendar-view k-calendar-yearview", !1), A = E({ cells: 5, rows: 2 }, "k-calendar-view k-calendar-decadeview", !1), S = () => H(V()), O = () => H(R()), tt = () => H(A()), j = (k) => parseFloat(window.getComputedStyle(k).height) || k.offsetHeight, gt = (k) => {
      const _ = window.getComputedStyle(k);
      return parseFloat(_.width) + parseFloat(_.paddingLeft) + parseFloat(_.paddingRight) || k.offsetWidth;
    }, It = (k) => k.querySelector("tbody");
    this.didCalculate = !0, t && (this.hostContainer = t), this.batch(V(), (k) => {
      const _ = It(k);
      this.calendarHeight = j(k), this.monthViewHeight = j(_), this.headerHeight = j(_.children[0]), this.scrollableContentHeight = j(g(k));
    }), this.batch(S(), (k) => {
      const _ = It(k);
      this.calendarWidth = gt(k), this.monthViewWidth = gt(_), this.scrollableContentWidth = gt(g(k));
    }), this.batch(R(), (k) => {
      this.yearViewHeight = j(It(k)), this.scrollableYearContentHeight = j(g(k));
    }), this.batch(O(), (k) => {
      this.yearViewWidth = gt(It(k));
    }), this.batch(A(), (k) => {
      this.decadeViewHeight = j(It(k)), this.centuryViewHeight = this.decadeViewHeight;
    }), this.batch(tt(), (k) => {
      this.decadeViewWidth = gt(It(k)), this.centuryViewWidth = this.decadeViewWidth;
    }), this.batch(w(), (k) => {
      this.navigationItemHeight = j(k.querySelector("li"));
    });
  }
  viewHeight(t) {
    return this.viewDimension(t, "height");
  }
  viewWidth(t) {
    return this.viewDimension(t, "width");
  }
  viewDimension(t, e) {
    const i = e === "height" ? "ViewHeight" : "ViewWidth";
    switch (t) {
      case D.month:
        return this[`month${i}`];
      case D.year:
        return this[`year${i}`];
      case D.decade:
        return this[`decade${i}`];
      case D.century:
        return this[`century${i}`];
      default:
        return 1;
    }
  }
  batch(t, e) {
    const i = this.hostContainer || document.body, a = i.appendChild(t);
    e(a), i.removeChild(a);
  }
};
const Zi = {
  33: b.PrevView,
  34: b.NextView,
  35: b.LastInView,
  36: b.FirstInView,
  37: b.Left,
  38: b.Up,
  39: b.Right,
  40: b.Down,
  "meta+38": b.UpperView,
  "meta+40": b.LowerView
};
class qs {
  constructor(t) {
    this.bus = t;
  }
  action(t) {
    const e = `${t.ctrlKey || t.metaKey ? "meta+" : ""}${t.keyCode}`;
    return Zi[e];
  }
  move(t, e, i, a, r) {
    return a ? e === b.UpperView && this.bus.canMoveUp(i) ? (this.bus.moveUp(i, r), t) : e === b.LowerView && this.bus.canMoveDown(i) ? (this.bus.moveDown(i, r), t) : a.move(t, e) : t;
  }
}
const Gi = (s) => (t) => Math.floor(t / s), Xi = (s) => (t) => t * s;
class Ji {
  constructor(t) {
    this.dom = t, this.divideByMagnitude = null, this.powerByMagnitude = null, this.navigator = null, this.view = null, this.monthScrolled = !1, this.navScrolled = !1;
  }
  configure(t) {
    const e = Math.max(this.dom.viewHeight(t) / this.dom.navigationItemHeight, 1);
    this.divideByMagnitude = Gi(e), this.powerByMagnitude = Xi(e);
  }
  sync(t, e, i) {
    if (!(!t || !e)) {
      if (this.navigator = t, this.view = e, i.target === this.navigator.element) {
        if (this.monthScrolled) {
          this.monthScrolled = !1;
          return;
        }
        this.navScrolled = !0, this.scrollSiblingOf(this.navigator.element);
      }
      if (i.target === this.view.element) {
        if (this.navScrolled) {
          this.navScrolled = !1;
          return;
        }
        this.monthScrolled = !0, this.scrollSiblingOf(this.view.element);
      }
    }
  }
  scrollSiblingOf(t) {
    const e = this.siblingComponent(t), i = this.calculateScroll(e, t.scrollTop);
    e.scrollTo(i);
  }
  siblingComponent(t) {
    return this.navigator.element === t ? this.view : this.navigator;
  }
  calculateScroll(t, e) {
    const i = t === this.navigator ? this.divideByMagnitude : this.powerByMagnitude;
    return i ? i(e) : 0;
  }
}
class Qi {
  constructor(t) {
    this.intl = t;
  }
  getWeekNames(t = !1) {
    const e = Bs(
      this.intl.dateFormatNames({ nameType: "short", type: "days" }),
      this.intl.firstDay()
    );
    return t ? [""].concat(e) : e;
  }
}
const bs = (s) => /* @__PURE__ */ o.createElement("td", { key: s, className: "k-calendar-td" }, " "), Ws = class extends o.Component {
  constructor() {
    super(...arguments), this.intl = null, this.weekService = null, this.buildWeekNumber = (s, t) => {
      if (!this.firstDate(s))
        return bs(`week-cell-${t}`);
      const i = this.firstDate(s), a = this.getWeekNumber(i), r = `kendo-react-calendar-week-cell-${a}`, l = {
        className: "k-alt",
        value: a,
        firstDate: i
      };
      return this.props.weekCell ? /* @__PURE__ */ o.createElement(this.props.weekCell, { ...l, key: r }, a) : /* @__PURE__ */ o.createElement(xi, { ...l, key: r }, a);
    }, this.buildRow = (s) => s.map((t, e) => {
      if (!t)
        return bs(e);
      const i = { "aria-selected": t.isSelected }, a = `kendo-react-calendar-cell-${t.value.getTime()}`, r = {
        ...i,
        ...t,
        isDisabled: !t.isInRange,
        view: this.props.activeView,
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      };
      return this.props.cell ? /* @__PURE__ */ o.createElement(this.props.cell, { ...r, key: a }, t.formattedValue) : /* @__PURE__ */ o.createElement(Si, { ...r, key: a }, t.formattedValue);
    }), this.firstDate = (s) => {
      const t = this.firstWeekDateContext(s);
      return t ? t.value : null;
    }, this.firstWeekDateContext = (s) => {
      if (!this.weekNumber)
        return null;
      let t = 0, e = s[t];
      for (; !e && t < s.length; )
        e = s[++t];
      return e;
    }, this.handleClick = (s, t) => {
      const { onChange: e } = this.props;
      if (e && t) {
        const i = {
          value: v(s),
          target: this,
          nativeEvent: t && t.nativeEvent,
          syntheticEvent: t
        };
        e.call(void 0, i);
      }
    }, this.handleMouseEnter = (s) => {
      const { onCellEnter: t } = this.props;
      t && t.call(void 0, v(s));
    }, this.handleMouseLeave = (s) => {
      const { onCellLeave: t } = this.props;
      t && t.call(void 0, v(s));
    };
  }
  get min() {
    return this.props.min;
  }
  get max() {
    return this.props.max;
  }
  get isHorizontal() {
    return this.props.direction === "horizontal";
  }
  get isMonthView() {
    return this.props.activeView === D.month;
  }
  get weekNumber() {
    return !!(this.props.showWeekNumbers && this.props.activeView === D.month);
  }
  get selectedDate() {
    return this.props.selectedDate !== void 0 ? this.props.selectedDate : Ws.defaultProps.selectedDate;
  }
  render() {
    this.intl = ct(this), this.weekService = new Qi(this.intl);
    const s = this.weekService.getWeekNames(this.weekNumber), t = this.props.service.rowLength(this.weekNumber), e = this.props.service.title(this.props.viewDate), i = U(), a = W(this.props.viewDate, i), r = this.props.service.data({
      cellUID: this.props.cellUID,
      min: this.min,
      max: this.max,
      focusedDate: this.props.focusedDate,
      isActiveView: !this.props.bus.canMoveDown(this.props.activeView),
      selectedDate: this.selectedDate,
      selectionRange: this.props.selectionRange,
      viewDate: a
    });
    return /* @__PURE__ */ o.createElement(o.Fragment, null, this.isMonthView && this.isHorizontal && /* @__PURE__ */ o.createElement(
      "thead",
      {
        role: "rowgroup",
        className: "k-calendar-thead"
      },
      /* @__PURE__ */ o.createElement("tr", { role: "row", className: "k-calendar-tr" }, s.map((l, c) => /* @__PURE__ */ o.createElement("th", { key: c, className: "k-calendar-th" }, l)))
    ), /* @__PURE__ */ o.createElement(
      "tbody",
      {
        role: "rowgroup",
        className: "k-calendar-tbody"
      },
      !this.isHorizontal && /* @__PURE__ */ o.createElement("tr", { role: "presentation", className: "k-calendar-tr" }, /* @__PURE__ */ o.createElement(
        "th",
        {
          scope: "col",
          colSpan: t,
          className: "k-calendar-caption"
        },
        e
      )),
      r.map((l, c) => /* @__PURE__ */ o.createElement("tr", { role: "row", className: "k-calendar-tr", key: c }, this.weekNumber && this.buildWeekNumber(l, c), this.buildRow(l)))
    ));
  }
  getWeekNumber(s) {
    return !this.weekNumber || !this.intl ? null : ii(s, this.intl.firstDay());
  }
};
let jt = Ws;
jt.propTypes = {
  activeRangeEnd: n.oneOf(["start", "end", null]),
  activeView: n.number.isRequired,
  cellUID: n.string.isRequired,
  direction: n.oneOf(["horizontal", "vertical"]),
  focusedDate: n.instanceOf(Date).isRequired,
  max: n.instanceOf(Date).isRequired,
  min: n.instanceOf(Date).isRequired,
  onChange: n.func,
  selectedDate: n.oneOfType(
    [n.instanceOf(Date), n.arrayOf(n.instanceOf(Date))]
  ),
  showWeekNumbers: n.bool,
  viewDate: n.instanceOf(Date).isRequired
};
jt.defaultProps = {
  direction: "vertical",
  selectedDate: U(),
  showWeekNumbers: !1
};
ft(jt);
class tn extends o.PureComponent {
  /**
   * @return
   * Returns a `<span />` element with the [`value`]({% slug api_dateinputs_calendarheadertitleprops %}#toc-value) of the title as a child.
   */
  render() {
    const { view: t, ...e } = this.props;
    return /* @__PURE__ */ o.createElement(N, { type: "button", fillMode: "flat", ...e }, this.props.children);
  }
}
const ce = class extends o.Component {
  constructor() {
    super(...arguments), this.getTitle = () => {
      if (!this.props.currentDate)
        return "";
      const s = this.rangeLength - 1, t = this.props.service.title(this.props.currentDate), e = this.props.service.addToDate(this.props.currentDate, s);
      return s < 1 || !this.props.service.isInRange(e, this.min, this.max) ? t : `${t} - ${this.props.service.title(e)}`;
    }, this.handleTitleClick = (s) => {
      this.canMoveUp && this.props.bus.moveUp(this.props.activeView, s);
    };
  }
  get min() {
    return this.props.min !== void 0 ? this.props.min : ce.defaultProps.min;
  }
  get max() {
    return this.props.max !== void 0 ? this.props.max : ce.defaultProps.max;
  }
  get rangeLength() {
    return this.props.rangeLength !== void 0 ? this.props.rangeLength : ce.defaultProps.rangeLength;
  }
  get canMoveUp() {
    return this.props.bus.canMoveUp(this.props.activeView);
  }
  render() {
    const s = this.getTitle(), t = P(
      "k-calendar-title"
    ), e = {
      children: s,
      value: s,
      view: this.props.activeView,
      className: t,
      onClick: this.handleTitleClick,
      disabled: !this.canMoveUp
    }, i = this.props.headerTitle ? /* @__PURE__ */ o.createElement(this.props.headerTitle, { ...e }, s) : /* @__PURE__ */ o.createElement(tn, { ...e }, s);
    return /* @__PURE__ */ o.createElement(
      "div",
      {
        className: P("k-calendar-header", {
          "k-vstack": this.props.verticalView,
          "k-hstack": !this.props.verticalView
        })
      },
      i,
      /* @__PURE__ */ o.createElement("span", { className: "k-spacer" }),
      /* @__PURE__ */ o.createElement("span", { className: "k-calendar-nav k-hstack" }, this.props.commands)
    );
  }
};
let Zt = ce;
Zt.propTypes = {
  activeView: n.number.isRequired,
  currentDate: n.instanceOf(Date).isRequired,
  max: n.instanceOf(Date).isRequired,
  min: n.instanceOf(Date).isRequired,
  rangeLength: n.number
};
Zt.defaultProps = {
  rangeLength: 1,
  min: ut,
  max: dt
};
at(Zt);
const Be = "multiviewcalendar.prevView", ze = "multiviewcalendar.nextView", Ft = "dateinput.increment", Lt = "dateinput.decrement", qe = "calendar.today", We = "datepicker.toggleCalendar", Ht = "daterangepicker.swapStartEnd", Ue = "daterangepicker.start", $e = "daterangepicker.end", Ye = "daterangepicker.separator", At = "datetimepicker.toggleDateTimeSelector", Ke = "timepicker.now", je = "timepicker.selectNow", ve = "timepicker.cancel", Ut = "timepicker.set", Ze = "timepicker.toggleTimeSelector", ue = "timepicker.toggleClock", Ge = "datetimepicker.date", Xe = "datetimepicker.time", $t = "datetimepicker.cancel", Yt = "datetimepicker.set", Je = "daterangepicker.cancel", Qe = "daterangepicker.set", T = {
  [qe]: "TODAY",
  [Ke]: "NOW",
  [Ut]: "Set",
  [ve]: "Cancel",
  [Ge]: "Date",
  [Xe]: "Time",
  [$t]: "Cancel",
  [Yt]: "Set",
  [Je]: "Cancel",
  [Qe]: "Set",
  [Ue]: "Start",
  [$e]: "End",
  [Ye]: " ",
  [je]: "Select Now",
  [Ze]: "Toggle TimeSelector",
  [ue]: "Toggle Clock",
  [Ft]: "Increase value",
  [Lt]: "Decrease value",
  [We]: "Toggle calendar",
  [Be]: "Navigate to previous view",
  [ze]: "Navigate to next view",
  [Ht]: "Swap start and end values",
  [At]: "Toggle date-time selector"
}, ts = class extends o.Component {
  constructor() {
    super(...arguments), this.localization = null, this.handleClick = (s) => {
      if (this.todayIsInRange && this.props.onClick) {
        const t = {
          syntheticEvent: s,
          nativeEvent: s.nativeEvent,
          value: K(U(), this.min, this.max),
          target: this,
          isTodayClick: !0
        };
        this.props.onClick.call(void 0, t);
      }
    };
  }
  get min() {
    return this.props.min !== void 0 ? this.props.min : ts.defaultProps.min;
  }
  get max() {
    return this.props.max !== void 0 ? this.props.max : ts.defaultProps.max;
  }
  get todayIsInRange() {
    return F(U(), x(this.min), x(this.max));
  }
  render() {
    this.localization = q(this);
    const s = this.localization.toLanguageString(qe, T[qe]), t = P(
      "k-calendar-nav-today",
      {
        "k-disabled": this.props.disabled
      }
    );
    return /* @__PURE__ */ o.createElement(
      N,
      {
        className: t,
        onClick: this.handleClick,
        tabIndex: this.props.tabIndex,
        fillMode: "flat"
      },
      s
    );
  }
};
let Gt = ts;
Gt.propTypes = {
  max: n.instanceOf(Date).isRequired,
  min: n.instanceOf(Date).isRequired,
  onClick: n.func,
  disabled: n.bool
};
Gt.defaultProps = {
  min: ut,
  max: dt
};
at(Gt);
const en = 5, Us = class extends o.Component {
  constructor(s) {
    super(s), this.virtualization = null, this.calendarView = null, this.table = null, this.intl = null, this.bottomOffset = 0, this.viewOffset = 0, this.viewHeight = 0, this._element = null, this.isActive = !1, this.animateToIndex = !0, this.shouldScroll = !1, this.focusActiveDate = () => {
      if (!this._element)
        return;
      const t = this._element.querySelector("td.k-focus"), e = this._element.querySelector(".k-state-pending-focus");
      t && t[0] && t[0].classList.remove("k-focus"), e && e.classList.add("k-focus"), this.isActive = !0;
    }, this.blurActiveDate = () => {
      if (!this._element)
        return;
      const t = this._element.querySelector("td.k-focus");
      t && t.classList.remove("k-focus"), this.isActive = !1;
    }, this.handleVirtualizationMount = (t) => {
      if (this.virtualization = t, this.virtualization && this.table) {
        this.table.style.transform = `translateY(${this.viewOffset}px)`;
        const e = K(this.props.focusedDate, this.props.min, this.props.max), i = this.props.service.skip(e, this.props.min);
        this.virtualization.scrollToIndex(i);
      }
    }, this.buildMonthView = (t, e) => /* @__PURE__ */ o.createElement(
      "table",
      {
        key: "calendar-view-list-weekdays",
        className: "k-calendar-table k-calendar-weekdays",
        role: "grid",
        tabIndex: this.props.tabIndex
      },
      /* @__PURE__ */ o.createElement("colgroup", null, t.map((i, a) => /* @__PURE__ */ o.createElement("col", { key: a }))),
      /* @__PURE__ */ o.createElement("thead", { className: "k-calendar-thead" }, /* @__PURE__ */ o.createElement("tr", { className: "k-calendar-tr" }, e.map((i, a) => /* @__PURE__ */ o.createElement("th", { key: a, className: "k-calendar-th" }, i))))
    ), this.buildDates = (t, e) => {
      const i = this.props.cellUID;
      return /* @__PURE__ */ o.createElement(
        "table",
        {
          className: "k-calendar-table",
          ref: (a) => this.table = a,
          role: "grid",
          tabIndex: this.props.tabIndex,
          "aria-activedescendant": i + this.props.focusedDate.getTime()
        },
        /* @__PURE__ */ o.createElement("colgroup", null, t.map((a, r) => /* @__PURE__ */ o.createElement("col", { key: r }))),
        e.map((a) => /* @__PURE__ */ o.createElement(
          jt,
          {
            ref: (r) => {
              this.calendarView || (this.calendarView = r);
            },
            key: a.getTime(),
            activeView: this.props.activeView,
            viewDate: a,
            min: this.props.min,
            max: this.props.max,
            cellUID: i,
            focusedDate: this.props.focusedDate,
            cell: this.props.cell,
            selectedDate: this.props.value,
            showWeekNumbers: this.weekNumber,
            onChange: this.handleDateChange,
            bus: this.props.bus,
            service: this.props.service,
            weekCell: this.props.weekCell
          }
        ))
      );
    }, this.calculateHeights = () => {
      if (!this.props.dom)
        return;
      const t = this.props.activeView === D.month ? this.props.dom.scrollableContentHeight : this.props.dom.scrollableYearContentHeight;
      this.bottomOffset = t - this.props.dom.viewHeight(this.props.activeView), this.viewOffset = -1 * this.props.dom.headerHeight, this.viewHeight = this.props.dom.viewHeight(this.props.activeView) || 1;
    }, this.getTake = (t, e) => Math.min(e - t, this.take), this.handleScrollAction = ({ index: t, scrollAction: e, pageAction: i }) => {
      const a = i ? i.skip : this.state.skip;
      if ((this.state.index !== t || this.state.skip !== a) && this.setState({ index: t, skip: a }), this.table && e) {
        const r = `translateY(${e.offset}px)`;
        this.table.style.transform = r;
      }
    }, this.handleTodayClick = (t) => {
      this.shouldScroll = !0, this.handleDateChange.call(void 0, t, !0);
    }, this.handleDateChange = (t, e = !1) => {
      const { onChange: i } = this.props;
      if (i) {
        const a = {
          syntheticEvent: t.syntheticEvent,
          nativeEvent: t.nativeEvent,
          value: v(t.value),
          target: this,
          isTodayClick: e
        };
        i.call(void 0, a);
      }
    }, this.lastView = this.props.activeView, this.lastFocus = this.props.focusedDate, this.state = {
      skip: this.props.service.skip(this.props.focusedDate, this.props.min),
      index: this.props.service.skip(this.props.focusedDate, this.props.min)
    };
  }
  get element() {
    return this._element;
  }
  get weekNames() {
    this.intl = ct(this);
    const s = Bs(
      this.intl.dateFormatNames({ nameType: "short", type: "days" }),
      this.intl.firstDay()
    );
    return this.weekNumber ? [""].concat(s) : s;
  }
  get weekNumber() {
    return !!(this.props.showWeekNumbers && this.props.activeView === D.month);
  }
  get take() {
    return this.props.take !== void 0 ? this.props.take : Us.defaultProps.take;
  }
  get animate() {
    return !!(this.props.smoothScroll && this.animateToIndex);
  }
  get todayIsInRange() {
    return F(U(), x(this.props.min), x(this.props.max));
  }
  componentDidUpdate(s, t) {
    this.shouldScroll = !1, this.indexToScroll !== void 0 && this.virtualization && this.virtualization[this.animate ? "animateToIndex" : "scrollToIndex"](this.indexToScroll), this.isActive && this.focusActiveDate(), this.lastView = this.props.activeView, this.indexToScroll = void 0;
  }
  render() {
    this.calculateHeights();
    const s = this.lastView !== this.props.activeView, t = K(this.props.focusedDate, this.props.min, this.props.max), e = s ? this.props.service.skip(t, this.props.min) : this.state.skip, i = this.props.service.total(this.props.min, this.props.max), a = this.getTake(e, i), r = this.props.service.addToDate(this.props.min, e), l = this.props.service.addToDate(this.props.min, this.state.index), c = new Array(this.props.service.rowLength(this.weekNumber)).fill(""), h = this.props.activeView !== this.lastView;
    this.animateToIndex = !h, (h || !wt(this.lastFocus, t) || this.shouldScroll || !this.props.shouldScroll || this.props.shouldScroll()) && (this.indexToScroll = this.props.service.skip(t, this.props.min)), this.lastFocus = t;
    const u = P(
      "k-calendar-view k-vstack",
      {
        "k-calendar-monthview": this.props.activeView === D.month,
        "k-calendar-yearview": this.props.activeView === D.year,
        "k-calendar-decadeview": this.props.activeView === D.decade,
        "k-calendar-centuryview": this.props.activeView === D.century
      }
    ), d = this.buildDates(c, this.props.service.datesList(r, a)), p = /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
      Zt,
      {
        key: "calendar-view-list-header",
        currentDate: l,
        min: this.props.min,
        max: this.props.max,
        activeView: this.props.activeView,
        bus: this.props.bus,
        service: this.props.service,
        headerTitle: this.props.headerTitle,
        commands: /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
          Gt,
          {
            min: this.props.min,
            max: this.props.max,
            onClick: this.handleTodayClick,
            disabled: !this.todayIsInRange,
            tabIndex: this.props.tabIndex
          }
        ))
      }
    ), this.props.activeView === D.month && this.buildMonthView(c, this.weekNames), /* @__PURE__ */ o.createElement(
      Kt,
      {
        key: "calendar-view-list-content",
        skip: e,
        take: this.take,
        total: i,
        itemHeight: this.viewHeight,
        topOffset: this.viewOffset,
        bottomOffset: this.bottomOffset,
        scrollOffsetSize: this.viewOffset,
        maxScrollDifference: this.viewHeight,
        onScroll: this.props.onScroll,
        onScrollAction: this.handleScrollAction,
        onMount: this.handleVirtualizationMount,
        children: d,
        tabIndex: this.props.tabIndex
      }
    ));
    return /* @__PURE__ */ o.createElement(
      "div",
      {
        ref: (m) => {
          this._element = m;
        },
        className: u
      },
      this.props.dom.didCalculate ? p : null
    );
  }
};
let ye = Us;
ye.propTypes = {
  activeView: n.number.isRequired,
  bottomOffset: n.number,
  cellUID: n.string.isRequired,
  focusedDate: n.instanceOf(Date).isRequired,
  max: n.instanceOf(Date).isRequired,
  min: n.instanceOf(Date).isRequired,
  onChange: n.func,
  showWeekNumbers: n.bool,
  smoothScroll: n.bool,
  take: n.number,
  value: n.instanceOf(Date),
  viewHeight: n.number,
  viewOffset: n.number,
  tabIndex: n.number
};
ye.defaultProps = {
  take: en,
  showWeekNumbers: !1,
  smoothScroll: !0
};
ft(ye);
class sn extends o.Component {
  constructor() {
    super(...arguments), this.handleClick = (t) => {
      const { onClick: e, value: i } = this.props;
      e && e.call(void 0, i, t);
    };
  }
  /**
   * @return
   * Returns a `<li />` element with a `<span />` inside. The text inside represents the [`value`]({% slug api_dateinputs_calendarnavigationitemprops %}#toc-value) of the `navigationItem`.
   */
  render() {
    const { isRangeStart: t, value: e, text: i, ...a } = this.props;
    return /* @__PURE__ */ o.createElement("li", { ...a, onClick: this.handleClick }, /* @__PURE__ */ o.createElement("span", { className: P({ "k-calendar-navigation-marker": t }) }, this.props.children));
  }
}
const nn = 30, $s = class extends o.Component {
  constructor(s) {
    super(s), this.virtualization = null, this.list = null, this.itemHeight = 0, this.topOffset = 0, this.maxViewHeight = 0, this.bottomOffset = 0, this.handleVirtualizationMount = (i) => {
      if (this.virtualization = i, this.virtualization && this.list) {
        this.list.style.transform = `translateY(${this.topOffset}px)`;
        const a = K(this.props.focusedDate, this.props.min, this.props.max), r = this.props.service.skip(a, this.props.min);
        this.virtualization.scrollToIndex(r);
      }
    }, this.buildNavigationItem = (i) => {
      const a = this.props.service.navigationTitle(i), r = this.props.service.isRangeStart(i), l = `kendo-react-calendar-nav-item-${i.getTime()}`, c = {
        text: a,
        value: i,
        isRangeStart: r,
        view: this.props.activeView,
        onClick: this.handleDateChange
      };
      return this.props.navigationItem ? /* @__PURE__ */ o.createElement(this.props.navigationItem, { ...c, key: l }, a) : /* @__PURE__ */ o.createElement(sn, { ...c, key: l }, a);
    }, this.calculateHeights = () => {
      const i = this.props.dom.calendarHeight;
      this.itemHeight = this.props.dom.navigationItemHeight || 1, this.maxViewHeight = this.props.dom.monthViewHeight, this.topOffset = (i - this.itemHeight) / 2, this.bottomOffset = i - this.itemHeight;
    }, this.handleDateChange = (i, a) => {
      const { onChange: r } = this.props;
      if (r && a) {
        const l = {
          value: v(i),
          target: this,
          nativeEvent: a && a.nativeEvent,
          syntheticEvent: a
        };
        r.call(void 0, l);
      }
    }, this.handleScrollAction = ({ scrollAction: i, pageAction: a }) => {
      const r = a ? a.skip : this.state.skip;
      if (this.state.skip !== r && this.setState({ skip: r }), this.list && i) {
        const l = `translateY(${i.offset}px)`;
        this.list.style.transform = l;
      }
    }, this.lastView = this.props.activeView, this.lastFocus = this.props.focusedDate;
    const t = this.props.service.skip(this.props.focusedDate, this.props.min), e = this.props.service.total(this.props.min, this.props.max);
    this.state = {
      skip: t - this.getTake(t, e) > 0 ? t : 0
    };
  }
  get take() {
    return this.props.take !== void 0 ? this.props.take : $s.defaultProps.take;
  }
  /**
   * @hidden
   */
  componentDidUpdate(s, t) {
    this.indexToScroll !== void 0 && this.virtualization && this.virtualization.scrollToIndex(this.indexToScroll), this.lastView = this.props.activeView, this.lastFocus = this.props.focusedDate, this.indexToScroll = void 0;
  }
  render() {
    this.calculateHeights();
    const s = this.lastView !== this.props.activeView, t = K(this.props.focusedDate, this.props.min, this.props.max), e = s ? this.props.service.skip(t, this.props.min) : this.state.skip, i = this.props.service.total(this.props.min, this.props.max), a = this.getTake(e, i), r = this.props.service.addToDate(this.props.min, e), l = this.props.service.datesList(r, a);
    (this.props.activeView !== this.lastView || !ht(t, this.lastFocus)) && (this.indexToScroll = this.props.service.skip(t, this.props.min));
    const c = /* @__PURE__ */ o.createElement(
      Kt,
      {
        skip: e,
        take: this.take,
        total: i,
        itemHeight: this.itemHeight,
        topOffset: this.topOffset,
        bottomOffset: this.bottomOffset,
        onScroll: this.props.onScroll,
        maxScrollDifference: this.maxViewHeight,
        onScrollAction: this.handleScrollAction,
        onMount: this.handleVirtualizationMount,
        tabIndex: this.props.tabIndex
      },
      /* @__PURE__ */ o.createElement("ul", { ref: (h) => {
        this.list = h;
      }, className: "k-reset" }, l.map((h) => this.buildNavigationItem(h)))
    );
    return /* @__PURE__ */ o.createElement(
      "div",
      {
        className: "k-calendar-navigation"
      },
      /* @__PURE__ */ o.createElement("span", { className: "k-calendar-navigation-highlight" }),
      this.props.dom.didCalculate ? c : null
    );
  }
  getTake(s, t) {
    return Math.min(t - s, this.take);
  }
};
let ns = $s;
ns.propTypes = {
  activeView: n.number.isRequired,
  focusedDate: n.instanceOf(Date).isRequired,
  max: n.instanceOf(Date).isRequired,
  min: n.instanceOf(Date).isRequired,
  onChange: n.func,
  take: n.number,
  tabIndex: n.number
};
ns.defaultProps = {
  take: nn
};
const Re = (s) => s ? s.virtualization : null, ks = (s = bt.defaultProps.min, t = bt.defaultProps.max, e, i) => i !== void 0 ? i !== null && F(x(i), s, t) ? i : null : e !== null && F(x(e), s, t) ? e : null, pt = class extends o.Component {
  constructor(s) {
    super(s), this.scrollSyncService = null, this.focusedDate = null, this.Navigation = null, this.calendarViewList = null, this._element = null, this.intl = null, this.service = null, this.isActive = !1, this.didNavigationChange = !1, this.focus = () => {
      this._element && this._element.focus();
    }, this.shouldScroll = () => this.didNavigationChange, this.handleScroll = (e) => {
      this.scrollSyncService && this.scrollSyncService.sync(
        Re(this.Navigation),
        Re(this.calendarViewList),
        e
      );
    }, this.handleNavigationChange = (e) => {
      if (this.props.disabled)
        return;
      this.didNavigationChange = !0;
      const i = v(e.value);
      this.setState({ focusedDate: i });
    }, this.handleViewChange = ({ view: e }) => {
      this.scrollSyncService && this.scrollSyncService.configure(e), this.setState({ activeView: e });
    }, this.handleDateChange = (e) => {
      const i = v(e.value), a = v(e.value), r = this.bus.canMoveDown(this.state.activeView);
      if (this.props.disabled)
        return;
      if (r)
        if (e.isTodayClick)
          this.bus.moveToBottom(this.state.activeView);
        else {
          this.bus.moveDown(this.state.activeView, e.syntheticEvent), this.setState({ focusedDate: a });
          return;
        }
      this.setState({ value: i, focusedDate: a }), this.valueDuringOnChange = i;
      const { onChange: l } = this.props;
      if (l) {
        const c = {
          syntheticEvent: e.syntheticEvent,
          nativeEvent: e.nativeEvent,
          value: i,
          target: this
        };
        l.call(void 0, c);
      }
      this.valueDuringOnChange = void 0;
    }, this.handleFocus = (e) => {
      if (this.isActive = !0, !this.calendarViewList)
        return;
      this.calendarViewList.focusActiveDate();
      const { onFocus: i } = this.props;
      i && i.call(void 0, e);
    }, this.handleBlur = (e) => {
      if (this.isActive = !1, !this.calendarViewList)
        return;
      this.calendarViewList.blurActiveDate();
      const { onBlur: i } = this.props;
      i && i.call(void 0, e);
    }, this.handleKeyDown = (e) => {
      const { keyCode: i } = e;
      if (!(!this.focusedDate || !this.service)) {
        if (i === C.enter) {
          if (this.value !== null && wt(this.focusedDate, this.value)) {
            const r = K(this.focusedDate, this.min, this.max);
            Re(this.calendarViewList).scrollToIndex(this.service.skip(r, this.min));
          }
          const a = {
            syntheticEvent: e,
            nativeEvent: e.nativeEvent,
            value: this.focusedDate,
            target: this
          };
          this.handleDateChange(a);
        } else {
          const a = K(
            this.navigation.move(
              this.focusedDate,
              this.navigation.action(e),
              this.state.activeView,
              this.service,
              e
            ),
            this.min,
            this.max
          );
          if (wt(this.focusedDate, a))
            return;
          this.setState({ focusedDate: a });
        }
        e.preventDefault();
      }
    }, this.handleMouseDown = (e) => {
      e.preventDefault();
    }, this.handleClick = (e) => {
      this._element && this._element.focus({ preventScroll: !0 });
    }, Pt(Rt);
    const t = ks(
      this.min,
      this.max,
      this.props.defaultValue || pt.defaultProps.defaultValue,
      this.props.value
    );
    this.state = {
      value: t,
      activeView: ge(
        D[s.defaultActiveView],
        this.bottomView,
        this.topView
      ),
      focusedDate: K(
        s.focusedDate || t || U(),
        this.min,
        this.max
      )
    }, this.dom = new ji(), this.bus = new zs(this.handleViewChange), this.navigation = new qs(this.bus), this.oldValue = t;
  }
  get cellUID() {
    return this.props.id + "-cell-uid";
  }
  get id() {
    return this.props.id + "-id";
  }
  /**
   * Gets the wrapping element of the Calendar.
   */
  get element() {
    return this._element;
  }
  /**
   * Gets the value of the Calendar.
   */
  get value() {
    return this.valueDuringOnChange !== void 0 ? this.valueDuringOnChange : this.props.value !== void 0 ? this.props.value : this.state.value;
  }
  get min() {
    return x(this.props.min !== void 0 ? this.props.min : pt.defaultProps.min);
  }
  get max() {
    return x(this.props.max !== void 0 ? this.props.max : pt.defaultProps.max);
  }
  get bottomView() {
    return D[this.props.bottomView !== void 0 ? this.props.bottomView : pt.defaultProps.bottomView];
  }
  get topView() {
    return D[this.props.topView !== void 0 ? this.props.topView : pt.defaultProps.topView];
  }
  /**
   * @hidden
   */
  componentDidMount() {
    Promise.resolve().then(() => {
      fs(), this._element && (this.dom.calculateHeights(this._element), this.scrollSyncService = new Ji(this.dom), this.scrollSyncService.configure(this.state.activeView), this.forceUpdate());
    });
  }
  /**
   * @hidden
   */
  componentDidUpdate(s, t) {
    fs(), t.activeView !== this.state.activeView && this.scrollSyncService && this.scrollSyncService.configure(this.state.activeView), this.calendarViewList && (this.isActive ? this.calendarViewList.focusActiveDate : this.calendarViewList.blurActiveDate)(), this.didNavigationChange = !1, this.oldValue = this.value;
  }
  /**
   * @hidden
   */
  render() {
    this.props._ref && this.props._ref(this);
    const s = this.value !== null && this.oldValue !== null ? !wt(this.value, this.oldValue) : this.value !== this.oldValue, t = ge(
      this.state.activeView,
      D[this.props.bottomView !== void 0 ? this.props.bottomView : pt.defaultProps.bottomView],
      D[this.props.topView !== void 0 ? this.props.topView : pt.defaultProps.topView]
    ), e = ks(this.min, this.max, this.value, this.value), i = e ? x(e) : null;
    this.focusedDate = x(K(
      s && e !== null ? e : this.state.focusedDate,
      this.min,
      this.max
    )), this.intl = ct(this), this.bus.configure(this.bottomView, this.topView), this.service = this.bus.service(t, this.intl);
    const { smoothScroll: a = Number.parseFloat(o.version) < 18 } = this.props, r = P(
      "k-widget k-calendar k-calendar-infinite",
      {
        "k-disabled": this.props.disabled,
        "k-week-number": this.props.weekNumber,
        "k-calendar-lg": this.props.mobileMode
      },
      this.props.className
    ), l = [this.props.navigation && /* @__PURE__ */ o.createElement(
      ns,
      {
        key: 0,
        ref: (c) => {
          this.Navigation = c;
        },
        activeView: this.state.activeView,
        focusedDate: this.focusedDate,
        min: this.min,
        max: this.max,
        onScroll: this.handleScroll,
        onChange: this.handleNavigationChange,
        service: this.service,
        dom: this.dom,
        navigationItem: this.props.navigationItem,
        tabIndex: this.props.tabIndex
      }
    ), /* @__PURE__ */ o.createElement(
      ye,
      {
        key: 1,
        ref: (c) => {
          this.calendarViewList = c;
        },
        activeView: this.state.activeView,
        focusedDate: this.focusedDate,
        min: this.min,
        max: this.max,
        bus: this.bus,
        shouldScroll: this.shouldScroll,
        onScroll: this.handleScroll,
        service: this.service,
        cell: this.props.cell,
        weekCell: this.props.weekCell,
        dom: this.dom,
        smoothScroll: a,
        showWeekNumbers: this.props.weekNumber,
        onChange: this.handleDateChange,
        value: i,
        cellUID: this.cellUID,
        headerTitle: this.props.headerTitle,
        tabIndex: this.props.tabIndex
      }
    )];
    return /* @__PURE__ */ o.createElement(
      "div",
      {
        ref: (c) => {
          this._element = c;
        },
        className: r,
        id: this.props.id || this.id,
        "aria-labelledby": this.props.ariaLabelledBy,
        "aria-describedby": this.props.ariaDescribedBy,
        "aria-disabled": this.props.disabled,
        tabIndex: this.props.disabled ? void 0 : this.props.tabIndex || 0,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown,
        onClick: this.handleClick
      },
      l
    );
  }
};
let bt = pt;
bt.displayName = "Calendar";
bt.propTypes = {
  className: n.string,
  defaultActiveView: n.oneOf(["month", "year", "decade", "century"]),
  defaultValue: n.instanceOf(Date),
  disabled: n.bool,
  focusedDate: n.instanceOf(Date),
  id: n.string,
  ariaLabelledBy: n.string,
  ariaDescribedBy: n.string,
  max: n.instanceOf(Date),
  min: n.instanceOf(Date),
  navigation: n.bool,
  smoothScroll: n.bool,
  onBlur: n.func,
  onChange: n.func,
  onFocus: n.func,
  tabIndex: n.number,
  value: n.instanceOf(Date),
  weekNumber: n.bool,
  topView: (s, t, e) => {
    const i = s[t], a = s.bottomView;
    return i && a && D[i] < D[a] ? new Error(
      `Invalid prop + ${t} suplied to ${e}.
                    ${t} can not be smaller than bottomView.
                    `
    ) : null;
  },
  bottomView: (s, t, e) => {
    const i = s[t], a = s.topView;
    return i && a && D[i] > D[a] ? new Error(
      `Invalid prop + ${t} suplied to ${e}.
                    ${t} can not be bigger than topView.
                    `
    ) : null;
  }
};
bt.defaultProps = {
  disabled: !1,
  min: ut,
  max: dt,
  navigation: !0,
  defaultActiveView: "month",
  defaultValue: null,
  topView: "century",
  bottomView: "month"
};
const an = Dt(), as = yt(St(an, bt));
as.displayName = "KendoReactCalendar";
ft(bt);
class rn {
  constructor() {
    this.symbols = "", this.partMap = [];
  }
}
const on = "d", ln = "wide", hn = (s, t, e, i) => {
  const a = s[i + s.length - e.length], r = s.substring(0, i + s.length - e.length), l = e.substring(0, i), c = [];
  if (r === l && i > 0)
    return c.push([t[i - 1], l[i - 1]]), c;
  if (r.indexOf(l) === 0 && (l.length === 0 || t[l.length - 1] !== t[l.length])) {
    let h = "";
    l.length === 1 && c.push([t[0], l[0]]);
    for (let u = l.length; u < r.length; u++)
      t[u] !== h && t[u] !== "_" && (h = t[u], c.push([h, ""]));
    return c;
  }
  if (l.indexOf(r) === 0 || t[i - 1] === "_") {
    let h = t[0];
    for (let u = Math.max(0, r.length - 1); u < t.length; u++)
      if (t[u] !== "_") {
        h = t[u];
        break;
      }
    return [[h, l[i - 1]]];
  }
  return l[l.length - 1] === " " || l[l.length - 1] === a ? [[t[i - 1], "_"]] : [[t[i - 1], l[i - 1]]];
}, cn = (s, t) => (s[t.pattern[0]] = t.type, s), un = (s, t, e) => s === null || !(t && t > s || e && e < s), dn = ["k-widget", "k-dateinput"];
class pn {
  constructor(t, e, i) {
    this.year = !0, this.month = !0, this.date = !0, this.hours = !0, this.minutes = !0, this.seconds = !0, this.milliseconds = !0, this.leadingZero = null, this.typedMonthPart = "", this.knownParts = "adHhmMsEy", this.symbols = {
      E: "E",
      H: "H",
      M: "M",
      a: "a",
      d: "d",
      h: "h",
      m: "m",
      s: "s",
      y: "y"
    }, this._value = x(/* @__PURE__ */ new Date()), this.intlProvider = t, this.formatPlaceholder = e, this.format = i, this.monthNames = this.allFormatedMonths();
  }
  get intl() {
    return this.intlProvider();
  }
  get value() {
    return this._value;
  }
  setValue(t) {
    t ? ht(t, this._value) || (this._value = v(t), this.modifyExisting(!0)) : (this._value = x(/* @__PURE__ */ new Date()), this.modifyExisting(!1));
  }
  hasValue() {
    const t = (e, i) => e || i.type !== "literal" && i.type !== "dayperiod" && this.getExisting(i.pattern[0]);
    return this.intl.splitDateFormat(this.format).reduce(t, !1);
  }
  getDateObject() {
    for (let t = 0; t < this.knownParts.length; t++)
      if (!this.getExisting(this.knownParts[t]))
        return null;
    return v(this.value);
  }
  getTextAndFormat() {
    return this.merge(
      this.intl.formatDate(this.value, this.format),
      this.dateFormatString(this.value, this.format)
    );
  }
  modifyExisting(t) {
    const e = this.dateFormatString(this.value, this.format).symbols;
    for (let i = 0; i < e.length; i++)
      this.setExisting(e[i], t);
  }
  getExisting(t) {
    switch (t) {
      case "y":
        return this.year;
      case "M":
      case "L":
        return this.month;
      case "d":
        return this.date;
      case "E":
        return this.date && this.month && this.year;
      case "h":
      case "H":
        return this.hours;
      case "m":
        return this.minutes;
      case "s":
        return this.seconds;
      default:
        return !0;
    }
  }
  setExisting(t, e) {
    switch (t) {
      case "y":
        this.year = e, e === !1 && this._value.setFullYear(2e3);
        break;
      case "M":
        this.month = e, e === !1 && this._value.setMonth(0);
        break;
      case "d":
        this.date = e;
        break;
      case "h":
      case "H":
        this.hours = e;
        break;
      case "m":
        this.minutes = e;
        break;
      case "s":
        this.seconds = e;
        break;
      default:
        return;
    }
  }
  modifyPart(t, e) {
    let i = v(this.value);
    switch (t) {
      case "y":
        i.setFullYear(i.getFullYear() + e);
        break;
      case "M":
        i = $(this.value, e);
        break;
      case "d":
      case "E":
        i.setDate(i.getDate() + e);
        break;
      case "h":
      case "H":
        i.setHours(i.getHours() + e);
        break;
      case "m":
        i.setMinutes(i.getMinutes() + e);
        break;
      case "s":
        i.setSeconds(i.getSeconds() + e);
        break;
      case "a":
        i.setHours(i.getHours() + 12 * e);
        break;
    }
    this.setExisting(t, !0), this._value = i;
  }
  parsePart(t, e) {
    if (this.resetLeadingZero(), !e)
      return this.setExisting(t, !1), { value: null };
    const i = this.intl.formatDate(this.value, this.format), a = this.dateFormatString(this.value, this.format), r = a.symbols;
    let l = !1, c = "", h = "", u = "";
    for (let m = 0; m < i.length; m++)
      r[m] === t ? (h += this.getExisting(t) ? i[m] : "0", l = !0) : l ? u += i[m] : c += i[m];
    let d = null;
    const p = this.matchMonth(e);
    for (; h.length > 0 && h.charAt(0) === "0"; )
      h = h.slice(1);
    h.length >= 4 && (h = "");
    for (let m = 0; m < 2; m++) {
      let f = h + e, y = parseInt(f, 10);
      if (d = this.intl.parseDate(c + f + u, this.format), !d && !isNaN(y) && !isNaN(parseInt(e, 10))) {
        if (t === "M" && !p) {
          const I = y - 1;
          I > -1 && I < 12 && (d = v(this.value), d.setMonth(I), d.getMonth() !== I && (d = Ot($(d, -1))));
        }
        t === "y" && (d = le(
          parseInt(f, 10),
          this.month ? this.value.getMonth() : 0,
          this.date ? this.value.getDate() : 1,
          this.hours ? this.value.getHours() : 0,
          this.minutes ? this.value.getMinutes() : 0,
          this.seconds ? this.value.getSeconds() : 0,
          this.milliseconds ? this.value.getMilliseconds() : 0
        ), this.date && d.getDate() !== this.value.getDate() && (d = Ot($(d, -1))));
      }
      if (d)
        return this._value = d, this.setExisting(t, !0), { value: this.value };
      h = "";
    }
    return p && (d = this.intl.parseDate(c + p + u, this.format), d) ? (this._value = d, this.setExisting(t, !0), { value: this.value }) : (e === "0" && (this.leadingZero = this.isAbbrMonth(a.partMap, t) ? null : { [t]: !0 }, this.setExisting(t, !1)), { value: null });
  }
  symbolMap(t) {
    return this.intl.splitDateFormat(this.format).reduce(cn, {})[t];
  }
  resetLeadingZero() {
    const t = this.leadingZero !== null;
    return this.leadingZero = null, t;
  }
  isAbbrMonth(t, e) {
    const i = this.partPattern(t, e);
    return i.type === "month" && i.names;
  }
  partPattern(t, e) {
    return t.filter((i) => i.pattern.indexOf(e) !== -1)[0];
  }
  matchMonth(t) {
    if (this.typedMonthPart += t.toLowerCase(), this.monthNames.length === 0)
      return "";
    for (; this.typedMonthPart.length > 0; ) {
      for (let i = 0; i < this.monthNames.length; i++)
        if (this.monthNames[i].toLowerCase().indexOf(this.typedMonthPart) === 0)
          return this.monthNames[i];
      const e = parseInt(this.typedMonthPart, 10);
      if (e >= 1 && e <= 12 && e.toString() === this.typedMonthPart)
        return this.monthNames[e - 1];
      this.typedMonthPart = this.typedMonthPart.substring(1, this.typedMonthPart.length);
    }
    return "";
  }
  allFormatedMonths() {
    const t = this.intl.splitDateFormat(this.format);
    for (let e = 0; e < t.length; e++)
      if (t[e].type === "month" && t[e].names)
        return this.intl.dateFormatNames(t[e].names);
    return [];
  }
  dateFormatString(t, e) {
    const i = this.intl.splitDateFormat(e), a = [], r = [];
    for (let c = 0; c < i.length; c++) {
      let h = this.intl.formatDate(t, { pattern: i[c].pattern }).length;
      for (; h > 0; )
        a.push(this.symbols[i[c].pattern[0]] || "_"), r.push(i[c]), h--;
    }
    const l = new rn();
    return l.symbols = a.join(""), l.partMap = r, l;
  }
  merge(t, e) {
    let i = "", a = "", r = e.symbols;
    for (let l = r.length - 1; l >= 0; l--)
      if (this.knownParts.indexOf(r[l]) === -1 || this.getExisting(r[l]))
        i = t[l] + i, a = r[l] + a;
      else {
        const c = r[l];
        for (; l >= 0 && c === r[l]; )
          l--;
        for (l++, this.leadingZero && this.leadingZero[c] ? i = "0" + i : i = this.dateFieldName(e.partMap[l]) + i; a.length < i.length; )
          a = r[l] + a;
      }
    return { text: i, format: a };
  }
  dateFieldName(t) {
    const e = this.formatPlaceholder || "wide";
    return e[t.type] ? e[t.type] : e === "formatPattern" ? t.pattern : this.intl.dateFieldName(Object.assign(t, { nameType: e }));
  }
}
const X = {
  dayperiod: "dayperiod",
  hour: "hour",
  millisecond: "millisecond",
  minute: "minute",
  second: "second"
}, rs = (s) => (t, e) => {
  const i = v(t);
  return i[s](e), i;
}, Ys = [
  { type: X.hour, getter: (s) => s.getHours() },
  { type: X.minute, getter: (s) => s.getMinutes() },
  { type: X.second, getter: (s) => s.getSeconds() },
  { type: X.millisecond, getter: (s) => s.getMilliseconds() }
], mn = (s) => (t, e) => s(t), fn = (s) => (t, e) => s(e), gn = (s) => s.reduce((t, e) => (t[e.type] = e.type, t), {}), vn = (s) => (t) => s[t.type] ? fn(t.getter) : mn(t.getter), wn = (s) => (t) => s.map(vn(gn(t))), bn = (s, t, e, i) => (a) => {
  const r = s(a), l = s(e);
  return i === "hour" ? r - (r - l) % t : a.getTime() <= e.getTime() && r !== 0 && r <= l ? Math.ceil(r / t) * t : r - r % t;
}, kn = (s) => (t, e) => s.map((i) => {
  const a = Math.floor(t[i.type]);
  return a ? bn(i.getter, a, e, i.type) : i.getter;
}), Dn = wn(Ys), Ds = kn(Ys), yn = (s) => (t, e) => (t.setHours(...s.map((i) => i(t, e))), t), ys = (s) => (t) => {
  const e = v(t);
  return e.setHours(...s.map((i) => i(e))), e;
}, de = rs("setHours"), pe = rs("setMinutes"), me = rs("setSeconds"), Vt = () => /* @__PURE__ */ new Date(), os = (s, t, e = 1) => {
  const i = [];
  for (let a = s; a < t; a = a + e)
    i.push(a);
  return i;
}, ls = (s, t, e) => ({
  candidateValue: W(L, s),
  maxValue: Wt(W(L, e), t.getHours() < e.getHours() ? 0 : 1),
  minValue: W(L, t)
}), Sn = (s, t, e) => {
  if (!s || !t || !e)
    return s;
  const {
    candidateValue: i,
    minValue: a,
    maxValue: r
  } = ls(s, t, e);
  return i < a ? W(s, t) : i > r ? W(s, e) : s;
}, hs = (s, t, e) => {
  if (!s || !t || !e)
    return !0;
  const {
    candidateValue: i,
    minValue: a,
    maxValue: r
  } = ls(s, t, e);
  return a <= i && i <= r;
}, xn = (s, t, e) => {
  if (s === null)
    return !0;
  const {
    candidateValue: i,
    minValue: a,
    maxValue: r
  } = ls(s, t, e);
  return a <= i && i <= r;
}, Cn = (s, t) => {
  if (s === null || t === null)
    return !1;
  const e = W(L, s), i = W(L, t);
  return e.getTime() < i.getHours();
}, In = (s, t) => {
  if (s === null || t === null)
    return !1;
  const e = W(L, s);
  return W(L, t).getTime() < e.getHours();
}, Mn = "Please enter a valid value!", Z = class extends o.Component {
  constructor(s) {
    super(s), this.kendoDate = null, this.currentFormat = "", this.paste = !1, this._element = null, this._wrapper = null, this._lastSelectedSymbol = "", this.focus = () => {
      this._element && this._element.focus();
    }, this.setValidity = () => {
      this.element && this.element.setCustomValidity && this.element.setCustomValidity(
        this.validity.valid ? "" : this.props.validationMessage || Z.defaultProps.validationMessage
      );
    }, this.updateOnPaste = (t) => {
      if (!this.element || !this.kendoDate)
        return;
      const e = ct(this).parseDate(this.element.value, this.props.format) || this.value, i = this.value;
      this.kendoDate.setValue(e), this.triggerChange(t, i);
    }, this.spinnersMouseDown = (t) => {
      t.preventDefault();
      const e = ot(document);
      this.element && e !== this.element && this.element.focus({ preventScroll: !0 });
    }, this.handlePaste = () => {
      this.paste = !0;
    }, this.elementChange = (t) => {
      if (!this.element || !this.kendoDate)
        return;
      if (this.paste) {
        this.updateOnPaste(t), this.paste = !1;
        return;
      }
      const { text: e, format: i } = this.kendoDate.getTextAndFormat();
      this.currentFormat = i;
      const a = this.value, r = hn(
        e,
        this.currentFormat,
        this.element.value,
        this.selection.start
      ), l = r.length === 1 && r[0][1] === "_";
      if (!l)
        for (let c = 0; c < r.length; c++)
          this.kendoDate.parsePart(r[c][0], r[c][1]);
      r.length && r[0][0] !== "_" && this.setSelection(this.selectionBySymbol(r[0][0])), l && this.switchDateSegment(1), this.triggerChange(t, a);
    }, this.elementClick = (t) => {
      this.setSelection(this.selectionByIndex(this.selection.start));
    }, this.nativeWheel = (t) => {
      ot(document) === this.element && t.preventDefault();
    }, this.wheel = (t) => {
      ot(document) === this.element && (t.nativeEvent.deltaY < 0 && this.increasePart(t), t.nativeEvent.deltaY > 0 && this.decreasePart(t));
    }, this.increasePart = (t) => {
      this.modifyDateSegmentValue(1, t);
    }, this.decreasePart = (t) => {
      this.modifyDateSegmentValue(-1, t);
    }, this.elementKeyDown = (t) => {
      if (!t.altKey) {
        switch (t.keyCode) {
          case 37:
            this.switchDateSegment(-1);
            break;
          case 38:
            this.modifyDateSegmentValue(1, t);
            break;
          case 39:
            this.switchDateSegment(1);
            break;
          case 40:
            this.modifyDateSegmentValue(-1, t);
            break;
          default:
            return;
        }
        t.preventDefault();
      }
    }, this.elementOnFocus = (t) => {
      this.wrapper && this.wrapper.classList.add("k-focus"), this.setState({ focused: !0 });
    }, this.elementOnBlur = (t) => {
      this.wrapper && this.wrapper.classList.remove("k-focus"), this.setState({ focused: !1 });
    }, Pt(Rt), this.state = {
      focused: !1
    };
  }
  get _inputId() {
    return this.props.id + "-accessibility-id";
  }
  /**
   * @hidden
   */
  componentDidMount() {
    this.setValidity(), this.wrapper && this.wrapper.addEventListener("wheel", this.nativeWheel, { passive: !1 });
  }
  /**
   * @hidden
   */
  componentDidUpdate(s, t) {
    this._lastSelectedSymbol && t.focused === this.state.focused ? this.setSelection(this.selectionBySymbol(this._lastSelectedSymbol)) : this.props.placeholder !== void 0 && this.selection.start === this.selection.end && this.setSelection({ start: 0, end: this.currentFormat.length }), this.setValidity();
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    this.wrapper && this.wrapper.removeEventListener("wheel", this.nativeWheel);
  }
  /**
   * @hidden
   */
  render() {
    const {
      size: s = Z.defaultProps.size,
      fillMode: t = Z.defaultProps.fillMode,
      rounded: e = Z.defaultProps.rounded
    } = this.props;
    this.props._ref && (this.props._ref.current = this);
    const i = q(this), a = { ...Z.defaultProps, ...this.props }, { name: r, label: l, id: c } = a, h = this.text, u = h === this.props.placeholder ? "" : h, d = h === this.props.placeholder ? h : void 0, p = c || this._inputId, m = !this.validityStyles || this.validity.valid;
    let f = [...dn];
    this.props.className && f.push(this.props.className);
    const y = /* @__PURE__ */ o.createElement(we, { onFocus: this.elementOnFocus, onBlur: this.elementOnBlur }, ({ onFocus: I, onBlur: M }) => /* @__PURE__ */ o.createElement(
      "span",
      {
        ref: (w) => {
          this._wrapper = w;
        },
        style: l ? void 0 : { width: this.props.width },
        dir: this.props.dir,
        className: P(
          "k-dateinput",
          "k-input",
          {
            [`k-input-${mt.sizeMap[s] || s}`]: s,
            [`k-input-${t}`]: t,
            [`k-rounded-${mt.roundedMap[e] || e}`]: e,
            "k-invalid": !m,
            "k-required": this.required,
            "k-disabled": this.props.disabled
          },
          this.props.className
        ),
        onFocus: I,
        onBlur: M
      },
      /* @__PURE__ */ o.createElement(
        "input",
        {
          role: this.props.ariaRole || "textbox",
          readOnly: this.props.readonly,
          tabIndex: this.props.tabIndex,
          disabled: this.props.disabled,
          title: this.props.title !== void 0 ? this.props.title : h,
          type: "text",
          spellCheck: !1,
          autoComplete: "off",
          autoCorrect: "off",
          className: "k-input-inner",
          id: p,
          "aria-label": this.props.ariaLabel,
          "aria-labelledby": this.props.ariaLabelledBy,
          "aria-describedby": this.props.ariaDescribedBy,
          "aria-haspopup": this.props.ariaHasPopup,
          "aria-disabled": this.props.disabled,
          "aria-expanded": this.props.ariaExpanded,
          "aria-controls": this.props.ariaControls,
          onWheel: this.wheel,
          onClick: this.elementClick,
          onInput: this.elementChange,
          onPaste: this.handlePaste,
          onKeyDown: this.elementKeyDown,
          onChange: Rs,
          value: u,
          placeholder: d,
          name: r,
          ref: (w) => this._element = w
        }
      ),
      this.props.children,
      this.props.spinners && /* @__PURE__ */ o.createElement("span", { className: "k-input-spinner k-spin-button", onMouseDown: this.spinnersMouseDown }, /* @__PURE__ */ o.createElement(
        N,
        {
          tabIndex: -1,
          type: "button",
          rounded: null,
          className: "k-spinner-increase",
          icon: "caret-alt-up",
          svgIcon: ai,
          "aria-label": i.toLanguageString(Ft, T[Ft]),
          title: i.toLanguageString(Ft, T[Ft]),
          onClick: this.increasePart
        }
      ), /* @__PURE__ */ o.createElement(
        N,
        {
          tabIndex: -1,
          type: "button",
          rounded: null,
          className: "k-spinner-decrease",
          icon: "caret-alt-down",
          svgIcon: ri,
          "aria-label": i.toLanguageString(Lt, T[Lt]),
          title: i.toLanguageString(Lt, T[Lt]),
          onClick: this.decreasePart
        }
      ))
    ));
    return l ? /* @__PURE__ */ o.createElement(
      Ls,
      {
        label: l,
        editorId: p,
        editorValue: h,
        editorValid: m,
        editorDisabled: this.props.disabled,
        children: y,
        style: { width: this.props.width }
      }
    ) : y;
  }
  /* Public Getters */
  /**
   * Gets the value of the DateInput.
   */
  get value() {
    return this.valueDuringOnChange !== void 0 ? this.valueDuringOnChange : this.kendoDate && this.kendoDate.getDateObject();
  }
  /**
   * Gets the `name` property of the DateInput.
   */
  get name() {
    return this.props.name;
  }
  get min() {
    return this.props.min !== void 0 ? this.props.min : Z.defaultProps.min;
  }
  get max() {
    return this.props.max !== void 0 ? this.props.max : Z.defaultProps.max;
  }
  /**
   * @hidden
   */
  get text() {
    const s = { ...kt.defaultProps, ...this.props }, {
      formatPlaceholder: t = Z.defaultProps.formatPlaceholder,
      format: e = Z.defaultProps.format,
      value: i,
      defaultValue: a
    } = s;
    this.kendoDate === null ? (this.kendoDate = new pn(this.intl.bind(this), t, e), this.kendoDate.setValue(i || a || null)) : (this.kendoDate.format = e, this.kendoDate.formatPlaceholder = t), i !== void 0 && this.value !== i && this.kendoDate.setValue(i);
    const { text: r, format: l } = this.kendoDate.getTextAndFormat();
    return this.currentFormat = l, s.placeholder !== null && s.placeholder !== void 0 && !this.state.focused && !this.kendoDate.hasValue() ? s.placeholder : r;
  }
  /**
   * Represents the validity state into which the DateInput is set.
   */
  get validity() {
    const s = un(this.value, this.min, this.max) && hs(this.value, this.props.minTime, this.props.maxTime), t = this.props.validationMessage !== void 0, e = (!this.required || this.value !== null) && s, i = this.props.valid !== void 0 ? this.props.valid : e;
    return {
      customError: t,
      rangeOverflow: this.value && this.max.getTime() < this.value.getTime() || !1,
      rangeUnderflow: this.value && this.value.getTime() < this.min.getTime() || !1,
      valid: i,
      valueMissing: this.value === null
    };
  }
  /**
   * Gets the element of the DateInput.
   *
   * @return - An `HTMLInputElement`.
   *
   * @example
   * ```jsx
   * class App extends React.Component {
   *     constructor(props) {
   *         super(props);
   *     }
   *     element = null;
   *     render() {
   *         return (
   *             <div>
   *                 <DateInput
   *                     ref={(dateInput) =>
   *                         this.element = dateInput ? dateInput.element : null}
   *                 />
   *                 <button onClick={() => console.log(this.element)}>console.log the element</button>
   *             </div>
   *         );
   *     }
   * }
   *
   * ReactDOM.render(
   *     <App />,
   *     document.getElementsByTagName('my-app')[0]
   * );
   * ```
   */
  get element() {
    return this._element;
  }
  /**
   * @hidden
   */
  get validityStyles() {
    return this.props.validityStyles !== void 0 ? this.props.validityStyles : Z.defaultProps.validityStyles;
  }
  /**
   * @hidden
   */
  get required() {
    return this.props.required !== void 0 ? this.props.required : Z.defaultProps.required;
  }
  /**
   * @hidden
   */
  get wrapper() {
    return this._wrapper;
  }
  /**
   * @hidden
   */
  intl() {
    return ct(this);
  }
  /*  end handlers */
  get selection() {
    let s = { start: 0, end: 0 };
    return this.element !== null && this.element.selectionStart !== void 0 && (s = { start: this.element.selectionStart, end: this.element.selectionEnd }), s;
  }
  setSelection(s) {
    this._lastSelectedSymbol = this.currentFormat[s.start], window.requestAnimationFrame(() => {
      const t = ot(document);
      this.element && t === this.element && !this.props.disableSelection && this.element.setSelectionRange(s.start, s.end);
    });
  }
  triggerChange(s, t) {
    this.valueDuringOnChange = this.value, this.forceUpdate(), this.props.onChange && !ht(t, this.value) && this.props.onChange.call(void 0, {
      syntheticEvent: s,
      nativeEvent: s.nativeEvent,
      value: this.value,
      target: this
      // inRange: this.props.min && this.props.max ? isInRange(value, this.props.min, this.props.max) : true
    }), this.valueDuringOnChange = void 0;
  }
  selectionBySymbol(s) {
    let t = -1, e = 0;
    for (let i = 0; i < this.currentFormat.length; i++)
      this.currentFormat[i] === s && (e = i + 1, t === -1 && (t = i));
    return t < 0 && (t = 0), { start: t, end: e };
  }
  selectionByIndex(s) {
    let t = { start: s, end: s };
    for (let e = s, i = s - 1; e < this.currentFormat.length || i >= 0; e++, i--) {
      if (e < this.currentFormat.length && this.currentFormat[e] !== "_") {
        t = this.selectionBySymbol(this.currentFormat[e]);
        break;
      }
      if (i >= 0 && this.currentFormat[i] !== "_") {
        t = this.selectionBySymbol(this.currentFormat[i]);
        break;
      }
    }
    return t;
  }
  switchDateSegment(s) {
    const { start: t, end: e } = this.selection;
    if (t < e && this.currentFormat[t] !== this.currentFormat[e - 1]) {
      this.setSelection(this.selectionByIndex(s > 0 ? t : e - 1));
      return;
    }
    const i = this.currentFormat[t];
    let a = t + s;
    for (; a > 0 && a < this.currentFormat.length && !(this.currentFormat[a] !== i && this.currentFormat[a] !== "_"); )
      a += s;
    if (this.currentFormat[a] === "_")
      return;
    let r = a;
    for (; r >= 0 && r < this.currentFormat.length && this.currentFormat[r] === this.currentFormat[a]; )
      r += s;
    a > r && (r + 1 !== t || a + 1 !== e) ? this.setSelection({ start: r + 1, end: a + 1 }) : a < r && (a !== t || r !== e) && this.setSelection({ start: a, end: r });
  }
  modifyDateSegmentValue(s, t) {
    if (!this.kendoDate)
      return;
    const e = this.value, i = this.currentFormat[this.selection.start], a = this.kendoDate.symbolMap(i), r = ((this.props.steps || {})[a] || 1) * s;
    this.kendoDate.modifyPart(i, r), this.triggerChange(t, e);
  }
};
let Ct = Z;
Ct.displayName = "DateInput";
Ct.propTypes = {
  value: n.instanceOf(Date),
  format: n.oneOfType([
    n.string,
    n.shape({
      skeleton: n.string,
      pattern: n.string,
      date: n.oneOf(["short", "medium", "long", "full"]),
      time: n.oneOf(["short", "medium", "long", "full"]),
      datetime: n.oneOf(["short", "medium", "long", "full"]),
      era: n.oneOf(["narrow", "short", "long"]),
      year: n.oneOf(["numeric", "2-digit"]),
      month: n.oneOf(["numeric", "2-digit", "narrow", "short", "long"]),
      day: n.oneOf(["numeric", "2-digit"]),
      weekday: n.oneOf(["narrow", "short", "long"]),
      hour: n.oneOf(["numeric", "2-digit"]),
      hour12: n.bool,
      minute: n.oneOf(["numeric", "2-digit"]),
      second: n.oneOf(["numeric", "2-digit"]),
      timeZoneName: n.oneOf(["short", "long"])
    })
  ]),
  formatPlaceholder: n.oneOfType([
    n.oneOf(["wide", "narrow", "short", "formatPattern"]),
    n.shape({
      year: n.string,
      month: n.string,
      day: n.string,
      hour: n.string,
      minute: n.string,
      second: n.string
    })
  ]),
  width: n.oneOfType([
    n.string,
    n.number
  ]),
  tabIndex: n.number,
  title: n.string,
  steps: n.shape({
    year: n.number,
    month: n.number,
    day: n.number,
    hour: n.number,
    minute: n.number,
    second: n.number
  }),
  min: n.instanceOf(Date),
  max: n.instanceOf(Date),
  disabled: n.bool,
  spinners: n.bool,
  name: n.string,
  dir: n.string,
  label: n.string,
  id: n.string,
  ariaLabelledBy: n.string,
  ariaDescribedBy: n.string,
  ariaLabel: n.string,
  ariaRole: n.string,
  ariaHasPopup: n.oneOfType([
    n.bool,
    n.string
  ]),
  ariaExpanded: n.oneOfType([
    n.bool
  ]),
  onChange: n.func,
  validationMessage: n.string,
  required: n.bool,
  validate: n.bool,
  valid: n.bool,
  size: n.oneOf([null, "small", "medium", "large"]),
  rounded: n.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: n.oneOf([null, "solid", "flat", "outline"])
};
Ct.defaultProps = {
  format: on,
  size: "medium",
  rounded: "medium",
  fillMode: "solid",
  formatPlaceholder: ln,
  // defaultValue: null as Date | null,
  spinners: !1,
  disabled: !1,
  max: v(dt),
  min: v(ut),
  minTime: v(Nt),
  maxTime: v(xt),
  required: !1,
  validityStyles: !0,
  validationMessage: Mn,
  placeholder: null,
  // the rest of the properties are undefined by default
  ariaHasPopup: "grid"
};
const Tn = Dt(), kt = yt(St(Tn, Ct));
kt.displayName = "KendoReactDateInput";
ft(Ct);
at(Ct);
const En = N, Vn = o.forwardRef((s, t) => {
  const { _ref: e } = s, i = o.useRef(null);
  o.useImperativeHandle(t, () => i.current), o.useImperativeHandle(e, () => i.current);
  const a = o.useMemo(
    () => P(s.className, "k-picker-wrap"),
    [s.className]
  );
  return /* @__PURE__ */ o.createElement(
    "span",
    {
      ref: i,
      id: s.id,
      style: s.style,
      className: a,
      tabIndex: s.tabIndex
    },
    s.children
  );
}), On = (s) => {
  const [t, e] = o.useState(!1), i = () => {
    s.current && e(!!s.current.text);
  };
  return o.useEffect(i), {
    editorValue: t
  };
}, cs = (s) => {
  const t = On(s.dateInput);
  return /* @__PURE__ */ o.createElement(
    Ls,
    {
      ...s,
      ...t
    }
  );
}, Ss = 500, Se = (s) => {
  const {
    footer: t,
    children: e,
    windowWidth: i = 0,
    navigatable: a,
    navigatableElements: r,
    expand: l,
    animation: c,
    onClose: h,
    adaptiveTitle: u,
    mobileFilter: d
  } = s, p = {
    navigatable: a || !1,
    navigatableElements: r || [],
    expand: l,
    animation: c !== !1,
    onClose: h,
    animationStyles: i <= Ss ? { top: 0, width: "100%", height: "100%" } : void 0,
    className: i <= Ss ? "k-adaptive-actionsheet k-actionsheet-fullscreen" : "k-adaptive-actionsheet k-actionsheet-bottom"
  };
  return /* @__PURE__ */ o.createElement(ci, { ...p }, /* @__PURE__ */ o.createElement(ui, { className: "k-text-center" }, /* @__PURE__ */ o.createElement("div", { className: "k-actionsheet-titlebar-group k-hbox" }, /* @__PURE__ */ o.createElement("div", { className: "k-actionsheet-title" }, /* @__PURE__ */ o.createElement("div", null, u)), /* @__PURE__ */ o.createElement("div", { className: "k-actionsheet-actions" }, /* @__PURE__ */ o.createElement(
    N,
    {
      tabIndex: 0,
      "aria-label": "Cancel",
      "aria-disabled": "false",
      type: "button",
      fillMode: "flat",
      icon: "x",
      svgIcon: oi,
      onClick: h
    }
  ))), d && /* @__PURE__ */ o.createElement("div", { className: "k-actionsheet-titlebar-group k-actionsheet-filter" }, d)), e, t && /* @__PURE__ */ o.createElement(di, { className: "k-actions k-actions-stretched" }, /* @__PURE__ */ o.createElement(
    N,
    {
      size: "large",
      tabIndex: 0,
      "aria-label": t.cancelText,
      "aria-disabled": "false",
      type: "button",
      onClick: t.onCancel
    },
    t.cancelText
  ), /* @__PURE__ */ o.createElement(
    N,
    {
      tabIndex: 0,
      themeColor: "primary",
      size: "large",
      "aria-label": t.applyText,
      "aria-disabled": "false",
      type: "button",
      onClick: t.onApply
    },
    t.applyText
  )));
}, xe = 768, B = class extends o.Component {
  constructor(s) {
    super(s), this._element = null, this._dateInput = o.createRef(), this._calendar = null, this.shouldFocusDateInput = !1, this.prevShow = !1, this.focus = () => {
      this.dateInput && this.dateInput.focus();
    }, this.setCalendarRef = (t) => {
      this._calendar = t;
    }, this.nextValue = (t, e) => t.value !== void 0 ? t.value : e.value, this.nextShow = (t, e) => t.show !== void 0 ? t.show : e.show, this.renderPopup = () => {
      const { disabled: t, min: e, max: i, weekNumber: a, focusedDate: r } = this.props, { popupClass: l, ...c } = this.props.popupSettings, h = this.show, u = this.value, d = u && x(u), p = P(
        "k-calendar-container k-group k-reset",
        l
      ), m = {
        popupClass: "k-datepicker-popup",
        show: h,
        anchor: this._element,
        className: p,
        id: this._popupId,
        anchorAlign: {
          horizontal: "left",
          vertical: "bottom"
        },
        popupAlign: {
          horizontal: "left",
          vertical: "top"
        },
        ...c
      }, f = {
        disabled: t,
        value: d,
        min: e,
        max: i,
        weekNumber: a,
        focusedDate: r,
        className: this.mobileMode ? "k-calendar-lg" : "",
        navigation: !this.mobileMode,
        onChange: this.handleCalendarValueChange
      };
      return this.mobileMode ? /* @__PURE__ */ o.createElement(this.calendarComp, { _ref: this.setCalendarRef, ...f }) : /* @__PURE__ */ o.createElement(this.popupComp, { ...m }, /* @__PURE__ */ o.createElement(this.calendarComp, { _ref: this.setCalendarRef, ...f }));
    }, this.renderAdaptivePopup = () => {
      const { windowWidth: t = 0 } = this.state, e = {
        expand: this.show,
        onClose: this.handleBlur,
        adaptiveTitle: this.props.adaptiveTitle,
        windowWidth: t
      };
      return /* @__PURE__ */ o.createElement(Se, { ...e }, /* @__PURE__ */ o.createElement(ke, { className: "!k-overflow-hidden" }, this.renderPopup()));
    }, this.handleInputValueChange = (t) => {
      this.handleValueChange(t.value, t);
    }, this.handleCalendarValueChange = (t) => {
      const e = this.mergeTime(t.value);
      this.handleValueChange(e, t);
    }, this.handleValueChange = (t, e) => {
      this.setState({
        value: v(t || void 0)
      }), this.valueDuringOnChange = t, this.showDuringOnChange = !1, this.mobileMode || (this.shouldFocusDateInput = !0);
      const { onChange: i } = this.props;
      i && i.call(void 0, {
        syntheticEvent: e.syntheticEvent,
        nativeEvent: e.nativeEvent,
        value: this.value,
        show: this.show,
        target: this
      }), this.valueDuringOnChange = void 0, this.showDuringOnChange = void 0, this.setShow(!1);
    }, this.handleFocus = () => {
      this.setState({ focused: !0 });
    }, this.handleBlur = () => {
      this.setState({ focused: !1 }), this.setShow(!1);
    }, this.handleIconClick = () => {
      this.props.disabled || (this.shouldFocusDateInput = !0, this.setShow(!this.show));
    }, this.handleIconMouseDown = (t) => {
      t.preventDefault();
    }, this.handleKeyDown = (t) => {
      const { altKey: e, keyCode: i } = t;
      if (i === C.esc) {
        this.shouldFocusDateInput = !0, this.setShow(!1);
        return;
      }
      e && (i === C.up || i === C.down) && (t.preventDefault(), t.stopPropagation(), this.shouldFocusDateInput = i === C.up, this.setShow(i === C.down));
    }, Pt(Rt), this.state = {
      value: this.props.defaultValue || B.defaultProps.defaultValue,
      show: this.props.defaultShow || B.defaultProps.defaultShow,
      focused: !1
    };
  }
  get _popupId() {
    return this.props.id + "-popup-id";
  }
  get document() {
    if (J)
      return this.element && this.element.ownerDocument || document;
  }
  /**
   * Gets the wrapping element of the DatePickerWithoutContext.
   */
  get element() {
    return this._element;
  }
  /**
   * The mobile mode of the DatePicker.
   */
  get mobileMode() {
    return !!(this.state.windowWidth && this.state.windowWidth <= xe && this.props.adaptive);
  }
  /**
   * Gets the DateInput component inside the DatePicker component.
   */
  get dateInput() {
    return this._dateInput.current;
  }
  /**
   * Gets the Calendar component inside the DatePicker component.
   */
  get calendar() {
    return this._calendar;
  }
  /**
   * Gets the value of the DatePickerWithoutContext.
   */
  get value() {
    const s = this.valueDuringOnChange !== void 0 ? this.valueDuringOnChange : this.props.value !== void 0 ? this.props.value : this.state.value;
    return s !== null ? v(s) : null;
  }
  /**
   * Gets the popup state of the DatePickerWithoutContext.
   */
  get show() {
    return this.showDuringOnChange !== void 0 ? this.showDuringOnChange : this.props.show !== void 0 ? this.props.show : this.state.show;
  }
  /**
   * Gets the `name` property of the DatePickerWithoutContext.
   */
  get name() {
    return this.props.name;
  }
  get min() {
    return this.props.min !== void 0 ? this.props.min : B.defaultProps.min;
  }
  get max() {
    return this.props.max !== void 0 ? this.props.max : B.defaultProps.max;
  }
  get dateInputComp() {
    return this.props.dateInput || B.defaultProps.dateInput;
  }
  get toggleButtonComp() {
    return this.props.toggleButton || B.defaultProps.toggleButton;
  }
  get calendarComp() {
    return this.props.calendar || B.defaultProps.calendar;
  }
  get popupComp() {
    return this.props.popup || B.defaultProps.popup;
  }
  get pickerWrapComp() {
    return this.props.pickerWrap || B.defaultProps.pickerWrap;
  }
  /**
   * Represents the validity state into which the DatePicker is set.
   */
  get validity() {
    const s = Hs(this.value, this.min, this.max), t = this.props.validationMessage !== void 0, e = (!this.required || this.value !== null) && s, i = this.props.valid !== void 0 ? this.props.valid : e;
    return {
      customError: t,
      rangeOverflow: this.value && this.max.getTime() < this.value.getTime() || !1,
      rangeUnderflow: this.value && this.value.getTime() < this.min.getTime() || !1,
      valid: i,
      valueMissing: this.value === null
    };
  }
  /**
   * @hidden
   */
  get validityStyles() {
    return this.props.validityStyles !== void 0 ? this.props.validityStyles : B.defaultProps.validityStyles;
  }
  /**
   * @hidden
   */
  get required() {
    return this.props.required !== void 0 ? this.props.required : B.defaultProps.required;
  }
  /**
   * @hidden
   */
  componentDidMount() {
    var s;
    this.observerResize = J && window.ResizeObserver && new window.ResizeObserver(this.calculateMedia.bind(this)), this.show && this.forceUpdate(), (s = this.document) != null && s.body && this.observerResize && this.observerResize.observe(this.document.body);
  }
  /**
   * @hidden
   */
  componentDidUpdate() {
    this._calendar && this._calendar.element && this.show && !this.prevShow && this._calendar.element.focus({ preventScroll: !0 }), this.dateInput && this.dateInput.element && !this.show && this.shouldFocusDateInput && this.dateInput.element.focus({ preventScroll: !0 }), this.prevShow = this.show, this.shouldFocusDateInput = !1;
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    var s;
    clearTimeout(this.nextTickId), (s = this.document) != null && s.body && this.observerResize && this.observerResize.disconnect();
  }
  /**
   * @hidden
   */
  render() {
    const {
      size: s = B.defaultProps.size,
      rounded: t = B.defaultProps.rounded,
      fillMode: e = B.defaultProps.fillMode,
      disabled: i,
      tabIndex: a,
      title: r,
      id: l,
      format: c,
      formatPlaceholder: h,
      min: u,
      max: d,
      className: p,
      width: m,
      name: f,
      validationMessage: y,
      required: I,
      validityStyles: M,
      ariaLabelledBy: w,
      ariaDescribedBy: E,
      ariaLabel: g
    } = this.props, H = this.show, V = this.value, R = !this.validityStyles || this.validity.valid, A = {
      disabled: i,
      format: c,
      formatPlaceholder: h,
      id: l,
      ariaLabelledBy: w,
      ariaDescribedBy: E,
      ariaLabel: g,
      max: d,
      min: u,
      name: f,
      onChange: this.handleInputValueChange,
      required: I,
      tabIndex: H ? -1 : a,
      title: r,
      valid: this.validity.valid,
      validationMessage: y,
      validityStyles: M,
      value: V,
      label: void 0,
      placeholder: this.state.focused ? null : this.props.placeholder,
      ariaExpanded: this.show,
      size: null,
      fillMode: null,
      rounded: null
    }, S = q(this).toLanguageString(We, T[We]), O = /* @__PURE__ */ o.createElement(
      we,
      {
        onFocus: this.handleFocus,
        onBlur: this.mobileMode ? void 0 : this.handleBlur,
        onSyncBlur: this.props.onBlur,
        onSyncFocus: this.props.onFocus
      },
      ({ onFocus: tt, onBlur: j }) => /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
        "span",
        {
          ref: (gt) => {
            this._element = gt;
          },
          className: P(
            "k-input",
            "k-datepicker",
            {
              [`k-input-${mt.sizeMap[s] || s}`]: s,
              [`k-rounded-${mt.roundedMap[t] || t}`]: t,
              [`k-input-${e}`]: e,
              ["k-invalid"]: !R,
              ["k-required"]: this.required,
              ["k-disabled"]: this.props.disabled
            },
            p
          ),
          onKeyDown: this.handleKeyDown,
          style: { width: m },
          onFocus: tt,
          onBlur: j,
          onClick: this.mobileMode ? this.handleIconClick : void 0
        },
        /* @__PURE__ */ o.createElement(
          this.dateInputComp,
          {
            _ref: this._dateInput,
            ariaRole: "combobox",
            readonly: this.mobileMode,
            ariaExpanded: this.show,
            ariaControls: this._popupId,
            ...A
          }
        ),
        /* @__PURE__ */ o.createElement(
          this.toggleButtonComp,
          {
            type: "button",
            icon: "calendar",
            svgIcon: Fs,
            title: S,
            className: "k-input-button",
            rounded: null,
            onClick: this.mobileMode ? void 0 : this.handleIconClick,
            "aria-label": S,
            onMouseDown: this.handleIconMouseDown
          }
        ),
        !this.mobileMode && this.renderPopup()
      ), this.mobileMode && this.renderAdaptivePopup())
    );
    return this.props.label ? /* @__PURE__ */ o.createElement(
      cs,
      {
        dateInput: this._dateInput,
        label: this.props.label,
        editorId: l,
        editorValid: R,
        editorDisabled: this.props.disabled,
        children: O,
        style: { width: this.props.width }
      }
    ) : O;
  }
  setShow(s) {
    const { onOpen: t, onClose: e } = this.props;
    this.show !== s && (this.setState({ show: s }), s && t && t.call(void 0, {
      target: this
    }), !s && e && e.call(void 0, {
      target: this
    }));
  }
  mergeTime(s) {
    return this.value && s ? W(s, this.value) : s;
  }
  nextTick(s) {
    clearTimeout(this.nextTickId), this.nextTickId = window.setTimeout(() => s());
  }
  calculateMedia(s) {
    for (let t of s)
      this.setState({ windowWidth: t.target.clientWidth });
  }
};
let Xt = B;
Xt.displayName = "DatePicker";
Xt.propTypes = {
  className: n.string,
  defaultShow: n.bool,
  defaultValue: n.instanceOf(Date),
  disabled: n.bool,
  focusedDate: n.instanceOf(Date),
  format: n.oneOfType([
    n.string,
    n.shape({
      skeleton: n.string,
      pattern: n.string,
      date: n.oneOf(["short", "medium", "long", "full"]),
      time: n.oneOf(["short", "medium", "long", "full"]),
      datetime: n.oneOf(["short", "medium", "long", "full"]),
      era: n.oneOf(["narrow", "short", "long"]),
      year: n.oneOf(["numeric", "2-digit"]),
      month: n.oneOf(["numeric", "2-digit", "narrow", "short", "long"]),
      day: n.oneOf(["numeric", "2-digit"]),
      weekday: n.oneOf(["narrow", "short", "long"]),
      hour: n.oneOf(["numeric", "2-digit"]),
      hour12: n.bool,
      minute: n.oneOf(["numeric", "2-digit"]),
      second: n.oneOf(["numeric", "2-digit"]),
      timeZoneName: n.oneOf(["short", "long"])
    })
  ]),
  formatPlaceholder: n.oneOfType([
    n.oneOf(["wide", "narrow", "short", "formatPattern"]),
    n.shape({
      year: n.string,
      month: n.string,
      day: n.string,
      hour: n.string,
      minute: n.string,
      second: n.string
    })
  ]),
  id: n.string,
  ariaLabelledBy: n.string,
  ariaDescribedBy: n.string,
  ariaLabel: n.string,
  min: n.instanceOf(Date),
  max: n.instanceOf(Date),
  name: n.string,
  popupSettings: n.shape({
    animate: n.bool,
    appendTo: n.any,
    popupClass: n.string
  }),
  show: n.bool,
  tabIndex: n.number,
  title: n.string,
  value: n.instanceOf(Date),
  weekNumber: n.bool,
  width: n.oneOfType([n.number, n.string]),
  validationMessage: n.string,
  required: n.bool,
  validate: n.bool,
  valid: n.bool,
  size: n.oneOf([null, "small", "medium", "large"]),
  rounded: n.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: n.oneOf([null, "solid", "flat", "outline"]),
  adaptive: n.bool,
  adaptiveTitle: n.string
};
Xt.defaultProps = {
  defaultShow: !1,
  defaultValue: null,
  dateInput: kt,
  calendar: as,
  toggleButton: En,
  popup: be,
  pickerWrap: Vn,
  disabled: !1,
  format: "d",
  max: dt,
  min: ut,
  popupSettings: {},
  tabIndex: 0,
  weekNumber: !1,
  required: !1,
  validityStyles: !0,
  size: "medium",
  rounded: "medium",
  fillMode: "solid"
};
const Pn = Dt(), Rn = yt(St(Pn, Xt));
Rn.displayName = "KendoReactDatePicker";
at(Xt);
const Ne = (s, t) => {
  const e = v(s);
  return e.setHours(t), e;
}, _e = (s) => s !== null && s < 12, Nn = (s) => s !== null && (!s || s > 11), _n = (s, t, e) => !t && !e || s >= t && s <= e, Fn = (s, t, e) => !t && !e || s >= t || s <= e;
class Ln {
  constructor(t) {
    this.intl = t, this.min = null, this.max = null, this.part = null;
  }
  /**
   * @hidden
   */
  apply(t, e) {
    const i = t.getHours(), a = _e(i), r = _e(e.getHours());
    if (a && r || !a && !r)
      return t;
    const [l, c = 24] = this.normalizedRange(), h = i + (r ? -12 : 12);
    return Ne(t, Math.min(Math.max(l, h), c || 24));
  }
  /**
   * @hidden
   */
  configure(t) {
    const { min: e = this.min, max: i = this.max, part: a = this.part } = t;
    this.min = e, this.max = i, this.part = a;
  }
  /**
   * @hidden
   */
  data(t) {
    const e = this.part && this.part.names;
    if (!e || !this.min)
      return [];
    const i = [], [a, r] = this.normalizedRange(), l = this.intl.dateFormatNames(e);
    return _e(a) && i.push({ text: l.am, value: Ne(this.min, a) }), Nn(r) && i.push({ text: l.pm, value: Ne(this.min, Math.max(12, r)) }), this.min.getHours() !== a ? i.reverse() : i;
  }
  /**
   * @hidden
   */
  isRangeChanged(t, e) {
    return !1;
  }
  /**
   * @hidden
   */
  limitRange(t, e, i) {
    return [t, e];
  }
  /**
   * @hidden
   */
  total() {
    const [t, e] = this.normalizedRange();
    return !t && !e ? 2 : t > 11 || e < 12 ? 1 : 2;
  }
  /**
   * @hidden
   */
  selectedIndex(t) {
    if (!this.valueInList(t) || !this.min)
      return -1;
    const e = Math.floor(t.getHours() / 12);
    return this.min.getHours() === this.normalizedRange()[0] ? e : e === 0 ? 1 : 0;
  }
  /**
   * @hidden
   */
  valueInList(t) {
    return !this.min || !this.max ? !1 : (this.min.getHours() !== this.normalizedRange()[0] ? Fn : _n)(t.getHours(), this.min.getHours(), this.max.getHours());
  }
  normalizedRange() {
    const t = this.min.getHours(), e = this.max.getHours();
    return [
      Math.min(t, e),
      Math.max(t, e)
    ];
  }
}
class Hn {
  constructor() {
    this.itemHeight = 0, this.timeListHeight = 0, this.didCalculate = !1;
  }
  ensureHeights() {
    this.timeListHeight === void 0 && this.calculateHeights();
  }
  calculateHeights(t) {
    if (!J)
      return;
    const e = Y("div"), i = Y("span"), a = Y("ul"), r = Y("li"), l = () => r("<span>02</span>", "k-item"), c = () => a([l()], "k-reset"), h = () => e([c()], "k-content k-scrollable k-time-container"), d = (() => e(
      [
        i("minute", "k-title"),
        e([h()], "k-time-list")
      ],
      "k-time-list-wrapper",
      { left: "-10000px", position: "absolute" }
    ))(), m = t && t.querySelector(".k-time-container") || document.body, f = m.appendChild(d);
    this.timeListHeight = f.querySelector(".k-scrollable").offsetHeight, this.itemHeight = f.querySelector("li").offsetHeight, m.removeChild(f), this.didCalculate = !0;
  }
}
const us = 24, An = (s) => (t) => t % s, Ks = An(us), Bn = (s, t) => (e) => Ks(s + e * t), xs = (s, t) => Ks(us + s - t), js = (s) => (t, e) => !e || x(t).getTime() === x(e).getTime() ? t : de(t, s), zn = js(0), qn = js(us - 1);
class Wn {
  constructor(t) {
    this.intl = t, this.boundRange = !1, this.insertUndividedMax = !1, this.min = null, this.max = null, this.step = 0, this.toListItem = null;
  }
  apply(t, e) {
    return de(t, e.getHours());
  }
  configure(t) {
    const {
      boundRange: e = this.boundRange,
      insertUndividedMax: i = this.insertUndividedMax,
      min: a = this.min,
      max: r = this.max,
      part: l,
      step: c = this.step
    } = t;
    this.boundRange = e, this.insertUndividedMax = i, this.toListItem = (h) => {
      const u = de(L, h);
      return {
        text: this.intl.formatDate(u, l.pattern),
        value: u
      };
    }, this.min = a, this.max = r, this.step = c;
  }
  data(t) {
    const [e] = this.range(t), i = Bn(e, this.step), a = (l) => this.toListItem && this.toListItem(i(l)), r = os(0, this.countFromMin(t)).map(a);
    return this.addLast(r), t && this.addMissing(r, t), r;
  }
  isRangeChanged(t, e) {
    return !this.min || !this.max ? !1 : !ht(this.min, t) || !ht(this.max, e);
  }
  limitRange(t, e, i) {
    return this.boundRange ? [zn(t, i), qn(e, i)] : [t, e];
  }
  total(t) {
    const e = this.insertUndividedMax && this.isLastMissing(t) ? 1 : 0, i = this.isMissing(t) ? 1 : 0;
    return this.countFromMin(t) + i + e;
  }
  selectedIndex(t) {
    return Math.ceil(this.divideByStep(t));
  }
  valueInList(t) {
    return t ? this.insertUndividedMax && this.lastHour(t) === t.getHours() || !this.isMissing(t) : !0;
  }
  addLast(t, e) {
    return this.insertUndividedMax && this.isLastMissing(e) && this.toListItem && t.push(this.toListItem(this.lastHour(e))), t;
  }
  addMissing(t, e) {
    if (this.valueInList(e))
      return t;
    if (this.toListItem) {
      const i = this.toListItem(e.getHours());
      t.splice(this.selectedIndex(e), 0, i);
    }
    return t;
  }
  countFromMin(t) {
    const [e, i] = this.range(t);
    return Math.floor(xs(i, e) / this.step) + 1;
  }
  isMissing(t) {
    return t ? this.selectedIndex(t) !== this.divideByStep(t) : !1;
  }
  isLastMissing(t) {
    return this.max !== null && this.isMissing(de(this.max, this.lastHour(t)));
  }
  divideByStep(t) {
    return xs(t.getHours(), this.min.getHours()) / this.step;
  }
  lastHour(t) {
    return this.range(t)[1];
  }
  range(t) {
    const [e, i] = this.limitRange(this.min, this.max, t);
    return [e.getHours(), i.getHours()];
  }
}
const ds = 60, Un = (s) => (t) => t % s, Zs = Un(ds), $n = (s, t) => (e) => Zs(s + e * t), Cs = (s, t) => Zs(ds + s - t), Gs = (s) => (t, e) => !e || t.getHours() === e.getHours() ? t : pe(t, s), Yn = Gs(0), Kn = Gs(ds - 1);
class jn {
  constructor(t) {
    this.intl = t, this.toListItem = null, this.min = null, this.max = null, this.step = 0, this.insertUndividedMax = !1;
  }
  apply(t, e) {
    return pe(t, e.getMinutes());
  }
  configure(t) {
    const {
      insertUndividedMax: e = this.insertUndividedMax,
      min: i = this.min,
      max: a = this.max,
      part: r,
      step: l = this.step
    } = t;
    this.insertUndividedMax = e, this.toListItem = (c) => {
      const h = pe(L, c);
      return {
        text: this.intl.formatDate(h, r.pattern),
        value: h
      };
    }, this.min = i, this.max = a, this.step = l;
  }
  data(t) {
    const [e] = this.range(t), i = $n(e, this.step), a = (l) => this.toListItem && this.toListItem(i(l)), r = os(0, this.countFromMin(t)).map(a);
    return this.addLast(r), t && this.addMissing(r, t), r;
  }
  isRangeChanged(t, e) {
    return this.min !== null && this.max !== null && (!ht(this.min, t) || !ht(this.max, e));
  }
  limitRange(t, e, i) {
    return [Yn(t, i), Kn(e, i)];
  }
  total(t) {
    const e = this.insertUndividedMax && this.isLastMissing(t) ? 1 : 0, i = this.isMissing(t) ? 1 : 0;
    return this.countFromMin(t) + i + e;
  }
  selectedIndex(t) {
    return Math.ceil(this.divideByStep(t));
  }
  valueInList(t) {
    return t ? this.insertUndividedMax && this.lastMinute(t) === t.getMinutes() || !this.isMissing(t) : !0;
  }
  addLast(t, e) {
    return this.insertUndividedMax && this.isLastMissing(e) && this.toListItem && t.push(this.toListItem(this.lastMinute(e))), t;
  }
  addMissing(t, e) {
    if (this.valueInList(e))
      return t;
    if (this.toListItem) {
      const i = this.toListItem(e.getMinutes());
      t.splice(this.selectedIndex(e), 0, i);
    }
    return t;
  }
  countFromMin(t) {
    const [e, i] = this.range(t);
    return Math.floor(Cs(i, e) / this.step) + 1;
  }
  isMissing(t) {
    return t ? this.selectedIndex(t) !== this.divideByStep(t) : !1;
  }
  isLastMissing(t) {
    return this.max !== null && this.isMissing(pe(this.max, this.lastMinute(t)));
  }
  divideByStep(t) {
    return Cs(t.getMinutes(), this.min.getMinutes()) / this.step;
  }
  lastMinute(t) {
    return this.range(t)[1];
  }
  range(t) {
    const [e, i] = this.limitRange(this.min, this.max, t);
    return [e.getMinutes(), i.getMinutes()];
  }
}
const ps = 60, Zn = (s) => (t) => t % s, Xs = Zn(ps), Gn = (s, t) => (e) => Xs(s + e * t), Is = (s, t) => Xs(ps + s - t), Js = (s) => (t, e) => !e || t.getMinutes() === e.getMinutes() && t.getHours() === e.getHours() ? t : me(t, s), Xn = Js(0), Jn = Js(ps - 1);
class Qn {
  constructor(t) {
    this.intl = t, this.toListItem = null, this.min = null, this.max = null, this.step = 0, this.insertUndividedMax = !1;
  }
  apply(t, e) {
    return me(t, e.getSeconds());
  }
  configure(t) {
    const {
      insertUndividedMax: e = this.insertUndividedMax,
      min: i = this.min,
      max: a = this.max,
      part: r,
      step: l = this.step
    } = t;
    this.insertUndividedMax = e, this.toListItem = (c) => {
      const h = me(L, c);
      return {
        text: this.intl.formatDate(h, r.pattern),
        value: h
      };
    }, this.min = i, this.max = a, this.step = l;
  }
  data(t) {
    const [e] = this.range(t), i = Gn(e, this.step), a = (l) => this.toListItem && this.toListItem(i(l)), r = os(0, this.countFromMin(t)).map(a);
    return this.addLast(r), t && this.addMissing(r, t), r;
  }
  isRangeChanged(t, e) {
    return this.min !== null && this.max !== null && (!ht(this.min, t) || !ht(this.max, e));
  }
  limitRange(t, e, i) {
    return [Xn(t, i), Jn(e, i)];
  }
  total(t) {
    const e = this.insertUndividedMax && this.isLastMissing(t) ? 1 : 0, i = this.isMissing(t) ? 1 : 0;
    return this.countFromMin(t) + i + e;
  }
  selectedIndex(t) {
    return Math.ceil(this.divideByStep(t));
  }
  valueInList(t) {
    return t ? this.insertUndividedMax && this.lastSecond(t) === t.getSeconds() || !this.isMissing(t) : !0;
  }
  divideByStep(t) {
    return Is(t.getSeconds(), this.min.getSeconds()) / this.step;
  }
  addLast(t, e) {
    return this.insertUndividedMax && this.isLastMissing(e) && this.toListItem && t.push(this.toListItem(this.lastSecond(e))), t;
  }
  addMissing(t, e) {
    if (this.valueInList(e))
      return t;
    if (this.toListItem) {
      const i = this.toListItem(e.getSeconds());
      t.splice(this.selectedIndex(e), 0, i);
    }
    return t;
  }
  countFromMin(t) {
    const [e, i] = this.range(t);
    return Math.floor(Is(i, e) / this.step) + 1;
  }
  isMissing(t) {
    return t ? this.selectedIndex(t) !== this.divideByStep(t) : !1;
  }
  isLastMissing(t) {
    return this.max !== null && this.isMissing(me(this.max, this.lastSecond(t)));
  }
  lastSecond(t) {
    return this.range(t)[1];
  }
  range(t) {
    const [e, i] = this.limitRange(this.min, this.max, t);
    return [e.getSeconds(), i.getSeconds()];
  }
}
const ta = 2, Ms = 0.05, ea = 100, sa = 0, Ts = 9, ia = {
  [C.end]: (s, t) => s[s.length - 1],
  [C.home]: (s, t) => s[0],
  [C.up]: (s, t) => s[t - 1],
  [C.down]: (s, t) => s[t + 1]
}, es = {
  [X.dayperiod]: Ln,
  [X.hour]: Wn,
  [X.minute]: jn,
  [X.second]: Qn
}, Tt = class extends o.Component {
  constructor(s) {
    super(s), this.intl = null, this._element = null, this.service = null, this.virtualization = null, this.topOffset = 0, this.bottomOffset = 0, this.itemHeight = 0, this.listHeight = 0, this.topThreshold = 0, this.bottomThreshold = 0, this.animateToIndex = !1, this.focus = (t) => {
      Promise.resolve().then(() => {
        this.element && this.element.focus(t);
      });
    }, this.itemOffset = (t) => {
      if (!this.virtualization || !this.service)
        return -1;
      const e = this.service.selectedIndex(this.props.value), i = this.virtualization.activeIndex(), a = this.virtualization.itemOffset(i), r = Math.abs(Math.ceil(t) - a);
      if (e === i && r < ta)
        return a;
      const l = e > i;
      return l && r >= this.bottomThreshold || !l && r > this.topThreshold ? this.virtualization.itemOffset(i + 1) : a;
    }, this.calculateHeights = () => {
      this.dom.didCalculate && (this.itemHeight = this.dom.itemHeight, this.listHeight = this.dom.timeListHeight, this.topOffset = (this.listHeight - this.itemHeight) / 2, this.bottomOffset = this.listHeight - this.itemHeight, this.props.mobileMode && (this.topOffset += Ts, this.bottomOffset += Ts * 2), this.topThreshold = this.itemHeight * Ms, this.bottomThreshold = this.itemHeight * (1 - Ms));
    }, this.configureServices = ({ min: t, max: e, value: i } = this.props) => {
      if (this.service) {
        const [a, r] = this.service.limitRange(t || this.min, e || this.max, i || this.props.value);
        this.service.configure(this.serviceSettings({ min: a, max: r }));
      }
    }, this.serviceSettings = (t) => {
      const e = {
        boundRange: this.props.boundRange || Tt.defaultProps.boundRange,
        insertUndividedMax: !1,
        min: v(this.min),
        max: v(this.max),
        part: this.props.part,
        step: this.step
      }, i = Object.assign({}, e, t);
      return i.boundRange = i.part.type !== "hour" || this.props.boundRange || Tt.defaultProps.boundRange, i;
    }, this.handleScrollAction = ({ target: t, animationInProgress: e }) => {
      if (!(!this.virtualization || !this.service) && t && !e) {
        this.animateToIndex = !1;
        const i = this.virtualization.itemIndex(this.itemOffset(t.scrollTop)), a = this.service.data(this.props.value)[i];
        this.handleChange(a);
      }
    }, this.handleFocus = (t) => {
      const { onFocus: e } = this.props;
      e && e.call(void 0, t);
    }, this.handleBlur = (t) => {
      const { onBlur: e } = this.props;
      e && e.call(void 0, t);
    }, this.handleMouseOver = () => {
      if (!this._element)
        return;
      const t = ot(document);
      document && t !== this._element && this.props.show && this._element.focus({ preventScroll: !0 });
    }, this.handleKeyDown = (t) => {
      if (!this.service)
        return;
      const { keyCode: e } = t;
      (e === C.down || e === C.up || e === C.end || e === C.home) && t.preventDefault();
      const a = (ia[t.keyCode] || Rs)(
        this.service.data(this.props.value),
        this.service.selectedIndex(this.props.value)
      );
      a && this.handleChange(a);
    }, this.handleChange = Ci((t) => {
      if (!this.service)
        return;
      const e = this.service.apply(this.props.value, t.value);
      if (this.props.value.getTime() === e.getTime())
        return;
      const { onChange: i } = this.props;
      i && i.call(void 0, e);
    }, ea), this.dom = new Hn();
  }
  get element() {
    return this._element;
  }
  get animate() {
    return !!(this.props.smoothScroll && this.animateToIndex);
  }
  get min() {
    return this.props.min || Tt.defaultProps.min;
  }
  get max() {
    return this.props.max || Tt.defaultProps.max;
  }
  get step() {
    return this.props.step !== void 0 && this.props.step !== 0 ? Math.floor(this.props.step) : Tt.defaultProps.step;
  }
  /**
   * @hidden
   */
  componentDidMount() {
    Promise.resolve().then(() => {
      this._element && (this.dom.calculateHeights(this._element), this.forceUpdate());
    });
  }
  /**
   * @hidden
   */
  componentDidUpdate() {
    if (!this.virtualization || !this.service)
      return;
    const s = this.service.selectedIndex(this.props.value);
    this.virtualization[this.animate ? "animateToIndex" : "scrollToIndex"](s), this.animateToIndex = !0;
  }
  /**
   * @hidden
   */
  render() {
    if (!this.props.part.type || !es[this.props.part.type])
      return;
    this.calculateHeights(), this.intl = ct(this), this.service = new es[this.props.part.type](this.intl), this.configureServices();
    const s = this.service.data(this.props.value), t = "translateY(" + this.topOffset + "px)", e = this.service.total(this.props.value), i = /* @__PURE__ */ o.createElement(
      "ul",
      {
        style: { transform: t, msTransform: t },
        className: "k-reset"
      },
      s.map((a, r) => /* @__PURE__ */ o.createElement(
        "li",
        {
          key: r,
          className: "k-item",
          onClick: () => {
            this.handleChange(a);
          }
        },
        /* @__PURE__ */ o.createElement("span", null, a.text)
      ))
    );
    return /* @__PURE__ */ o.createElement(
      "div",
      {
        className: "k-time-list",
        id: String(this.props.id || ""),
        tabIndex: this.props.disabled ? -1 : 0,
        ref: (a) => {
          this._element = a;
        },
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onMouseOver: this.handleMouseOver
      },
      this.dom.didCalculate ? /* @__PURE__ */ o.createElement(
        Kt,
        {
          bottomOffset: this.bottomOffset,
          children: i,
          className: "k-time-container",
          itemHeight: this.itemHeight,
          maxScrollDifference: this.listHeight,
          onScrollAction: this.handleScrollAction,
          ref: (a) => {
            this.virtualization = a;
          },
          role: "presentation",
          skip: sa,
          tabIndex: -1,
          take: e,
          topOffset: this.topOffset,
          total: e
        }
      ) : /* @__PURE__ */ o.createElement("div", { className: "k-time-container" }, i)
    );
  }
};
let Ce = Tt;
Ce.propTypes = {
  id: n.number,
  max: n.instanceOf(Date),
  min: n.instanceOf(Date),
  part: function(s, t, e) {
    const i = s[t];
    if (!i || !es[i.type])
      throw new Error(`
                    Invalid prop '${t}' supplied to ${e}.
                    Supported part types are hour|minute|second|dayperiod.
                `);
    return null;
  },
  step: function(s, t, e) {
    const i = s[t];
    if (i !== void 0 && i <= 0)
      throw new Error(`
                    Invalid prop '${t}' supplied to ${e}.
                    ${t} cannot be less than 1.
                `);
    return null;
  },
  value: n.instanceOf(Date),
  smoothScroll: n.bool,
  show: n.bool
};
Ce.defaultProps = {
  boundRange: !1,
  max: xt,
  min: L,
  step: 1,
  smoothScroll: !0
};
ft(Ce);
const Fe = new RegExp(`${X.hour}|${X.minute}|${X.second}|${X.dayperiod}|literal`), vt = class extends o.Component {
  constructor(s) {
    super(s), this._element = null, this._nowButton = null, this.dateFormatParts = [], this.timeLists = [], this.focus = (t) => {
      Promise.resolve().then(() => {
        const e = this.timeLists[0];
        this.state.activeListIndex === -1 && !this.hasActiveButton() && e && e.element && e.focus(t);
      });
    }, this.timeFormatReducer = (t, e) => t + e.pattern, this.timeFormatFilter = (t, e, i) => {
      const a = e >= 1 && i[e - 1];
      return a && a && t.type === "literal" ? Fe.test(a.type || "") : Fe.test(t.type || "");
    }, this.focusList = (t) => {
      this.timeLists.length && this.timeLists.reduce(this.listReducer, []).map((e) => t === 1 ? e.next : e.prev).map((e) => e && e.element && e.element.focus({ preventScroll: !0 }));
    }, this.listReducer = (t, e, i, a) => t.length || e.props.id !== this.state.activeListIndex ? t : [{
      next: a[i + 1] || e,
      prev: a[i - 1] || e
    }], this.showNowButton = () => !this.hasSteps() && this.props.nowButton && hs(Vt(), this.min, this.max), this.handleKeyDown = (t) => {
      const { keyCode: e } = t;
      switch (e) {
        case C.left:
          t.preventDefault(), this.focusList(
            0
            /* Left */
          );
          return;
        case C.right:
          t.preventDefault(), this.focusList(
            1
            /* Right */
          );
          return;
        default:
          return;
      }
    }, this.handleListBlur = () => {
      this.nextTick(() => {
        this.setState({ activeListIndex: -1 });
      });
    }, this.handleListFocus = (t) => {
      clearTimeout(this.nextTickId), this.setState({
        activeListIndex: t
      });
    }, this.handleChange = (t) => {
      const { onChange: e } = this.props;
      e && e.call(void 0, t);
    }, this.snapTime = ys(
      Ds(this.props.steps, this.props.min || vt.defaultProps.min)
    ), this.state = {
      activeListIndex: -1
    }, this.hasActiveButton = this.hasActiveButton.bind(this);
  }
  /**
   * @hidden
   */
  get element() {
    return this._element;
  }
  get value() {
    return Sn(
      this.snapTime(v(this.props.value || L)),
      this.min,
      this.max
    );
  }
  get intl() {
    return ct(this);
  }
  get min() {
    return this.snapTime(this.props.min || vt.defaultProps.min);
  }
  get max() {
    return this.snapTime(this.props.max || vt.defaultProps.max);
  }
  get steps() {
    return this.props.steps || vt.defaultProps.steps;
  }
  get boundRange() {
    return this.props.boundRange !== void 0 ? this.props.boundRange : vt.defaultProps.boundRange;
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    clearTimeout(this.nextTickId);
  }
  componentDidMount() {
    const { onMount: s } = this.props;
    s && s.call(void 0, this.value);
  }
  /**
   * @hidden
   */
  render() {
    const {
      format: s,
      smoothScroll: t,
      onNowClick: e,
      className: i,
      disabled: a,
      mobileMode: r,
      show: l
    } = this.props;
    this.snapTime = ys(Ds(this.steps, this.min)), this.dateFormatParts = this.intl.splitDateFormat(s || vt.defaultProps.format).filter(this.timeFormatFilter);
    const c = P(
      {
        "k-disabled": a,
        "k-time-part": r
      },
      i
    );
    this.timeLists = [];
    const h = q(this), u = h.toLanguageString(je, T[je]);
    return /* @__PURE__ */ o.createElement("div", { className: c }, /* @__PURE__ */ o.createElement("div", { className: "k-time-header" }, /* @__PURE__ */ o.createElement("span", { className: "k-title" }, this.intl.formatDate(this.value, this.dateFormatParts.reduce(this.timeFormatReducer, ""))), this.showNowButton() && /* @__PURE__ */ o.createElement(
      N,
      {
        type: "button",
        ref: (d) => {
          this._nowButton = d;
        },
        className: "k-time-now",
        fillMode: "flat",
        themeColor: "primary",
        title: u,
        "aria-label": u,
        onClick: e,
        tabIndex: a ? -1 : 0
      },
      h.toLanguageString(Ke, T[Ke])
    )), /* @__PURE__ */ o.createElement(
      "div",
      {
        className: "k-time-list-container",
        onKeyDown: this.handleKeyDown
      },
      /* @__PURE__ */ o.createElement("span", { className: "k-time-highlight" }),
      this.dateFormatParts.map((d, p) => d.type !== "literal" ? /* @__PURE__ */ o.createElement(
        "div",
        {
          key: p,
          className: P("k-time-list-wrapper", {
            "k-focus": p === this.state.activeListIndex
          }),
          role: "presentation",
          tabIndex: -1
        },
        /* @__PURE__ */ o.createElement("span", { className: "k-title", onMouseDown: (m) => {
          m.preventDefault();
        } }, this.intl.dateFieldName(d)),
        /* @__PURE__ */ o.createElement(
          Ce,
          {
            min: this.min,
            max: this.max,
            boundRange: this.boundRange,
            part: d,
            step: d.type ? this.steps[d.type] : 1,
            smoothScroll: t,
            ref: (m) => {
              m && this.timeLists.push(m);
            },
            id: p,
            onFocus: () => {
              this.handleListFocus(p);
            },
            onBlur: this.handleListBlur,
            onChange: this.handleChange,
            value: this.value,
            disabled: a,
            show: l,
            mobileMode: r
          }
        )
      ) : /* @__PURE__ */ o.createElement(
        "div",
        {
          key: p,
          className: "k-time-separator"
        },
        d.pattern
      ))
    ));
  }
  nextTick(s) {
    clearTimeout(this.nextTickId), this.nextTickId = window.setTimeout(() => s());
  }
  hasActiveButton() {
    const s = ot(document);
    return this._nowButton && s === this._nowButton.element;
  }
  hasSteps() {
    const s = Object.keys(this.steps);
    return s.length !== s.reduce((t, e) => t + this.steps[e], 0);
  }
};
let _t = vt;
_t.propTypes = {
  cancelButton: n.bool,
  disabled: n.bool,
  format: n.oneOfType([
    n.string,
    n.shape({
      skeleton: n.string,
      pattern: n.string,
      date: n.oneOf(["short", "medium", "long", "full"]),
      time: n.oneOf(["short", "medium", "long", "full"]),
      datetime: n.oneOf(["short", "medium", "long", "full"]),
      era: n.oneOf(["narrow", "short", "long"]),
      year: n.oneOf(["numeric", "2-digit"]),
      month: n.oneOf(["numeric", "2-digit", "narrow", "short", "long"]),
      day: n.oneOf(["numeric", "2-digit"]),
      weekday: n.oneOf(["narrow", "short", "long"]),
      hour: n.oneOf(["numeric", "2-digit"]),
      hour12: n.bool,
      minute: n.oneOf(["numeric", "2-digit"]),
      second: n.oneOf(["numeric", "2-digit"]),
      timeZoneName: n.oneOf(["short", "long"])
    })
  ]),
  max: n.instanceOf(Date),
  min: n.instanceOf(Date),
  nowButton: n.bool,
  steps: n.shape({
    hour: n.number,
    minute: n.number,
    second: n.number
  }),
  smoothScroll: n.bool,
  tabIndex: n.number,
  value: n.instanceOf(Date),
  show: n.bool
};
_t.defaultProps = {
  value: null,
  disabled: !1,
  nowButton: !0,
  cancelButton: !0,
  format: "hh:mm a",
  min: Nt,
  max: xt,
  steps: {},
  boundRange: !1
};
ft(_t);
at(_t);
const ss = class extends o.Component {
  constructor(s) {
    super(s), this._element = null, this._cancelButton = null, this._acceptButton = null, this.timePart = null, this.focusActiveList = () => {
      this.timePart && this.timePart.focus({ preventScroll: !0 });
    }, this.handleKeyDown = (t) => {
      const { keyCode: e } = t;
      switch (e) {
        case C.enter:
          this.hasActiveButton() || this.handleAccept(t);
          return;
        default:
          return;
      }
    }, this.handleAccept = (t) => {
      const e = this.mergeValue(
        v(this.value || Vt()),
        this.timePart ? this.timePart.value : this.current
      );
      this.setState({ value: e }), this.valueDuringOnChange = e;
      const { onChange: i } = this.props;
      i && i.call(void 0, {
        syntheticEvent: t,
        nativeEvent: t.nativeEvent,
        value: this.value,
        target: this
      }), this.valueDuringOnChange = void 0;
    }, this.handleReject = (t) => {
      this.setState({ current: this.value });
      const { onReject: e } = this.props;
      e && e.call(void 0, t);
    }, this.handleNowClick = (t) => {
      const e = this.mergeValue(
        v(this.value || Vt()),
        Vt()
      );
      this.setState({
        current: e,
        value: e
      }), this.valueDuringOnChange = e;
      const { onChange: i } = this.props;
      i && i.call(void 0, {
        syntheticEvent: t,
        nativeEvent: t.nativeEvent,
        value: this.value,
        target: this
      }), this.valueDuringOnChange = void 0;
    }, this.handleChange = (t) => {
      this.setState({ current: t });
      const { handleTimeChange: e } = this.props;
      e && e.call(void 0, {
        time: t
      });
    }, this.dateFormatParts = this.intl.splitDateFormat(this.props.format || ss.defaultProps.format), this.mergeValue = yn(Dn(this.dateFormatParts)), this.hasActiveButton = this.hasActiveButton.bind(this), this.state = {
      current: this.props.value || L,
      value: this.props.value || ss.defaultProps.value
    };
  }
  /**
   * @hidden
   */
  get element() {
    return this._element;
  }
  get value() {
    const s = this.valueDuringOnChange !== void 0 ? this.valueDuringOnChange : this.props.value !== void 0 ? this.props.value : this.state.value;
    return s !== null ? v(s) : null;
  }
  get intl() {
    return ct(this);
  }
  get current() {
    return this.state.current !== null ? v(this.state.current) : null;
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    clearTimeout(this.nextTickId);
  }
  /**
   * @hidden
   */
  render() {
    const {
      format: s,
      cancelButton: t,
      disabled: e,
      tabIndex: i,
      className: a,
      smoothScroll: r,
      min: l,
      max: c,
      boundRange: h,
      nowButton: u,
      steps: d,
      show: p,
      mobileMode: m
    } = this.props, f = q(this), y = f.toLanguageString(ve, T[ve]), I = f.toLanguageString(Ut, T[Ut]);
    return /* @__PURE__ */ o.createElement(
      "div",
      {
        ref: (M) => {
          this._element = M;
        },
        tabIndex: e ? void 0 : i || 0,
        className: P("k-timeselector", a, {
          "k-disabled": e
        }),
        onKeyDown: this.handleKeyDown
      },
      /* @__PURE__ */ o.createElement(
        _t,
        {
          ref: (M) => {
            this.timePart = M;
          },
          value: this.current,
          onChange: this.handleChange,
          onNowClick: this.handleNowClick,
          format: s,
          smoothScroll: r,
          min: l,
          max: c,
          boundRange: h,
          disabled: e,
          nowButton: u,
          steps: d,
          show: p,
          mobileMode: m
        }
      ),
      this.props.footer && /* @__PURE__ */ o.createElement("div", { className: "k-time-footer k-actions k-actions-stretched" }, t && /* @__PURE__ */ o.createElement(
        N,
        {
          type: "button",
          ref: (M) => {
            this._cancelButton = M;
          },
          className: "k-time-cancel",
          onClick: this.handleReject,
          title: y,
          "aria-label": y
        },
        y
      ), /* @__PURE__ */ o.createElement(
        N,
        {
          type: "button",
          ref: (M) => {
            this._acceptButton = M;
          },
          className: "k-time-accept",
          themeColor: "primary",
          onClick: this.handleAccept,
          title: I,
          "aria-label": I
        },
        I
      ))
    );
  }
  nextTick(s) {
    clearTimeout(this.nextTickId), this.nextTickId = window.setTimeout(() => s());
  }
  hasActiveButton() {
    if (!this._acceptButton || !this._acceptButton.element)
      return !1;
    const s = ot(document);
    return this._acceptButton && s === this._acceptButton.element || this._cancelButton && s === this._cancelButton.element;
  }
};
let Jt = ss;
Jt.propTypes = {
  cancelButton: n.bool,
  className: n.string,
  disabled: n.bool,
  format: n.oneOfType([
    n.string,
    n.shape({
      skeleton: n.string,
      pattern: n.string,
      date: n.oneOf(["short", "medium", "long", "full"]),
      time: n.oneOf(["short", "medium", "long", "full"]),
      datetime: n.oneOf(["short", "medium", "long", "full"]),
      era: n.oneOf(["narrow", "short", "long"]),
      year: n.oneOf(["numeric", "2-digit"]),
      month: n.oneOf(["numeric", "2-digit", "narrow", "short", "long"]),
      day: n.oneOf(["numeric", "2-digit"]),
      weekday: n.oneOf(["narrow", "short", "long"]),
      hour: n.oneOf(["numeric", "2-digit"]),
      hour12: n.bool,
      minute: n.oneOf(["numeric", "2-digit"]),
      second: n.oneOf(["numeric", "2-digit"]),
      timeZoneName: n.oneOf(["short", "long"])
    })
  ]),
  max: n.instanceOf(Date),
  min: n.instanceOf(Date),
  nowButton: n.bool,
  steps: n.shape({
    hour: n.number,
    minute: n.number,
    second: n.number
  }),
  smoothScroll: n.bool,
  tabIndex: n.number,
  value: n.instanceOf(Date),
  show: n.bool
};
Jt.defaultProps = {
  value: null,
  disabled: !1,
  cancelButton: !0,
  format: "t",
  min: Nt,
  max: xt,
  boundRange: !1,
  footer: !0
};
ft(Jt);
at(Jt);
const G = class extends o.Component {
  constructor(s) {
    super(s), this._element = null, this._dateInput = o.createRef(), this._timeSelector = null, this.shouldFocusDateInput = !1, this.prevShow = !1, this.focus = () => {
      this.dateInput && this.dateInput.focus();
    }, this.renderTimeSelector = () => {
      const { smoothScroll: t, cancelButton: e, nowButton: i, disabled: a, format: r, steps: l } = this.props;
      return /* @__PURE__ */ o.createElement(
        Jt,
        {
          ref: this.setTimeSelectorRef,
          className: this.mobileMode ? "k-reset k-timeselector-lg" : "",
          mobileMode: this.mobileMode,
          show: this.show,
          cancelButton: e,
          disabled: a,
          nowButton: i,
          format: r,
          min: this.min,
          max: this.max,
          steps: l,
          smoothScroll: t,
          value: this.value,
          footer: !this.mobileMode,
          handleTimeChange: this.mobileMode && this.handleTimeChange,
          onChange: this.handleValueChange,
          onReject: this.handleValueReject
        }
      );
    }, this.renderPopup = () => {
      const { popupClass: t, ...e } = this.popupSettings, i = P(
        "k-group k-reset",
        t
      ), a = {
        popupClass: "k-timepicker-popup",
        show: this.show,
        animate: this.element !== null,
        anchor: this.element,
        className: i,
        id: this._popupId,
        anchorAlign: {
          horizontal: "left",
          vertical: "bottom"
        },
        popupAlign: {
          horizontal: "left",
          vertical: "top"
        },
        ...e
      };
      return this.props.popup ? /* @__PURE__ */ o.createElement(this.props.popup, { ...a }, this.renderTimeSelector()) : /* @__PURE__ */ o.createElement(be, { ...a }, this.renderTimeSelector());
    }, this.renderAdaptivePopup = () => {
      const { windowWidth: t = 0 } = this.state, e = {
        expand: this.show,
        onClose: this.handleBlur,
        adaptiveTitle: this.props.adaptiveTitle,
        windowWidth: t,
        footer: {
          cancelText: this.localizationService.toLanguageString(ue, T[ve]),
          onCancel: this.handleValueReject,
          applyText: this.localizationService.toLanguageString(Ut, T[Ut]),
          onApply: (i) => this.handleValueChange(i)
        }
      };
      return /* @__PURE__ */ o.createElement(Se, { ...e }, /* @__PURE__ */ o.createElement(ke, { className: "!k-overflow-hidden" }, this.renderTimeSelector()));
    }, this.setTimeSelectorRef = (t) => {
      this._timeSelector = t;
    }, this.nextValue = (t, e) => t.value !== void 0 ? t.value : e.value, this.nextShow = (t, e) => t.show !== void 0 ? t.show : e.show, this.handleInputValueChange = (t) => {
      const e = this.mergeTime(t.value);
      this.handleValueChange({ ...t, value: e });
    }, this.handleTimeChange = (t) => {
      this.setState({ candidate: t.time });
    }, this.handleValueChange = (t) => {
      this.setState({
        value: v(t.value || this.state.candidate)
      }), this.valueDuringOnChange = t.value, this.showDuringOnChange = !1, this.shouldFocusDateInput = !0;
      const { onChange: e } = this.props, i = this.value || this.state.candidate;
      e && e.call(void 0, {
        syntheticEvent: t.syntheticEvent,
        nativeEvent: t.nativeEvent,
        value: i,
        show: this.show,
        target: this
      }), this.valueDuringOnChange = void 0, this.showDuringOnChange = void 0, this.setShow(!1);
    }, this.handleFocus = () => {
      this.setState({ focused: !0 });
    }, this.handleBlur = () => {
      this.setState({ focused: !1 }), this.setShow(!1);
    }, this.handleValueReject = (t) => {
      this.setShow(!1);
    }, this.handleIconClick = (t) => {
      this.props.disabled || (this.shouldFocusDateInput = !0, this.setShow(!this.show));
    }, this.handleIconMouseDown = (t) => {
      t.preventDefault();
    }, this.handleKeyDown = (t) => {
      const { altKey: e, keyCode: i } = t;
      if (i === C.esc) {
        this.shouldFocusDateInput = !0, this.setShow(!1);
        return;
      }
      e && (i === C.up || i === C.down) && (t.preventDefault(), t.stopPropagation(), this.shouldFocusDateInput = i === C.up, this.setShow(i === C.down));
    }, Pt(Rt), this.state = {
      value: this.props.defaultValue || G.defaultProps.defaultValue,
      show: this.props.defaultShow || G.defaultProps.defaultShow,
      focused: !1,
      candidate: null
    }, this.normalizeTime = this.normalizeTime.bind(this), this.setShow = this.setShow.bind(this), this.mergeTime = this.mergeTime.bind(this);
  }
  get _popupId() {
    return this.props.id + "-popup-id";
  }
  get document() {
    if (J)
      return this.element && this.element.ownerDocument || document;
  }
  /**
   * Gets the wrapping element of the TimePicker.
   */
  get element() {
    return this._element;
  }
  /**
   * Gets the DateInput component inside the TimePicker component.
   */
  get dateInput() {
    return this._dateInput.current;
  }
  /**
   * Gets the TimeSelector component inside the TimePicker component.
   */
  get timeSelector() {
    return this._timeSelector;
  }
  /**
   * Gets the value of the TimePicker.
   */
  get value() {
    const s = this.valueDuringOnChange !== void 0 ? this.valueDuringOnChange : this.props.value !== void 0 ? this.props.value : this.state.value;
    return s !== null ? v(s) : null;
  }
  /**
   * Gets the popup state of the TimeSelector.
   */
  get show() {
    return this.showDuringOnChange !== void 0 ? this.showDuringOnChange : this.props.show !== void 0 ? this.props.show : this.state.show;
  }
  /**
   * Gets the `name` property of the TimePicker.
   */
  get name() {
    return this.props.name;
  }
  /**
   * Represents the validity state into which the TimePicker is set.
   */
  get validity() {
    const s = this.value && this.normalizeTime(this.value), t = this.normalizeTime(this.min), e = this.normalizeTime(this.max), i = xn(s, t, e), a = this.props.validationMessage !== void 0, r = (!this.required || this.value !== null) && i, l = this.props.valid !== void 0 ? this.props.valid : r;
    return {
      customError: a,
      rangeOverflow: In(s, e),
      rangeUnderflow: Cn(s, t),
      valid: l,
      valueMissing: this.value === null
    };
  }
  /**
   * The mobile mode of the ComboBox.
   */
  get mobileMode() {
    return !!(this.state.windowWidth && this.state.windowWidth <= xe && this.props.adaptive);
  }
  /**
   * @hidden
   */
  get validityStyles() {
    return this.props.validityStyles !== void 0 ? this.props.validityStyles : G.defaultProps.validityStyles;
  }
  /**
   * @hidden
   */
  get required() {
    return this.props.required !== void 0 ? this.props.required : G.defaultProps.required;
  }
  get popupSettings() {
    return this.props.popupSettings || G.defaultProps.popupSettings;
  }
  get min() {
    return this.props.min !== void 0 ? this.props.min : G.defaultProps.min;
  }
  get max() {
    return this.props.max !== void 0 ? this.props.max : G.defaultProps.max;
  }
  get dateInputComp() {
    return this.props.dateInput || G.defaultProps.dateInput;
  }
  get localizationService() {
    return q(this);
  }
  /**
   * @hidden
   */
  componentDidMount() {
    var s;
    this.observerResize = J && window.ResizeObserver && new window.ResizeObserver(this.calculateMedia.bind(this)), this.show && this.forceUpdate(), (s = this.document) != null && s.body && this.observerResize && this.observerResize.observe(this.document.body);
  }
  /**
   * @hidden
   */
  componentDidUpdate() {
    this._timeSelector && this.show && !this.prevShow ? this._timeSelector.focusActiveList() : this.dateInput && this.dateInput.element && !this.show && this.shouldFocusDateInput && this.dateInput.element.focus({ preventScroll: !0 }), this.prevShow = this.show, this.shouldFocusDateInput = !1;
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    var s;
    (s = this.document) != null && s.body && this.observerResize && this.observerResize.disconnect();
  }
  /**
   * @hidden
   */
  render() {
    const {
      size: s = G.defaultProps.size,
      rounded: t = G.defaultProps.rounded,
      fillMode: e = G.defaultProps.fillMode,
      disabled: i,
      tabIndex: a,
      title: r,
      id: l,
      className: c,
      format: h,
      formatPlaceholder: u,
      width: d,
      name: p,
      steps: m,
      validationMessage: f,
      required: y,
      validityStyles: I,
      ariaLabelledBy: M,
      ariaDescribedBy: w
    } = this.props, E = !this.validityStyles || this.validity.valid, g = {
      disabled: i,
      format: h,
      formatPlaceholder: u,
      id: l,
      ariaLabelledBy: M,
      ariaDescribedBy: w,
      max: this.normalizeTime(this.max),
      min: this.normalizeTime(this.min),
      name: p,
      onChange: this.handleInputValueChange,
      required: y,
      steps: m,
      tabIndex: this.show ? -1 : a,
      title: r,
      valid: this.validity.valid,
      validationMessage: f,
      validityStyles: I,
      value: this.value && this.normalizeTime(this.value),
      label: void 0,
      placeholder: this.state.focused ? null : this.props.placeholder,
      ariaHasPopup: "dialog",
      ariaExpanded: this.show,
      size: null,
      fillMode: null,
      rounded: null,
      readonly: this.mobileMode
    }, H = this.localizationService.toLanguageString(ue, T[ue]), V = this.localizationService.toLanguageString(Ze, T[Ze]), R = /* @__PURE__ */ o.createElement(
      we,
      {
        onFocus: this.handleFocus,
        onBlur: this.mobileMode ? void 0 : this.handleBlur,
        onSyncBlur: this.props.onBlur,
        onSyncFocus: this.props.onFocus
      },
      ({ onFocus: A, onBlur: S }) => /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
        "div",
        {
          id: this.props.id,
          ref: (O) => {
            this._element = O;
          },
          className: P(
            "k-input",
            "k-timepicker",
            {
              [`k-input-${mt.sizeMap[s] || s}`]: s,
              [`k-rounded-${mt.roundedMap[t] || t}`]: t,
              [`k-input-${e}`]: e,
              ["k-invalid"]: !E,
              ["k-required"]: this.required,
              ["k-disabled"]: this.props.disabled
            },
            c
          ),
          onKeyDown: this.handleKeyDown,
          style: { width: d },
          onFocus: A,
          onBlur: S,
          onClick: this.mobileMode ? this.handleIconClick : void 0
        },
        /* @__PURE__ */ o.createElement(
          this.dateInputComp,
          {
            _ref: this._dateInput,
            ariaRole: "combobox",
            ariaControls: this._popupId,
            ...g
          }
        ),
        /* @__PURE__ */ o.createElement(
          N,
          {
            tabIndex: -1,
            type: "button",
            icon: "clock",
            svgIcon: li,
            onMouseDown: this.handleIconMouseDown,
            onClick: this.mobileMode ? void 0 : this.handleIconClick,
            title: V,
            className: "k-input-button",
            rounded: null,
            "aria-label": H
          }
        ),
        !this.mobileMode && this.renderPopup()
      ), this.mobileMode && this.renderAdaptivePopup())
    );
    return this.props.label ? /* @__PURE__ */ o.createElement(
      cs,
      {
        dateInput: this._dateInput,
        label: this.props.label,
        editorId: l,
        editorValid: E,
        editorDisabled: this.props.disabled,
        children: R,
        style: { width: this.props.width }
      }
    ) : R;
  }
  normalizeTime(s) {
    return W(L, s);
  }
  setShow(s) {
    const { onOpen: t, onClose: e } = this.props;
    this.show !== s && (this.setState({ show: s }), s && t && t.call(void 0, {
      target: this
    }), !s && e && e.call(void 0, {
      target: this
    }));
  }
  mergeTime(s) {
    return this.value && s ? W(this.value, s) : s;
  }
  calculateMedia(s) {
    for (let t of s)
      this.setState({ windowWidth: t.target.clientWidth });
  }
};
let Qt = G;
Qt.displayName = "TimePicker";
Qt.propTypes = {
  className: n.string,
  cancelButton: n.bool,
  nowButton: n.bool,
  defaultShow: n.bool,
  defaultValue: n.instanceOf(Date),
  disabled: n.bool,
  format: n.oneOfType([
    n.string,
    n.shape({
      skeleton: n.string,
      pattern: n.string,
      date: n.oneOf(["short", "medium", "long", "full"]),
      time: n.oneOf(["short", "medium", "long", "full"]),
      datetime: n.oneOf(["short", "medium", "long", "full"]),
      era: n.oneOf(["narrow", "short", "long"]),
      year: n.oneOf(["numeric", "2-digit"]),
      month: n.oneOf(["numeric", "2-digit", "narrow", "short", "long"]),
      day: n.oneOf(["numeric", "2-digit"]),
      weekday: n.oneOf(["narrow", "short", "long"]),
      hour: n.oneOf(["numeric", "2-digit"]),
      hour12: n.bool,
      minute: n.oneOf(["numeric", "2-digit"]),
      second: n.oneOf(["numeric", "2-digit"]),
      timeZoneName: n.oneOf(["short", "long"])
    })
  ]),
  formatPlaceholder: n.oneOfType([
    n.oneOf(["wide", "narrow", "short", "formatPattern"]),
    n.shape({
      year: n.string,
      month: n.string,
      day: n.string,
      hour: n.string,
      minute: n.string,
      second: n.string
    })
  ]),
  id: n.string,
  ariaLabelledBy: n.string,
  ariaDescribedBy: n.string,
  min: n.instanceOf(Date),
  max: n.instanceOf(Date),
  name: n.string,
  popupSettings: n.shape({
    animate: n.bool,
    appendTo: n.any,
    popupClass: n.string
  }),
  show: n.bool,
  steps: n.shape({
    hour: n.number,
    minute: n.number,
    second: n.number
  }),
  smoothScroll: n.bool,
  tabIndex: n.number,
  title: n.string,
  value: n.instanceOf(Date),
  width: n.oneOfType([n.number, n.string]),
  validationMessage: n.string,
  required: n.bool,
  validate: n.bool,
  valid: n.bool,
  size: n.oneOf([null, "small", "medium", "large"]),
  rounded: n.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: n.oneOf([null, "solid", "flat", "outline"])
};
Qt.defaultProps = {
  defaultShow: !1,
  defaultValue: null,
  disabled: !1,
  format: "t",
  max: xt,
  min: Nt,
  popupSettings: {},
  tabIndex: 0,
  steps: {},
  required: !1,
  validityStyles: !0,
  dateInput: kt,
  size: "medium",
  rounded: "medium",
  fillMode: "solid"
};
const na = Dt(), aa = yt(St(na, Qt));
aa.displayName = "KendoReactTimePicker";
at(Qt);
const Es = 2, is = class extends o.Component {
  constructor(s) {
    super(s), this._element = null, this.isActive = !1, this.focusActiveDate = () => {
      if (!this._element)
        return;
      const t = this._element.querySelector("td.k-focus"), e = this._element.querySelector(".k-state-pending-focus");
      t && t[0] && t[0].classList.remove("k-focus"), e && e.classList.add("k-focus"), this.isActive = !0;
    }, this.blurActiveDate = () => {
      if (!this._element)
        return;
      const t = this._element.querySelector("td.k-focus");
      t && t.classList.remove("k-focus"), this.isActive = !1;
    }, this.rotateSelectionRange = (t) => {
      if (t.start === null || t.end === null)
        return t;
      const e = t.end < t.start;
      return {
        start: e ? t.end : t.start,
        end: e ? t.start : t.end
      };
    }, this.handleDateChange = (t, e = !1) => {
      const { onChange: i } = this.props;
      if (i) {
        const a = {
          syntheticEvent: t.syntheticEvent,
          nativeEvent: t.nativeEvent,
          value: v(t.value),
          target: this,
          isTodayClick: e
        };
        i.call(void 0, a);
      }
    };
  }
  get element() {
    return this._element;
  }
  get weekNumber() {
    return !!(this.props.showWeekNumbers && this.props.activeView === D.month);
  }
  get min() {
    return this.props.min !== void 0 ? this.props.min : is.defaultProps.min;
  }
  get max() {
    return this.props.max !== void 0 ? this.props.max : is.defaultProps.max;
  }
  componentDidUpdate() {
    this.isActive && this.focusActiveDate();
  }
  render() {
    const s = this.props.allowReverse ? this.rotateSelectionRange(this.props.selectionRange) : this.props.selectionRange, t = P(
      "k-calendar-view k-align-items-start k-justify-content-center",
      {
        "k-vstack": this.props.verticalView,
        "k-hstack": !this.props.verticalView,
        "k-calendar-monthview": this.props.activeView === D.month,
        "k-calendar-yearview": this.props.activeView === D.year,
        "k-calendar-decadeview": this.props.activeView === D.decade,
        "k-calendar-centuryview": this.props.activeView === D.century
      }
    );
    return /* @__PURE__ */ o.createElement(
      "div",
      {
        ref: (e) => {
          this._element = e;
        },
        className: t
      },
      this.props.dates.map((e) => /* @__PURE__ */ o.createElement("table", { className: "k-calendar-table k-content", key: e.getTime(), role: "grid" }, /* @__PURE__ */ o.createElement(
        jt,
        {
          bus: this.props.bus,
          service: this.props.service,
          key: e.getTime(),
          direction: "horizontal",
          activeView: this.props.activeView,
          cellUID: this.props.cellUID,
          viewDate: e,
          min: this.min,
          max: this.max,
          focusedDate: this.props.focusedDate,
          selectionRange: s,
          selectedDate: this.props.value,
          showWeekNumbers: this.weekNumber,
          onChange: this.handleDateChange,
          onCellEnter: this.props.onCellEnter,
          cell: this.props.cell,
          weekCell: this.props.weekCell
        }
      )))
    );
  }
};
let Bt = is;
Bt.defaultProps = {
  showWeekNumbers: !1,
  views: Es,
  take: Es,
  allowReverse: !0,
  min: ut,
  max: dt
};
const Le = (s = lt.defaultProps.min, t = lt.defaultProps.max, e) => e instanceof Date && !Array.isArray(e) && F(x(e), s, t) ? x(e) : null, Vs = (s = lt.defaultProps.min, t = lt.defaultProps.max, e) => Array.isArray(e) ? e.filter((i) => F(i, s, t)).map((i) => x(i)) : null, Os = (s) => typeof s == "object" && !(s instanceof Date) && s !== null && !Array.isArray(s) ? s : z, Ps = (s, t, e) => s || t && t[0] || e && e.start, ra = (s, t) => s.start === null && t === null ? "start" : s.end === null ? "end" : "start", Et = class extends o.Component {
  constructor(s) {
    super(s), this.dates = [], this.selectedDate = null, this.selectedMultiple = null, this.selectedRange = z, this._focusedDate = /* @__PURE__ */ new Date(), this.cellUID = this.props.id + "-cell-uid", this.activeRangeEnd = "start", this._element = null, this.intl = null, this.localization = null, this.service = null, this.calendarViewList = null, this.isActive = !1, this.calculateFocusFromValue = !0, this.focus = () => {
      this._element && this._element.focus();
    }, this.clampRange = (h) => ({ start: h, end: null }), this.rangeWithFocused = (h, u) => ({
      start: h.start,
      end: h.end === null && h.start !== null && this.isActive ? u : h.end
    }), this.generateRange = (h, u) => {
      let { end: d, start: p } = u;
      const m = u.start !== null && h.getTime() <= u.start.getTime();
      return !this.props.allowReverse && m ? { start: h, end: this.selectedRange.start } : this.activeRange !== "end" ? { start: h, end: d } : { start: p || this.selectedDate, end: h };
    }, this.canNavigate = (h) => {
      if (!this.service)
        return !1;
      const u = this.service.move(this.focusedDate, h);
      return this.min <= u && u <= this.max || this.service.isInSameView(u, this.min) || this.service.isInSameView(u, this.max);
    }, this.navigate = (h, u) => {
      this.calculateFocusFromValue = !1;
      const d = this.move(h, u);
      this.setState({ navigateDate: d, focusedDate: d });
    }, this.move = (h, u) => this.clampDate(this.service.move(u, h)), this.clampDate = (h) => K(h, this.min, this.max), this.shouldAutoCorrect = (h, u) => {
      const { end: d, start: p } = u;
      return this.activeRange !== "end" ? d !== null && h > d : p !== null && h < p;
    }, this.handleCellEnter = (h) => {
      this.props.mode === "range" && (this.calculateFocusFromValue = !1, this.setState({
        focusedDate: h
      }));
    }, this.handleMouseDown = (h) => {
      h.preventDefault();
    }, this.handleClick = (h) => {
      this._element && this._element.focus({ preventScroll: !0 });
    }, this.handleFocus = (h) => {
      if (this.isActive = !0, !this.calendarViewList)
        return;
      this.calendarViewList.focusActiveDate();
      const { onFocus: u } = this.props;
      u && u.call(void 0, h);
    }, this.handleBlur = (h) => {
      if (this.isActive = !1, !this.calendarViewList)
        return;
      this.calendarViewList.blurActiveDate();
      const { onBlur: u } = this.props;
      u && u.call(void 0, h);
    }, this.handleTodayClick = (h) => {
      this.todayIsInRange && this.handleDateChange(h);
    }, this.handlePrevButtonClick = () => {
      const h = b.PrevView;
      if (this.state.activeView > 0 && this.focusedDate.getFullYear() > this.dates[0].getFullYear())
        this.navigate(h, this.move(h, this.focusedDate));
      else {
        const u = this.isInMonth(this.focusedDate, this.dates[1]) ? this.move(h, this.focusedDate) : this.focusedDate;
        this.navigate(h, u);
      }
    }, this.handleNextButtonClick = () => {
      this.navigate(b.NextView, this.focusedDate);
    }, this.handleKeyDown = (h) => {
      const { keyCode: u } = h;
      if (u === C.enter) {
        const d = {
          syntheticEvent: h,
          nativeEvent: h.nativeEvent,
          value: this.focusedDate,
          target: this
        };
        this.handleDateChange(d);
      } else {
        const d = K(
          this.navigation.move(
            this.focusedDate,
            this.navigation.action(h),
            this.state.activeView,
            this.service,
            h
          ),
          this.min,
          this.max
        );
        if (wt(this.focusedDate, d))
          return;
        this.dates && this.service && !this.service.isInArray(d, this.dates) && this.setState({ navigateDate: d }), this.calculateFocusFromValue = !1, this.setState({ focusedDate: d });
      }
      h.preventDefault();
    }, this.handleViewChange = ({ view: h }) => {
      this.calculateFocusFromValue = !1, this.setState((u) => ({ activeView: h, navigateDate: u.focusedDate }));
    }, this.handleDateChange = (h) => {
      const u = v(h.value), d = this.bus.canMoveDown(this.state.activeView);
      if (this.props.disabled)
        return;
      if (d)
        if (h.isTodayClick)
          this.bus.moveToBottom(this.state.activeView);
        else {
          this.bus.moveDown(this.state.activeView, h.syntheticEvent), this.setState({ focusedDate: u });
          return;
        }
      this.calculateFocusFromValue = !0;
      let p;
      switch (this.props.mode) {
        case "single":
          p = v(h.value);
          break;
        case "multiple":
          if (Array.isArray(this.selectedMultiple)) {
            let f = this.selectedMultiple.slice(), y = -1;
            f.forEach((I, M) => {
              wt(I, h.value) && (y = M);
            }), y !== -1 ? f.splice(y, 1) : f.push(v(h.value)), p = f.slice();
          } else
            this.selectedDate ? p = [v(this.selectedDate), v(h.value)] : p = [v(h.value)];
          break;
        case "range": {
          p = this.selectedRange.start !== null && this.selectedRange.end !== null && this.activeRange === "start" ? this.clampRange(h.value) : this.generateRange(h.value, this.selectedRange), this.activeRangeEnd = this.activeRange !== "end" ? "end" : "start";
          break;
        }
        default:
          p = v(h.value);
          break;
      }
      this.valueDuringOnChange = p, h.isTodayClick && this.setState({ navigateDate: u }), this.setState({ value: p, focusedDate: u }), this.valueDuringOnChange = p;
      const { onChange: m } = this.props;
      if (m) {
        const f = {
          syntheticEvent: h.syntheticEvent,
          nativeEvent: h.nativeEvent,
          value: p,
          target: this
        };
        m.call(void 0, f);
      }
      this.valueDuringOnChange = void 0;
    };
    const t = s.value !== void 0 ? s.value : s.defaultValue || Et.defaultProps.defaultValue, e = Le(this.min, this.max, t), i = Vs(this.min, this.max, t), a = Os(t), r = Ps(e, i, a), l = ge(
      D[s.defaultActiveView],
      this.bottomView,
      this.topView
    ), c = K(
      s.focusedDate || r || U(),
      this.min,
      this.max
    );
    this.state = {
      value: t,
      activeView: l,
      focusedDate: c,
      navigateDate: c
    }, this.activeRangeEnd = ra(a, e), this.bus = new zs(this.handleViewChange), this.navigation = new qs(this.bus), this.calculateFocusFromValue = !1, this.lastView = l, this.lastViewsCount = this.props.views || Bt.defaultProps.views;
  }
  get wrapperID() {
    return this.props.id + "-wrapper-id";
  }
  get isRtl() {
    return this.props.dir === "rtl";
  }
  /**
   * Gets the wrapping element of the MultiViewCalendar component.
   */
  get element() {
    return this._element;
  }
  /**
   * Gets the value of the MultiViewCalendar.
   */
  get value() {
    return this.valueDuringOnChange !== void 0 ? this.valueDuringOnChange : this.props.value !== void 0 ? this.props.value : this.state.value;
  }
  /**
   * Gets the current focused date of the MultiViewCalendar.
   */
  get focusedDate() {
    return v(this._focusedDate);
  }
  get min() {
    return x(this.props.min !== void 0 ? this.props.min : Et.defaultProps.min);
  }
  get max() {
    return x(this.props.max !== void 0 ? this.props.max : Et.defaultProps.max);
  }
  get bottomView() {
    return D[this.props.bottomView !== void 0 ? this.props.bottomView : Et.defaultProps.bottomView];
  }
  get topView() {
    return D[this.props.topView !== void 0 ? this.props.topView : Et.defaultProps.topView];
  }
  get activeRange() {
    return this.props.activeRangeEnd !== void 0 ? this.props.activeRangeEnd : this.activeRangeEnd;
  }
  get todayIsInRange() {
    return F(U(), x(this.min), x(this.max));
  }
  /**
   * @hidden
   */
  componentDidMount() {
    this.calculateFocusFromValue = !0;
  }
  /**
   * @hidden
   */
  componentDidUpdate() {
    this.calendarViewList && (this.isActive ? this.calendarViewList.focusActiveDate : this.calendarViewList.blurActiveDate)();
    const s = Le(this.min, this.max, this.value);
    this.calculateFocusFromValue = !!(this.selectedDate && s && this.selectedDate.getTime() && s.getTime()), this.lastView = this.state.activeView, this.lastViewsCount = this.props.views || Bt.defaultProps.views;
  }
  /**
   * @hidden
   */
  render() {
    this.props._ref && this.props._ref(this), this.intl = ct(this), this.localization = q(this), this.bus.configure(this.bottomView, this.topView);
    const s = ge(this.state.activeView, this.bottomView, this.topView);
    this.service = this.bus.service(s, this.intl), this.selectedDate = Le(this.min, this.max, this.value), this.selectedMultiple = Vs(this.min, this.max, this.value), this.selectedRange = Os(this.value);
    const t = Ps(this.selectedDate, this.selectedMultiple, this.selectedRange);
    this._focusedDate = K(
      this.calculateFocusFromValue && t !== null ? t : this.state.focusedDate,
      this.min,
      this.max
    );
    const e = P(
      "k-widget k-calendar k-calendar-range",
      {
        "k-disabled": this.props.disabled
      },
      this.props.className
    ), i = this.rangeWithFocused(this.selectedRange, this.focusedDate), a = this.localization.toLanguageString(Be, T[Be]), r = this.localization.toLanguageString(ze, T[ze]), l = !this.canNavigate(b.PrevView), c = !this.canNavigate(b.NextView), h = { "aria-disabled": l }, u = { "aria-disabled": c }, d = this.lastView !== s, p = this.dates && this.isInMonth(this.state.navigateDate, this.dates[0]), m = this.lastViewsCount !== this.props.views;
    (!p || d || m) && (this.dates = this.service.datesList(
      this.state.navigateDate,
      this.props.views || Bt.defaultProps.views
    ));
    const f = v(this.dates && this.dates[0] ? this.dates[0] : U());
    return /* @__PURE__ */ o.createElement(
      "div",
      {
        ref: (y) => {
          this._element = y;
        },
        className: e,
        id: this.props.id || this.wrapperID,
        "aria-labelledby": this.props.ariaLabelledBy,
        "aria-describedby": this.props.ariaDescribedBy,
        tabIndex: this.props.disabled ? void 0 : this.props.tabIndex,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onMouseDown: this.handleMouseDown,
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        "aria-disabled": this.props.disabled,
        dir: this.props.dir
      },
      /* @__PURE__ */ o.createElement(
        Zt,
        {
          key: `.kendo.calendar.header.${f.getTime()}`,
          activeView: s,
          currentDate: f,
          min: this.min,
          max: this.max,
          rangeLength: this.props.views,
          bus: this.bus,
          service: this.service,
          headerTitle: this.props.headerTitle,
          verticalView: this.props.mobileMode,
          commands: /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
            N,
            {
              type: "button",
              className: "k-calendar-nav-prev",
              icon: this.isRtl ? "chevron-right" : "chevron-left",
              svgIcon: this.isRtl ? vs : ws,
              fillMode: "flat",
              title: a,
              disabled: l,
              onClick: this.handlePrevButtonClick,
              ...h
            }
          ), /* @__PURE__ */ o.createElement(
            Gt,
            {
              min: this.min,
              max: this.max,
              onClick: this.handleTodayClick,
              disabled: !this.todayIsInRange
            }
          ), /* @__PURE__ */ o.createElement(
            N,
            {
              type: "button",
              className: "k-calendar-nav-next",
              icon: this.isRtl ? "chevron-left" : "chevron-right",
              svgIcon: this.isRtl ? ws : vs,
              fillMode: "flat",
              title: r,
              disabled: c,
              onClick: this.handleNextButtonClick,
              ...u
            }
          ))
        }
      ),
      /* @__PURE__ */ o.createElement(
        Bt,
        {
          ref: (y) => {
            this.calendarViewList = y;
          },
          dates: this.dates,
          activeView: s,
          focusedDate: this.focusedDate,
          min: this.min,
          max: this.max,
          bus: this.bus,
          service: this.service,
          selectionRange: i,
          value: this.selectedMultiple || this.selectedDate,
          cellUID: this.cellUID,
          views: this.props.views,
          onChange: this.handleDateChange,
          showWeekNumbers: this.props.weekNumber,
          onCellEnter: this.handleCellEnter,
          cell: this.props.cell,
          weekCell: this.props.weekCell,
          headerTitle: this.props.headerTitle,
          verticalView: this.props.mobileMode
        }
      )
    );
  }
  // protected isListInRange = (list: Date[]): boolean => {
  //     return this.min < list[0]
  //         && this.max > list[Math.max(0, (this.props.views || MultiViewCalendarWithoutContext.defaultProps.views) - 1)];
  // };
  isInMonth(s, t) {
    return !!t && fe(t) <= s && s <= Ot(t);
  }
};
let lt = Et;
lt.displayName = "MultiViewCalendar";
lt.propTypes = {
  activeRangeEnd: n.oneOf(["start", "end"]),
  allowReverse: n.bool,
  bottomView: n.oneOf(["month", "year", "decade", "century"]),
  className: n.string,
  defaultActiveView: n.oneOf(["month", "year", "decade", "century"]),
  defaultValue: n.oneOfType([
    rt(n.instanceOf(Date)),
    n.arrayOf(n.instanceOf(Date)),
    n.shape({
      start: rt(n.instanceOf(Date)),
      end: rt(n.instanceOf(Date))
    })
  ]),
  disabled: n.bool,
  focusedDate: n.instanceOf(Date),
  id: n.string,
  ariaLabelledBy: n.string,
  ariaDescribedBy: n.string,
  max: n.instanceOf(Date),
  min: n.instanceOf(Date),
  mode: n.oneOf(["single", "multiple", "range"]),
  onBlur: n.func,
  onChange: n.func,
  onFocus: n.func,
  tabIndex: n.number,
  topView: n.oneOf(["month", "year", "decade", "century"]),
  value: n.oneOfType([
    rt(n.instanceOf(Date)),
    n.arrayOf(n.instanceOf(Date)),
    n.shape({
      start: rt(n.instanceOf(Date).isRequired),
      end: rt(n.instanceOf(Date).isRequired)
    })
  ]),
  views: (s, t, e) => {
    const i = s[t];
    return i !== void 0 && i < 1 ? new Error(
      `Invalid prop '${t}' supplied to'${e}'. The '${t}' property cannot be less than 1'`
    ) : null;
  },
  weekNumber: n.bool,
  dir: n.string
};
lt.defaultProps = {
  disabled: !1,
  min: ut,
  max: dt,
  navigation: !0,
  defaultActiveView: "month",
  defaultValue: null,
  topView: "century",
  tabIndex: 0,
  bottomView: "month",
  views: 2,
  allowReverse: !1
};
const oa = Dt(), Qs = yt(St(oa, lt));
Qs.displayName = "KendoReactMultiViewCalendar";
ft(lt);
at(lt);
const zt = class extends o.Component {
  constructor(s) {
    super(s), this._element = null, this._calendar = null, this._startDateInput = o.createRef(), this._endDateInput = o.createRef(), this.shouldFocusDateInput = !1, this.shouldFocusCalendar = !1, this.focus = () => {
      this.startDateInput && this.startDateInput.focus();
    }, this.setCalendarRef = (t) => {
      this._calendar = t;
    }, this.focusCalendarElement = () => {
      this._calendar && this._calendar.element && this._calendar.element.focus({ preventScroll: !0 });
    }, this.calculateValue = (t, e) => (t.value !== void 0 ? t.value : e.value) || z, this.calculateShow = (t, e) => t.show !== void 0 ? t.show : e.show, this.renderCalendar = () => {
      const t = this.value || z, e = {
        min: this.min,
        max: this.max,
        allowReverse: this.props.allowReverse,
        mode: "range",
        focusedDate: this.props.focusedDate,
        disabled: this.props.disabled,
        className: this.mobileMode ? "k-calendar-lg" : "",
        mobileMode: this.mobileMode,
        ...this.props.calendarSettings,
        value: t,
        dir: this.props.dir,
        onChange: this.handleCalendarChange
      };
      return this.props.calendar ? /* @__PURE__ */ o.createElement(this.props.calendar, { ...e }) : /* @__PURE__ */ o.createElement(Qs, { ...e, ref: this.setCalendarRef });
    }, this.renderPopup = () => {
      const t = {
        popupClass: "k-daterangepicker-popup",
        animate: this._element !== null,
        anchor: this._element,
        id: this._popupId,
        anchorAlign: {
          horizontal: "left",
          vertical: "bottom"
        },
        popupAlign: {
          horizontal: "left",
          vertical: "top"
        },
        ...this.props.popupSettings,
        show: this.show
      };
      return this.props.popup ? /* @__PURE__ */ o.createElement(this.props.popup, { ...t }, this.renderCalendar()) : /* @__PURE__ */ o.createElement(be, { ...t }, this.renderCalendar());
    }, this.renderAdaptivePopup = () => {
      const { windowWidth: t = 0 } = this.state, e = {
        expand: this.show,
        onClose: (i) => this.handleCancel(i),
        adaptiveTitle: this.props.adaptiveTitle,
        windowWidth: t,
        footer: {
          cancelText: this.localizationService.toLanguageString(Je, T[Je]),
          onCancel: this.handleCancel,
          applyText: this.localizationService.toLanguageString(Qe, T[Qe]),
          onApply: this.handleBlur
        }
      };
      return /* @__PURE__ */ o.createElement(Se, { ...e }, /* @__PURE__ */ o.createElement(ke, { className: "!k-overflow-hidden" }, /* @__PURE__ */ o.createElement("div", { className: "k-scrollable-wrap" }, this.renderCalendar())));
    }, this.handleReverseClick = (t) => {
      const e = {
        start: this.value.end,
        end: this.value.start
      }, i = {
        syntheticEvent: t,
        nativeEvent: t.nativeEvent
      };
      this.handleChange(e, i);
    }, this.handleReverseMouseDown = (t) => {
      t.preventDefault();
    }, this.handleFocus = (t) => {
      clearTimeout(this.nextTickId), this.shouldFocusDateInput || (this.setShow(!0), this.mobileMode && this.setState({ currentValue: this.value }));
      const { onFocus: e } = this.props;
      e && e.call(void 0, t);
    }, this.handleBlur = (t) => {
      this.nextTick(() => {
        this.setShow(!1);
      });
      const { onBlur: e } = this.props;
      e && e.call(void 0, t);
    }, this.handleCancel = (t) => {
      this.nextTick(() => {
        this.setShow(!1), this.setState({ currentValue: z });
      });
      const { onCancel: e } = this.props;
      e && e.call(void 0, t);
    }, this.handleEndChange = (t) => {
      const e = {
        start: this.value.start,
        end: v(t.value || void 0)
      };
      this.handleChange(e, t);
    }, this.handleStartChange = (t) => {
      const e = {
        start: v(t.value || void 0),
        end: this.value.end
      };
      this.handleChange(e, t);
    }, this.extractRangeFromValue = (t) => {
      if (!Array.isArray(t.value) && !(t.value instanceof Date))
        return t.value || z;
      const e = Array.isArray(t.value) ? t.value[0] : t.value;
      return {
        start: this.value.end !== null ? e : this.value.start,
        end: this.value.start !== null ? e : this.value.end
      };
    }, this.handleCalendarChange = (t) => {
      const e = this.extractRangeFromValue(t);
      this.handleChange(e, t);
    }, this.handleKeyDown = (t) => {
      const { keyCode: e, altKey: i } = t, a = ot(document);
      e === C.esc ? (t.preventDefault(), this.shouldFocusDateInput = !0, this.setShow(!1)) : i && e === C.down ? (t.preventDefault(), this.shouldFocusCalendar = !0, this.setShow(!0)) : e === C.tab && this.show && this._calendar && this._calendar.element && this.endDateInput && this.endDateInput.element && document && a === this.endDateInput.element && (t.preventDefault(), this.focusCalendarElement());
    }, this.handleChange = (t, e) => {
      this.setState({ value: t }), this.valueDuringOnChange = t;
      const { onChange: i } = this.props;
      if (i) {
        const a = {
          syntheticEvent: e.syntheticEvent,
          nativeEvent: e.nativeEvent,
          value: this.value,
          show: this.show,
          target: this
        };
        i.call(void 0, a);
      }
      this.valueDuringOnChange = void 0;
    }, Pt(Rt), this.state = {
      show: this.props.show || this.props.defaultShow || zt.defaultProps.defaultShow,
      value: this.props.value || this.props.defaultValue || zt.defaultProps.defaultValue,
      currentValue: z
    }, this.nextTick = this.nextTick.bind(this), this.setShow = this.setShow.bind(this), this.focusCalendarElement = this.focusCalendarElement.bind(this), this.focusDateInputElement = this.focusDateInputElement.bind(this);
  }
  get _popupId() {
    return this.props.id + "-popup-id";
  }
  get _startInputId() {
    return this.props.id + "-start-input-id";
  }
  get _endInputId() {
    return this.props.id + "-end-input-id";
  }
  /**
   * Gets the wrapping element of the DateRangePicker.
   */
  get element() {
    return this._element;
  }
  /**
   * Gets the start DateInput component inside the DatePicker component.
   */
  get startDateInput() {
    return this._startDateInput.current;
  }
  /**
   * Gets the end DateInput component inside the DatePicker component.
   */
  get endDateInput() {
    return this._endDateInput.current;
  }
  /**
   * Gets the MultiVieCalendar inside the DateRangePicker.
   */
  get calendar() {
    return this._calendar;
  }
  /**
   * Gets the value of the DateRangePicker.
   */
  get value() {
    return (this.valueDuringOnChange !== void 0 ? this.valueDuringOnChange : this.props.value !== void 0 ? this.props.value : this.state.value) || z;
  }
  /**
   * Gets the popup state of the DateRangePicker.
   */
  get show() {
    return this.showDuringOnChange !== void 0 ? this.showDuringOnChange : this.props.show !== void 0 ? this.props.show : this.state.show;
  }
  get min() {
    return this.props.min !== void 0 ? this.props.min : zt.defaultProps.min;
  }
  get max() {
    return this.props.max !== void 0 ? this.props.max : zt.defaultProps.max;
  }
  get document() {
    if (J)
      return this.element && this.element.ownerDocument || document;
  }
  get localizationService() {
    return q(this);
  }
  /**
   * The mobile mode of the DateRangePicker.
   */
  get mobileMode() {
    return !!(this.state.windowWidth && this.state.windowWidth <= xe && this.props.adaptive);
  }
  /**
   * @hidden
   */
  componentDidMount() {
    var s;
    this.observerResize = J && window.ResizeObserver && new window.ResizeObserver(this.calculateMedia.bind(this)), this.show && this.forceUpdate(), (s = this.document) != null && s.body && this.observerResize && this.observerResize.observe(this.document.body);
  }
  /**
   * @hidden
   */
  componentDidUpdate() {
    this.shouldFocusCalendar && this.focusCalendarElement(), this.shouldFocusDateInput && this.focusDateInputElement(), this.shouldFocusCalendar = !1, this.shouldFocusDateInput = !1;
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    var s;
    clearTimeout(this.nextTickId), (s = this.document) != null && s.body && this.observerResize && this.observerResize.disconnect();
  }
  /**
   * @hidden
   */
  render() {
    const s = this.value || z, t = this.mobileMode && this.show ? this.state.currentValue : s, e = (this.props.startDateInputSettings || {}).id || this._startInputId, i = (this.props.endDateInputSettings || {}).id || this._endInputId, a = P(
      "k-daterangepicker",
      {
        "k-disabled": this.props.disabled
      },
      this.props.className
    ), r = this.localizationService.toLanguageString(Ue, T[Ue]), l = this.localizationService.toLanguageString($e, T[$e]), c = this.localizationService.toLanguageString(Ye, T[Ye]), h = {
      disableSelection: this.mobileMode && !0,
      label: r,
      format: this.props.format,
      min: this.min,
      max: this.max,
      id: this._startInputId,
      disabled: this.props.disabled,
      valid: this.props.valid,
      tabIndex: this.props.tabIndex,
      ariaExpanded: this.show,
      ...this.props.startDateInputSettings,
      value: t.start,
      onChange: this.handleStartChange
    }, u = {
      disableSelection: this.mobileMode && !0,
      label: l,
      format: this.props.format,
      min: this.min,
      max: this.max,
      id: this._endInputId,
      disabled: this.props.disabled,
      valid: this.props.valid,
      tabIndex: this.props.tabIndex,
      ariaExpanded: this.show,
      ...this.props.endDateInputSettings,
      value: t.end,
      onChange: this.handleEndChange
    }, d = /* @__PURE__ */ o.createElement(
      N,
      {
        type: "button",
        className: "k-select",
        fillMode: "flat",
        title: q(this).toLanguageString(Ht, T[Ht]),
        onMouseDown: this.handleReverseMouseDown,
        onClick: this.handleReverseClick,
        "aria-controls": e + " " + i,
        "aria-label": q(this).toLanguageString(Ht, T[Ht])
      },
      /* @__PURE__ */ o.createElement(ei, { style: { transform: "rotate(90deg)" }, name: "arrows-swap", icon: hi })
    );
    return /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
      "span",
      {
        ref: (p) => {
          this._element = p;
        },
        className: a,
        style: this.props.style,
        id: this.props.id,
        "aria-labelledby": this.props.ariaLabelledBy,
        "aria-describedby": this.props.ariaDescribedBy,
        tabIndex: this.props.tabIndex,
        onFocus: this.handleFocus,
        onBlur: this.mobileMode ? void 0 : this.handleBlur,
        onKeyDown: this.handleKeyDown,
        dir: this.props.dir
      },
      this.props.startDateInput ? /* @__PURE__ */ o.createElement(this.props.startDateInput, { ...h }) : /* @__PURE__ */ o.createElement(
        kt,
        {
          ...h,
          ref: this._startDateInput,
          ariaRole: "combobox",
          ariaControls: this._popupId,
          readonly: this.mobileMode
        }
      ),
      (this.props.allowReverse || this.props.calendarSettings && this.props.calendarSettings.allowReverse) && this.props.swapButton ? d : c,
      this.props.endDateInput ? /* @__PURE__ */ o.createElement(this.props.endDateInput, { ...u }) : /* @__PURE__ */ o.createElement(
        kt,
        {
          ...u,
          ref: this._endDateInput,
          ariaRole: "combobox",
          ariaControls: this._popupId,
          readonly: this.mobileMode
        }
      ),
      !this.mobileMode && this.renderPopup()
    ), this.mobileMode && this.renderAdaptivePopup());
  }
  focusDateInputElement() {
    if (!document || !this.startDateInput || !this.startDateInput.element || !this.endDateInput || !this.endDateInput.element)
      return;
    const s = ot(document);
    (this.value.start === null || this.value.end !== null) && s !== this.endDateInput.element ? this.startDateInput.element.focus({ preventScroll: !0 }) : s !== this.startDateInput.element && this.endDateInput.element.focus({ preventScroll: !0 });
  }
  nextTick(s) {
    clearTimeout(this.nextTickId), this.nextTickId = window.setTimeout(() => s());
  }
  setShow(s) {
    const { onOpen: t, onClose: e } = this.props;
    this.show !== s && (this.setState({ show: s }), s && t && t.call(void 0, {
      target: this
    }), !s && e && e.call(void 0, {
      target: this
    }));
  }
  calculateMedia(s) {
    for (let t of s)
      this.setState({ windowWidth: t.target.clientWidth });
  }
};
let te = zt;
te.displayName = "DateRangePicker";
te.propTypes = {
  allowReverse: n.bool,
  calendarSettings: n.any,
  className: n.string,
  defaultShow: n.bool,
  defaultValue: n.shape({
    start: rt(n.instanceOf(Date).isRequired),
    end: rt(n.instanceOf(Date).isRequired)
  }),
  disabled: n.bool,
  endDateInputSettings: n.shape(Ct.propTypes),
  focusedDate: n.instanceOf(Date),
  format: n.oneOfType([
    n.string,
    n.shape({
      skeleton: n.string,
      pattern: n.string,
      date: n.oneOf(["short", "medium", "long", "full"]),
      time: n.oneOf(["short", "medium", "long", "full"]),
      datetime: n.oneOf(["short", "medium", "long", "full"]),
      era: n.oneOf(["narrow", "short", "long"]),
      year: n.oneOf(["numeric", "2-digit"]),
      month: n.oneOf(["numeric", "2-digit", "narrow", "short", "long"]),
      day: n.oneOf(["numeric", "2-digit"]),
      weekday: n.oneOf(["narrow", "short", "long"]),
      hour: n.oneOf(["numeric", "2-digit"]),
      hour12: n.bool,
      minute: n.oneOf(["numeric", "2-digit"]),
      second: n.oneOf(["numeric", "2-digit"]),
      timeZoneName: n.oneOf(["short", "long"])
    })
  ]),
  id: n.string,
  ariaLabelledBy: n.string,
  ariaDescribedBy: n.string,
  max: n.instanceOf(Date),
  min: n.instanceOf(Date),
  onBlur: n.func,
  onChange: n.func,
  onFocus: n.func,
  popupSettings: n.any,
  show: n.bool,
  startDateInputSettings: n.any,
  style: n.any,
  swapButton: n.any,
  tabIndex: n.number,
  dir: n.string,
  value: n.shape({
    start: rt(n.instanceOf(Date).isRequired),
    end: rt(n.instanceOf(Date).isRequired)
  })
};
te.defaultProps = {
  allowReverse: !1,
  defaultShow: !1,
  defaultValue: z,
  disabled: !1,
  format: "d",
  max: dt,
  min: ut,
  swapButton: !1
};
const la = Dt(), ha = yt(St(la, te));
ha.displayName = "KendoReactDateRangePicker";
at(te);
class ms extends o.Component {
  constructor(t) {
    super(t), this._calendar = null, this._timePart = null, this._cancelButton = null, this._acceptButton = null, this._calendarWrap = null, this.shouldFocusPart = !1, this.focus = (e) => {
      Promise.resolve().then(() => {
        this.state.tab === "time" && this._timePart && this._timePart.focus(e);
        const i = this.calendarElement();
        this.state.tab === "date" && i && i.focus(e);
      });
    }, this.calendarElement = () => this._calendar && this._calendar.element || this._calendarWrap && this._calendarWrap.querySelector(".k-widget.k-calendar"), this.move = (e) => {
      if (e === "right" && this.state.tab === "time" || e === "left" && this.state.tab === "date")
        return;
      const i = e === "left" ? "date" : "time";
      this.shouldFocusPart = !0, this.setState({ tab: i });
    }, this.dateTimeFooter = () => {
      const { cancelButton: e } = this.props, i = this.localizationService.toLanguageString($t, T[$t]), a = this.localizationService.toLanguageString(Yt, T[Yt]);
      return /* @__PURE__ */ o.createElement("div", { className: "k-datetime-footer k-actions k-actions-stretched " }, e && /* @__PURE__ */ o.createElement(
        N,
        {
          type: "button",
          ref: (r) => {
            this._cancelButton = r;
          },
          className: "k-time-cancel",
          onClick: this.handleReject,
          title: i,
          "aria-label": i
        },
        i
      ), /* @__PURE__ */ o.createElement(
        N,
        {
          type: "button",
          themeColor: "primary",
          ref: (r) => {
            this._acceptButton = r;
          },
          className: "k-time-accept",
          disabled: !this.hasDateValue,
          onClick: this.handleAccept,
          title: a,
          "aria-label": a
        },
        a
      ));
    }, this.handleReject = (e) => {
      this.setState({ dateValue: this.props.value, timeValue: this.props.value || L });
      const i = this.mergeDate(this.props.value, this.props.value || L);
      if (this.props.onReject) {
        const a = {
          nativeEvent: e.nativeEvent,
          syntheticEvent: e,
          target: this,
          value: i
        };
        this.props.onReject.call(void 0, a);
      }
    }, this.handleAccept = (e, i) => {
      if (!this.state.dateValue || !this.state.timeValue || !this.hasDateValue)
        return;
      const a = this.mergeDate(this.state.dateValue, i || this.state.timeValue);
      this.props.onChange.call(void 0, {
        syntheticEvent: e,
        nativeEvent: e.nativeEvent,
        value: a,
        target: this
      });
    }, this.handleNowClick = (e) => {
      this.setState({ timeValue: Vt() }), this.handleAccept(e, Vt());
    }, this.handleCalendarValueChange = (e) => {
      e.syntheticEvent.stopPropagation(), this.setState({ dateValue: e.value, tab: "time" }), this.shouldFocusPart = !0;
    }, this.handleTimeListContainerChange = (e) => {
      this.setState({ timeValue: e });
    }, this.handleDateClick = (e) => {
      e.stopPropagation(), this.move("left");
    }, this.handleTimeClick = (e) => {
      e.stopPropagation(), this.move("right");
    }, this.handleKeyDown = (e) => {
      const { keyCode: i, altKey: a } = e;
      switch (i) {
        case C.enter:
          !this.hasActiveButton() && this.hasDateValue && this.handleAccept(e);
          return;
        case C.left:
          if (!a)
            return;
          this.move("left");
          return;
        case C.right:
          if (!a)
            return;
          this.move("right");
          return;
        default:
          return;
      }
    }, this.handleTimePartMount = (e) => {
      this.setState({ timeValue: e });
    }, this.state = {
      tab: "date",
      dateValue: this.props.value,
      timeValue: this.props.value || L
    };
  }
  get calendar() {
    return this._calendar;
  }
  get timePart() {
    return this._timePart;
  }
  get hasDateValue() {
    return this.state.dateValue !== null;
  }
  get localizationService() {
    return q(this);
  }
  componentDidUpdate() {
    this.shouldFocusPart && this.focus({ preventScroll: !0 }), this.shouldFocusPart = !1;
  }
  render() {
    const {
      disabled: t,
      min: e,
      max: i,
      weekNumber: a,
      focusedDate: r,
      format: l,
      mobileMode: c,
      footerActions: h
    } = this.props, u = P(
      {
        "k-date-tab": this.state.tab === "date",
        "k-time-tab": this.state.tab === "time",
        "k-disabled": t
      },
      "k-datetime-wrap"
    ), d = this.localizationService.toLanguageString(Ge, T[Ge]), p = this.localizationService.toLanguageString(Xe, T[Xe]), m = {
      min: e,
      max: i,
      weekNumber: a,
      focusedDate: r,
      disabled: t || this.state.tab !== "date",
      value: this.state.dateValue,
      onChange: this.handleCalendarValueChange,
      navigation: !1,
      mobileMode: c
    };
    return /* @__PURE__ */ o.createElement(
      "div",
      {
        onKeyDown: this.handleKeyDown,
        className: u,
        tabIndex: -1
      },
      /* @__PURE__ */ o.createElement("div", { className: "k-datetime-buttongroup" }, /* @__PURE__ */ o.createElement(ni, { width: "100%" }, /* @__PURE__ */ o.createElement(
        N,
        {
          type: "button",
          selected: this.state.tab === "date",
          togglable: !0,
          onClick: this.handleDateClick
        },
        d
      ), /* @__PURE__ */ o.createElement(
        N,
        {
          type: "button",
          selected: this.state.tab === "time",
          togglable: !0,
          onClick: this.handleTimeClick
        },
        p
      ))),
      /* @__PURE__ */ o.createElement("div", { className: "k-datetime-selector" }, /* @__PURE__ */ o.createElement("div", { className: "k-datetime-calendar-wrap", ref: (f) => this._calendarWrap = f }, this.props.calendar ? /* @__PURE__ */ o.createElement(this.props.calendar, { ...m }) : /* @__PURE__ */ o.createElement(
        as,
        {
          ref: (f) => {
            this._calendar = f;
          },
          ...m
        }
      )), /* @__PURE__ */ o.createElement("div", { className: "k-datetime-time-wrap" }, /* @__PURE__ */ o.createElement("div", { className: c ? "k-reset k-timeselector-lg k-timeselector" : "" }, /* @__PURE__ */ o.createElement(
        _t,
        {
          key: 1,
          onNowClick: this.handleNowClick,
          disabled: t || this.state.tab !== "time",
          ref: (f) => {
            this._timePart = f;
          },
          min: this.minTime || Nt,
          max: this.maxTime || xt,
          steps: this.props.steps,
          value: this.state.timeValue,
          format: l,
          onChange: this.handleTimeListContainerChange,
          onMount: this.handleTimePartMount,
          mobileMode: c
        }
      )))),
      h && this.dateTimeFooter()
    );
  }
  get minTime() {
    return this.props.minTime !== void 0 ? this.props.minTime : this.normalizeRange(this.props.min, this.state.dateValue);
  }
  get maxTime() {
    return this.props.maxTime !== void 0 ? this.props.maxTime : this.normalizeRange(this.props.max, this.state.dateValue);
  }
  normalizeRange(t, e) {
    return wt(t, e || U()) ? t : null;
  }
  hasActiveButton() {
    if (!this._acceptButton)
      return !1;
    const t = ot(document);
    return this._acceptButton && t === this._acceptButton.element || this._cancelButton && t === this._cancelButton.element;
  }
  mergeTime(t, e) {
    return t && e ? W(e, t) : e;
  }
  mergeDate(t, e) {
    return t ? W(t || U(), e) : e;
  }
}
ms.defaultProps = {
  footerActions: !0
};
at(ms);
const et = class extends o.Component {
  constructor(s) {
    super(s), this._element = null, this._dateInput = o.createRef(), this._dateTimeSelector = null, this.shouldFocusDateInput = !1, this.prevShow = !1, this.focus = () => {
      const t = this.dateInputElement();
      t && t.focus();
    }, this.renderPicker = () => {
      const {
        disabled: t,
        minTime: e,
        maxTime: i,
        format: a,
        calendar: r,
        cancelButton: l,
        weekNumber: c,
        focusedDate: h
      } = this.props;
      return /* @__PURE__ */ o.createElement(
        ms,
        {
          ref: (u) => {
            this._dateTimeSelector = u;
          },
          cancelButton: l,
          steps: this.props.steps,
          value: this.value,
          onChange: this.handleValueChange,
          onReject: this.handleReject,
          disabled: t,
          weekNumber: c,
          min: this.min,
          max: this.max,
          minTime: e,
          maxTime: i,
          focusedDate: h,
          format: a,
          calendar: r,
          mobileMode: this.mobileMode,
          footerActions: !this.mobileMode
        }
      );
    }, this.renderAdaptivePopup = () => {
      const { windowWidth: t = 0 } = this.state, e = q(this).toLanguageString($t, T[$t]), i = q(this).toLanguageString(Yt, T[Yt]), a = {
        expand: this.show,
        onClose: this.handleBlur,
        adaptiveTitle: this.props.adaptiveTitle,
        windowWidth: t,
        footer: {
          cancelText: e,
          onCancel: (r) => {
            var l;
            return (l = this._dateTimeSelector) == null ? void 0 : l.handleReject(r);
          },
          applyText: i,
          onApply: (r) => {
            var l;
            return (l = this._dateTimeSelector) == null ? void 0 : l.handleAccept(r);
          }
        }
      };
      return /* @__PURE__ */ o.createElement(Se, { ...a }, /* @__PURE__ */ o.createElement(ke, { className: "!k-overflow-hidden" }, this.renderPicker()));
    }, this.handleReject = () => {
      this.shouldFocusDateInput = !0, this.setShow(!1);
    }, this.handleValueChange = (t) => {
      this.setState({
        value: v(t.value || void 0)
      }), this.valueDuringOnChange = t.value, this.showDuringOnChange = !1, this.mobileMode || (this.shouldFocusDateInput = !0);
      const { onChange: e } = this.props;
      e && e.call(void 0, {
        syntheticEvent: t.syntheticEvent,
        nativeEvent: t.nativeEvent,
        value: this.value,
        show: this.show,
        target: this
      }), this.valueDuringOnChange = void 0, this.showDuringOnChange = void 0, this.setShow(!1);
    }, this.handleFocus = () => {
      this.setState({ focused: !0 });
    }, this.handleBlur = () => {
      this.setState({ focused: !1 }), this.setShow(!1);
    }, this.handleDateIconClick = () => {
      this.props.disabled || (this.shouldFocusDateInput = !0, this.setShow(!this.show));
    }, this.handleIconMouseDown = (t) => {
      t.preventDefault();
    }, this.handleKeyDown = (t) => {
      const { altKey: e, keyCode: i } = t;
      if (i === C.esc) {
        this.shouldFocusDateInput = !0, this.setShow(!1);
        return;
      }
      e && (i === C.up || i === C.down) && (t.preventDefault(), t.stopPropagation(), this.shouldFocusDateInput = i === C.up, this.setShow(i === C.down));
    }, this.dateInputElement = () => this.dateInput && this.dateInput.element || this.element && this.element.querySelector(".k-dateinput > input.k-input-inner"), Pt(Rt), this.state = {
      value: this.props.defaultValue || et.defaultProps.defaultValue,
      show: this.props.defaultShow || et.defaultProps.defaultShow,
      focused: !1
    };
  }
  get _popupId() {
    return this.props.id + "-popup-id";
  }
  get document() {
    if (J)
      return this.element && this.element.ownerDocument || document;
  }
  /**
   * Gets the wrapping element of the DateTimePicker.
   */
  get element() {
    return this._element;
  }
  /**
   * Gets the DateInput component inside the DateTimePicker component.
   */
  get dateInput() {
    return this._dateInput.current;
  }
  /**
   * Gets the value of the DateTimePicker.
   */
  get value() {
    const s = this.valueDuringOnChange !== void 0 ? this.valueDuringOnChange : this.props.value !== void 0 ? this.props.value : this.state.value;
    return s !== null ? v(s) : null;
  }
  /**
   * Gets the popup state of the DateTimePicker.
   */
  get show() {
    return this.showDuringOnChange !== void 0 ? this.showDuringOnChange : this.props.show !== void 0 ? this.props.show : this.state.show;
  }
  /**
   * Gets the `name` property of the DateTimePicker.
   */
  get name() {
    return this.props.name;
  }
  /**
   * The mobile mode of the ComboBox.
   */
  get mobileMode() {
    return !!(this.state.windowWidth && this.state.windowWidth <= xe && this.props.adaptive);
  }
  get min() {
    return this.props.min !== void 0 ? this.props.min : et.defaultProps.min;
  }
  get max() {
    return this.props.max !== void 0 ? this.props.max : et.defaultProps.max;
  }
  /**
   * Represents the validity state into which the DateTimePicker is set.
   */
  get validity() {
    const s = Hs(this.value, this.min, this.max) && hs(this.value, this.props.minTime || Nt, this.props.maxTime || xt), t = this.props.validationMessage !== void 0, e = (!this.required || this.value !== null) && s, i = this.props.valid !== void 0 ? this.props.valid : e;
    return {
      customError: t,
      rangeOverflow: this.value && this.max.getTime() < this.value.getTime() || !1,
      rangeUnderflow: this.value && this.value.getTime() < this.min.getTime() || !1,
      valid: i,
      valueMissing: this.value === null
    };
  }
  /**
   * @hidden
   */
  get validityStyles() {
    return this.props.validityStyles !== void 0 ? this.props.validityStyles : et.defaultProps.validityStyles;
  }
  /**
   * @hidden
   */
  get required() {
    return this.props.required !== void 0 ? this.props.required : et.defaultProps.required;
  }
  /**
   * @hidden
   */
  get dateInputComp() {
    return this.props.dateInput || et.defaultProps.dateInput;
  }
  /**
   * @hidden
   */
  componentDidMount() {
    var s;
    this.observerResize = J && window.ResizeObserver && new window.ResizeObserver(this.calculateMedia.bind(this)), this.show && this.forceUpdate(), (s = this.document) != null && s.body && this.observerResize && this.observerResize.observe(this.document.body);
  }
  /**
   * @hidden
   */
  componentDidUpdate() {
    const s = this.dateInputElement();
    this._dateTimeSelector && this.show && !this.prevShow && this._dateTimeSelector.focus({ preventScroll: !0 }), s && !this.show && this.shouldFocusDateInput && s.focus({ preventScroll: !0 }), this.prevShow = this.show, this.shouldFocusDateInput = !1;
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    var s;
    clearTimeout(this.nextTickId), (s = this.document) != null && s.body && this.observerResize && this.observerResize.disconnect();
  }
  /**
   * @hidden
   */
  render() {
    const {
      size: s = et.defaultProps.size,
      rounded: t = et.defaultProps.rounded,
      fillMode: e = et.defaultProps.fillMode,
      disabled: i,
      tabIndex: a,
      title: r,
      id: l,
      format: c,
      formatPlaceholder: h,
      min: u,
      max: d,
      className: p,
      width: m,
      name: f,
      validationMessage: y,
      required: I,
      validityStyles: M,
      minTime: w,
      maxTime: E,
      ariaLabelledBy: g,
      ariaDescribedBy: H,
      popup: V = be
    } = this.props, R = !this.validityStyles || this.validity.valid, A = {
      id: l,
      ariaLabelledBy: g,
      ariaDescribedBy: H,
      format: c,
      formatPlaceholder: h,
      disabled: i,
      title: r,
      validityStyles: M,
      validationMessage: y,
      required: I,
      min: u,
      max: d,
      minTime: w,
      maxTime: E,
      name: f,
      tabIndex: this.show ? -1 : a,
      valid: this.validity.valid,
      value: this.value,
      onChange: this.handleValueChange,
      steps: this.props.steps,
      label: void 0,
      placeholder: this.state.focused ? null : this.props.placeholder,
      ariaExpanded: this.show,
      size: null,
      fillMode: null,
      rounded: null
    }, S = /* @__PURE__ */ o.createElement(
      we,
      {
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onSyncFocus: this.props.onFocus,
        onSyncBlur: this.props.onBlur
      },
      ({ onFocus: O, onBlur: tt }) => /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
        "div",
        {
          ref: (j) => {
            this._element = j;
          },
          className: P(
            "k-input",
            "k-datetimepicker",
            {
              [`k-input-${mt.sizeMap[s] || s}`]: s,
              [`k-rounded-${mt.roundedMap[t] || t}`]: t,
              [`k-input-${e}`]: e,
              ["k-invalid"]: !R,
              ["k-required"]: this.required,
              ["k-disabled"]: this.props.disabled
            },
            p
          ),
          onKeyDown: this.handleKeyDown,
          style: { width: m },
          onFocus: this.mobileMode ? void 0 : O,
          onBlur: tt,
          onClick: this.mobileMode ? this.handleDateIconClick : void 0
        },
        /* @__PURE__ */ o.createElement(
          this.dateInputComp,
          {
            _ref: this._dateInput,
            ariaRole: "combobox",
            ariaControls: this._popupId,
            readonly: this.mobileMode,
            ...A
          }
        ),
        /* @__PURE__ */ o.createElement(
          N,
          {
            tabIndex: -1,
            type: "button",
            icon: "calendar",
            svgIcon: Fs,
            onMouseDown: this.handleIconMouseDown,
            onClick: this.mobileMode ? void 0 : this.handleDateIconClick,
            title: q(this).toLanguageString(At, T[At]),
            className: "k-input-button",
            rounded: null,
            "aria-label": q(this).toLanguageString(At, T[At])
          }
        ),
        /* @__PURE__ */ o.createElement(
          V,
          {
            show: this.show,
            animate: this.element !== null,
            anchor: this.element,
            popupClass: "k-datetime-container k-reset",
            id: this._popupId,
            anchorAlign: {
              horizontal: "left",
              vertical: "bottom"
            },
            popupAlign: {
              horizontal: "left",
              vertical: "top"
            }
          },
          !this.mobileMode && this.renderPicker()
        )
      ), this.mobileMode && this.renderAdaptivePopup())
    );
    return this.props.label ? /* @__PURE__ */ o.createElement(
      cs,
      {
        dateInput: this._dateInput,
        label: this.props.label,
        editorId: l,
        editorValid: R,
        editorDisabled: this.props.disabled,
        children: S,
        style: { width: this.props.width }
      }
    ) : S;
  }
  setShow(s) {
    const { onOpen: t, onClose: e } = this.props;
    this.show !== s && (this.setState({ show: s }), s && t && t.call(void 0, {
      target: this
    }), !s && e && e.call(void 0, {
      target: this
    }));
  }
  nextTick(s) {
    clearTimeout(this.nextTickId), this.nextTickId = window.setTimeout(() => s());
  }
  calculateMedia(s) {
    for (let t of s)
      this.setState({ windowWidth: t.target.clientWidth });
  }
};
let ee = et;
ee.displayName = "DateTimePicker";
ee.propTypes = {
  className: n.string,
  defaultShow: n.bool,
  defaultValue: n.instanceOf(Date),
  disabled: n.bool,
  focusedDate: n.instanceOf(Date),
  format: n.oneOfType([
    n.string,
    n.shape({
      skeleton: n.string,
      pattern: n.string,
      date: n.oneOf(["short", "medium", "long", "full"]),
      time: n.oneOf(["short", "medium", "long", "full"]),
      datetime: n.oneOf(["short", "medium", "long", "full"]),
      era: n.oneOf(["narrow", "short", "long"]),
      year: n.oneOf(["numeric", "2-digit"]),
      month: n.oneOf(["numeric", "2-digit", "narrow", "short", "long"]),
      day: n.oneOf(["numeric", "2-digit"]),
      weekday: n.oneOf(["narrow", "short", "long"]),
      hour: n.oneOf(["numeric", "2-digit"]),
      hour12: n.bool,
      minute: n.oneOf(["numeric", "2-digit"]),
      second: n.oneOf(["numeric", "2-digit"]),
      timeZoneName: n.oneOf(["short", "long"])
    })
  ]),
  formatPlaceholder: n.oneOfType([
    n.oneOf(["wide", "narrow", "short", "formatPattern"]),
    n.shape({
      year: n.string,
      month: n.string,
      day: n.string,
      hour: n.string,
      minute: n.string,
      second: n.string
    })
  ]),
  id: n.string,
  ariaLabelledBy: n.string,
  ariaDescribedBy: n.string,
  min: n.instanceOf(Date),
  max: n.instanceOf(Date),
  name: n.string,
  popupSettings: n.shape({
    animate: n.bool,
    appendTo: n.any,
    popupClass: n.string
  }),
  show: n.bool,
  tabIndex: n.number,
  title: n.string,
  value: n.instanceOf(Date),
  weekNumber: n.bool,
  width: n.oneOfType([n.number, n.string]),
  validationMessage: n.string,
  required: n.bool,
  validate: n.bool,
  valid: n.bool,
  cancelButton: n.bool,
  size: n.oneOf([null, "small", "medium", "large"]),
  rounded: n.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: n.oneOf([null, "solid", "flat", "outline"])
};
ee.defaultProps = {
  defaultShow: !1,
  defaultValue: null,
  disabled: !1,
  format: "g",
  // general date and time pattern (short time): "M/d/y h:mm a" for en.
  max: dt,
  min: ut,
  popupSettings: {},
  tabIndex: 0,
  weekNumber: !1,
  required: !1,
  validityStyles: !0,
  cancelButton: !0,
  dateInput: kt,
  size: "medium",
  rounded: "medium",
  fillMode: "solid"
};
const ca = Dt(), ua = yt(St(ca, ee));
ua.displayName = "KendoReactDateTimePicker";
at(ee);
export {
  b as Action,
  zs as BusViewService,
  as as Calendar,
  Si as CalendarCell,
  tn as CalendarHeaderTitle,
  sn as CalendarNavigationItem,
  an as CalendarPropsContext,
  D as CalendarViewEnum,
  xi as CalendarWeekCell,
  bt as CalendarWithoutContext,
  Ei as CenturyViewService,
  ji as DOMService,
  kt as DateInput,
  Tn as DateInputPropsContext,
  Ct as DateInputWithoutContext,
  Rn as DatePicker,
  Pn as DatePickerPropsContext,
  Xt as DatePickerWithoutContext,
  ha as DateRangePicker,
  la as DateRangePickerPropsContext,
  te as DateRangePickerWithoutContext,
  ua as DateTimePicker,
  ca as DateTimePickerPropsContext,
  ee as DateTimePickerWithoutContext,
  Ln as DayPeriodService,
  Ri as DecadeViewService,
  z as EMPTY_SELECTIONRANGE,
  Zt as Header,
  Bt as HorizontalViewList,
  Wn as HoursService,
  dt as MAX_DATE,
  xt as MAX_TIME,
  ut as MIN_DATE,
  Nt as MIN_TIME,
  jn as MinutesService,
  Ai as MonthViewService,
  Qs as MultiViewCalendar,
  oa as MultiViewCalendarPropsContext,
  lt as MultiViewCalendarWithoutContext,
  qs as NavigationService,
  Vn as PickerWrap,
  Ji as ScrollSyncService,
  Qn as SecondsService,
  Ce as TimeList,
  _t as TimePart,
  aa as TimePicker,
  na as TimePickerPropsContext,
  Qt as TimePickerWithoutContext,
  Jt as TimeSelector,
  Gt as TodayCommand,
  En as ToggleButton,
  ye as ViewList,
  Kt as Virtualization,
  Qi as WeekNamesService,
  $i as YearViewService,
  T as dateInputsMessages,
  Lt as decreaseValue,
  $e as end,
  Vt as getNow,
  U as getToday,
  Ft as increaseValue,
  Ye as separator,
  Ue as start,
  Ht as swapStartEnd,
  qe as today,
  We as toggleCalendar,
  At as toggleDateTimeSelector
};
